
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $fO90s.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8coUR({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8coUR({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8coUR({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8coUR({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8coUR({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8coUR({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8coUR({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8coUR({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8coUR({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8coUR({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8coUR({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8coUR({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $fO90s.unstable_runWithPriority, Of = $fO90s.unstable_scheduleCallback, Pf = $fO90s.unstable_cancelCallback, Qf = $fO90s.unstable_shouldYield, Rf = $fO90s.unstable_requestPaint, Sf = $fO90s.unstable_now, Tf = $fO90s.unstable_getCurrentPriorityLevel, Uf = $fO90s.unstable_ImmediatePriority, Vf = $fO90s.unstable_UserBlockingPriority, Wf = $fO90s.unstable_NormalPriority, Xf = $fO90s.unstable_LowPriority, Yf = $fO90s.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $acw62.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRegister("f736Y", function(module, exports) {
"use strict";
function $b009ec5c27feb43c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b009ec5c27feb43c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b009ec5c27feb43c$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b009ec5c27feb43c$var$LoginForm;

var $b009ec5c27feb43c$var$_react = $b009ec5c27feb43c$var$_interopRequireWildcard((parcelRequire("acw62")));

var $b009ec5c27feb43c$var$alertStyles = $b009ec5c27feb43c$var$_interopRequireWildcard((parcelRequire("jbsrN")));

var $b009ec5c27feb43c$var$styles = $b009ec5c27feb43c$var$_interopRequireWildcard((parcelRequire("kMVI2")));

var $b009ec5c27feb43c$var$_CredentialsForm = $b009ec5c27feb43c$var$_interopRequireDefault((parcelRequire("JjFQA")));

var $b009ec5c27feb43c$var$_MfaForm = $b009ec5c27feb43c$var$_interopRequireDefault((parcelRequire("gwdxu")));

var $b009ec5c27feb43c$var$_NewPasswordForm = $b009ec5c27feb43c$var$_interopRequireDefault((parcelRequire("a0NPf")));

var $4fGPb = parcelRequire("4fGPb");

var $b009ec5c27feb43c$var$_CustomLogin = $b009ec5c27feb43c$var$_interopRequireDefault((parcelRequire("f2HJd")));

var $g3rxA = parcelRequire("g3rxA");

var $dwN01 = parcelRequire("dwN01");

var $1XggU = parcelRequire("1XggU");

var $b009ec5c27feb43c$var$_Flash = $b009ec5c27feb43c$var$_interopRequireDefault((parcelRequire("2gSw0")));

var $b009ec5c27feb43c$var$_Logger = $b009ec5c27feb43c$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $b009ec5c27feb43c$var$_reactTopLoadingBar = $b009ec5c27feb43c$var$_interopRequireDefault((parcelRequire("1KSzM")));

var $b009ec5c27feb43c$var$_AlertTypes = $b009ec5c27feb43c$var$_interopRequireDefault((parcelRequire("5LA7J")));
function $b009ec5c27feb43c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b009ec5c27feb43c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b009ec5c27feb43c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b009ec5c27feb43c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $b009ec5c27feb43c$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $b009ec5c27feb43c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $b009ec5c27feb43c$var$_slicedToArray(r, e) {
    return $b009ec5c27feb43c$var$_arrayWithHoles(r) || $b009ec5c27feb43c$var$_iterableToArrayLimit(r, e) || $b009ec5c27feb43c$var$_unsupportedIterableToArray(r, e) || $b009ec5c27feb43c$var$_nonIterableRest();
}
function $b009ec5c27feb43c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b009ec5c27feb43c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b009ec5c27feb43c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b009ec5c27feb43c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b009ec5c27feb43c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b009ec5c27feb43c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b009ec5c27feb43c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

if (null) null.accept("../SharedCss/alert.css", function() {
    (parcelRequire("jbsrN"));
});

(parcelRequire("8vghX")).config();
function $b009ec5c27feb43c$var$LoginForm(props) {
    var advisorId = (0, $1XggU.getAdvisorCustomLogin)();
    var CognitoIdentityLib = props.CognitoIdentityLib;
    var initialAlertType = '';
    var flashMessage = $b009ec5c27feb43c$var$_Flash["default"].getMessage();
    if (flashMessage !== null) initialAlertType = $b009ec5c27feb43c$var$_AlertTypes["default"].FLASH;
    var _useState = (0, $b009ec5c27feb43c$var$_react.useState)(''), _useState2 = $b009ec5c27feb43c$var$_slicedToArray(_useState, 2), confirmationEmail = _useState2[0], setConfirmationEmail = _useState2[1];
    var _useState3 = (0, $b009ec5c27feb43c$var$_react.useState)(initialAlertType), _useState4 = $b009ec5c27feb43c$var$_slicedToArray(_useState3, 2), alertType = _useState4[0], setAlertType = _useState4[1];
    var _useState5 = (0, $b009ec5c27feb43c$var$_react.useState)(false), _useState6 = $b009ec5c27feb43c$var$_slicedToArray(_useState5, 2), showMfaForm = _useState6[0], setShowMfaForm = _useState6[1];
    var _useState7 = (0, $b009ec5c27feb43c$var$_react.useState)(false), _useState8 = $b009ec5c27feb43c$var$_slicedToArray(_useState7, 2), showNewPasswordForm = _useState8[0], setShowNewPasswordForm = _useState8[1];
    var _useState9 = (0, $b009ec5c27feb43c$var$_react.useState)(null), _useState10 = $b009ec5c27feb43c$var$_slicedToArray(_useState9, 2), sessionUserAttributes = _useState10[0], setSessionUserAttributes = _useState10[1];
    var _useState11 = (0, $b009ec5c27feb43c$var$_react.useState)(''), _useState12 = $b009ec5c27feb43c$var$_slicedToArray(_useState11, 2), destination = _useState12[0], setDestination = _useState12[1];
    var _useState13 = (0, $b009ec5c27feb43c$var$_react.useState)(''), _useState14 = $b009ec5c27feb43c$var$_slicedToArray(_useState13, 2), session = _useState14[0], setSession = _useState14[1];
    var loadingRef = (0, $b009ec5c27feb43c$var$_react.useRef)(null);
    var params = new URLSearchParams(window.location.search);
    var returnToUrl = params.get('return_to');
    var userPool = new CognitoIdentityLib.CognitoUserPool({
        UserPoolId: "us-east-1_dghkmntO0",
        ClientId: "745dij271n5sgodrapt1ofef22"
    });
    var authenticate = function authenticate(email, password) {
        $b009ec5c27feb43c$var$_Logger["default"].start('Authenticate', {
            email: email
        });
        setAlertType('');
        loadingRef.current.continuousStart();
        // From this documentation
        // https://docs.aws.amazon.com/cognito/latest/developerguide/authentication.html
        var authenticationData = {
            Username: email,
            Password: password
        };
        var authenticationDetails = new CognitoIdentityLib.AuthenticationDetails(authenticationData);
        var userData = {
            Username: email,
            Pool: userPool
        };
        var cognitoUser = new CognitoIdentityLib.CognitoUser(userData);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function onSuccess(cognitoTokens) {
                $b009ec5c27feb43c$var$_Logger["default"].done('Authenticate', {
                    email: email
                });
                (0, $dwN01.signIn)(cognitoTokens);
                if (returnToUrl) (0, $g3rxA.signInExternalHostWithCustomRedirect)(returnToUrl);
                else (0, $g3rxA.signInExternalHost)().then();
            },
            onFailure: function onFailure(err) {
                loadingRef.current.complete();
                $b009ec5c27feb43c$var$_Logger["default"].error('Authenticate', err);
                if (err.name === 'NotAuthorizedException') setAlertType($b009ec5c27feb43c$var$_AlertTypes["default"].INVALID_CREDENTIALS);
                else if (err.name === 'UserNotConfirmedException') {
                    // email will change so we need to store this in another state
                    setConfirmationEmail(email);
                    setAlertType($b009ec5c27feb43c$var$_AlertTypes["default"].USER_NOT_CONFIRMED);
                }
            },
            mfaRequired: function mfaRequired(codeDeliveryDetails, params) {
                $b009ec5c27feb43c$var$_Logger["default"].info('Authenticate, Mfa required', {
                    email: email
                });
                setSession(cognitoUser);
                setDestination(params.CODE_DELIVERY_DESTINATION);
                setShowMfaForm(true);
            },
            newPasswordRequired: function newPasswordRequired(userAttributes, requiredAttributes) {
                $b009ec5c27feb43c$var$_Logger["default"].info('Authenticate, New Password required', {
                    email: email
                });
                userAttributes.nickname = userAttributes.email;
                delete userAttributes.email_verified;
                setSession(cognitoUser);
                setSessionUserAttributes(userAttributes);
                setShowNewPasswordForm(true);
            }
        });
        return false;
    };
    var renderAlert = function renderAlert() {
        if (alertType === $b009ec5c27feb43c$var$_AlertTypes["default"].INVALID_CREDENTIALS) return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement("div", {
            className: [
                $b009ec5c27feb43c$var$alertStyles.alert,
                $b009ec5c27feb43c$var$alertStyles.error
            ].join(' ')
        }, "The email address / password combination you entered was not found. If the problem persists you may reset your password \xA0", /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement($4fGPb.Link, {
            className: $b009ec5c27feb43c$var$styles.forgot_password_link,
            to: "/forgot_password",
            style: {
                color: 'black',
                textDecoration: 'underline'
            }
        }, "here"), ".");
        else if (alertType === $b009ec5c27feb43c$var$_AlertTypes["default"].FLASH && flashMessage !== null) {
            var markup = {
                __html: flashMessage
            };
            return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement("div", {
                className: [
                    $b009ec5c27feb43c$var$alertStyles.alert,
                    $b009ec5c27feb43c$var$alertStyles.success
                ].join(' '),
                dangerouslySetInnerHTML: markup
            });
        } else if (alertType === $b009ec5c27feb43c$var$_AlertTypes["default"].LOGIN_SUCCESSFULLY) return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement("div", {
            className: [
                $b009ec5c27feb43c$var$alertStyles.alert,
                $b009ec5c27feb43c$var$alertStyles.success
            ].join(' ')
        }, "Login successfully. Redirecting to main application....");
        else if (alertType === $b009ec5c27feb43c$var$_AlertTypes["default"].RESENT_CONFIRMATION_LIMIT_EXCEEDED) return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement("div", {
            className: [
                $b009ec5c27feb43c$var$alertStyles.alert,
                $b009ec5c27feb43c$var$alertStyles.error
            ].join(' ')
        }, "Attempt limit exceeded, please try after some time.");
        else if (alertType === $b009ec5c27feb43c$var$_AlertTypes["default"].RESENT_CONFIRMATION) return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement("div", {
            className: [
                $b009ec5c27feb43c$var$alertStyles.alert,
                $b009ec5c27feb43c$var$alertStyles.success
            ].join(' ')
        }, "Email sent!! Please check your email to confirm.");
        else if (alertType === $b009ec5c27feb43c$var$_AlertTypes["default"].USER_NOT_CONFIRMED) return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement("div", {
            className: [
                $b009ec5c27feb43c$var$alertStyles.alert,
                $b009ec5c27feb43c$var$alertStyles.error
            ].join(' ')
        }, "Please confirm your email address to sign into Blueleaf. \xA0", /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement("a", {
            id: "resend-confirmation-btn",
            onClick: handleResendConfirmation,
            className: $b009ec5c27feb43c$var$styles.resend_confirmation_link
        }, "Resend confirmation"));
    };
    // *********
    // CALLBACKS
    // *********
    var handleResendConfirmation = function handleResendConfirmation(e) {
        e.preventDefault();
        var userData = {
            Username: confirmationEmail,
            Pool: userPool
        };
        var cognitoUser = new CognitoIdentityLib.CognitoUser(userData);
        cognitoUser.resendConfirmationCode(function(err, result) {
            if (err) setAlertType($b009ec5c27feb43c$var$_AlertTypes["default"].RESENT_CONFIRMATION_LIMIT_EXCEEDED);
            else setAlertType($b009ec5c27feb43c$var$_AlertTypes["default"].RESENT_CONFIRMATION);
        });
    };
    // *********
    // RENDER
    // *********
    if (showMfaForm) return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement($b009ec5c27feb43c$var$_MfaForm["default"], {
        cognitoUser: session,
        destination: destination
    });
    else if (showNewPasswordForm) return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement($b009ec5c27feb43c$var$_NewPasswordForm["default"], {
        cognitoUser: session,
        sessionUserAttributes: sessionUserAttributes
    });
    else if (advisorId) return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement("div", null, renderAlert(), /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement($b009ec5c27feb43c$var$_reactTopLoadingBar["default"], {
        color: "#f11946",
        ref: loadingRef
    }), /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement($b009ec5c27feb43c$var$_CustomLogin["default"], {
        advisorId: advisorId,
        authenticate: authenticate
    }));
    else return /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement("div", {
        className: $b009ec5c27feb43c$var$styles.container
    }, renderAlert(), /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement($b009ec5c27feb43c$var$_reactTopLoadingBar["default"], {
        color: "#f11946",
        ref: loadingRef
    }), /*#__PURE__*/ $b009ec5c27feb43c$var$_react["default"].createElement($b009ec5c27feb43c$var$_CredentialsForm["default"], {
        authenticate: authenticate
    }));
}

});
parcelRegister("jbsrN", function(module, exports) {

$parcel$export(module.exports, "alert", () => $df751c7304f0f73a$export$5ea928c9faf85bd3, (v) => $df751c7304f0f73a$export$5ea928c9faf85bd3 = v);
$parcel$export(module.exports, "render-with-menu", () => $df751c7304f0f73a$export$47f24f7e8f4f40b8, (v) => $df751c7304f0f73a$export$47f24f7e8f4f40b8 = v);
$parcel$export(module.exports, "error", () => $df751c7304f0f73a$export$a3bc9b8ed74fc, (v) => $df751c7304f0f73a$export$a3bc9b8ed74fc = v);
$parcel$export(module.exports, "success", () => $df751c7304f0f73a$export$fe7c49d056ea1d88, (v) => $df751c7304f0f73a$export$fe7c49d056ea1d88 = v);
var $df751c7304f0f73a$export$5ea928c9faf85bd3;
var $df751c7304f0f73a$export$47f24f7e8f4f40b8;
var $df751c7304f0f73a$export$a3bc9b8ed74fc;
var $df751c7304f0f73a$export$fe7c49d056ea1d88;
"use strict";
$df751c7304f0f73a$export$5ea928c9faf85bd3 = "js-SharedCss-__alert__alert__OgMSM";
$df751c7304f0f73a$export$47f24f7e8f4f40b8 = "js-SharedCss-__alert__render-with-menu__aJNR-";
$df751c7304f0f73a$export$a3bc9b8ed74fc = "js-SharedCss-__alert__error__vbKGB";
$df751c7304f0f73a$export$fe7c49d056ea1d88 = "js-SharedCss-__alert__success__gD8zV";

});

parcelRegister("kMVI2", function(module, exports) {

$parcel$export(module.exports, "container", () => $f2250e33cdd6f35d$export$34e0f9847d4c02dd, (v) => $f2250e33cdd6f35d$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "header", () => $f2250e33cdd6f35d$export$38e42c68cf43b5d4, (v) => $f2250e33cdd6f35d$export$38e42c68cf43b5d4 = v);
$parcel$export(module.exports, "logo", () => $f2250e33cdd6f35d$export$db3c28d99448dcff, (v) => $f2250e33cdd6f35d$export$db3c28d99448dcff = v);
$parcel$export(module.exports, "header_text", () => $f2250e33cdd6f35d$export$6e87302b124dfd8f, (v) => $f2250e33cdd6f35d$export$6e87302b124dfd8f = v);
$parcel$export(module.exports, "form_container", () => $f2250e33cdd6f35d$export$4be61d40313a3d60, (v) => $f2250e33cdd6f35d$export$4be61d40313a3d60 = v);
$parcel$export(module.exports, "label", () => $f2250e33cdd6f35d$export$1237798dc640739a, (v) => $f2250e33cdd6f35d$export$1237798dc640739a = v);
$parcel$export(module.exports, "input_field", () => $f2250e33cdd6f35d$export$1e077af29af3389c, (v) => $f2250e33cdd6f35d$export$1e077af29af3389c = v);
$parcel$export(module.exports, "fieldset", () => $f2250e33cdd6f35d$export$a38812d1aa1302d9, (v) => $f2250e33cdd6f35d$export$a38812d1aa1302d9 = v);
$parcel$export(module.exports, "submit_btn", () => $f2250e33cdd6f35d$export$6eae7689ca139ede, (v) => $f2250e33cdd6f35d$export$6eae7689ca139ede = v);
$parcel$export(module.exports, "link", () => $f2250e33cdd6f35d$export$9c30223ca0a664fb, (v) => $f2250e33cdd6f35d$export$9c30223ca0a664fb = v);
$parcel$export(module.exports, "form_description", () => $f2250e33cdd6f35d$export$6a64d2fc98121048, (v) => $f2250e33cdd6f35d$export$6a64d2fc98121048 = v);
$parcel$export(module.exports, "checkbox", () => $f2250e33cdd6f35d$export$b07e517d22efa1ca, (v) => $f2250e33cdd6f35d$export$b07e517d22efa1ca = v);
$parcel$export(module.exports, "forgot_password_link", () => $f2250e33cdd6f35d$export$3e5d400ec6d58aff, (v) => $f2250e33cdd6f35d$export$3e5d400ec6d58aff = v);
$parcel$export(module.exports, "resend_confirmation_link", () => $f2250e33cdd6f35d$export$6dde455074644275, (v) => $f2250e33cdd6f35d$export$6dde455074644275 = v);
var $f2250e33cdd6f35d$export$34e0f9847d4c02dd;
var $f2250e33cdd6f35d$export$38e42c68cf43b5d4;
var $f2250e33cdd6f35d$export$db3c28d99448dcff;
var $f2250e33cdd6f35d$export$6e87302b124dfd8f;
var $f2250e33cdd6f35d$export$4be61d40313a3d60;
var $f2250e33cdd6f35d$export$1237798dc640739a;
var $f2250e33cdd6f35d$export$1e077af29af3389c;
var $f2250e33cdd6f35d$export$a38812d1aa1302d9;
var $f2250e33cdd6f35d$export$6eae7689ca139ede;
var $f2250e33cdd6f35d$export$9c30223ca0a664fb;
var $f2250e33cdd6f35d$export$6a64d2fc98121048;
var $f2250e33cdd6f35d$export$b07e517d22efa1ca;
var $f2250e33cdd6f35d$export$3e5d400ec6d58aff;
var $f2250e33cdd6f35d$export$6dde455074644275;
"use strict";
$f2250e33cdd6f35d$export$34e0f9847d4c02dd = "js-SharedCss-__form__container__mCfkD";
$f2250e33cdd6f35d$export$38e42c68cf43b5d4 = "js-SharedCss-__form__header__x9FGu";
$f2250e33cdd6f35d$export$db3c28d99448dcff = "js-SharedCss-__form__logo__4MIil";
$f2250e33cdd6f35d$export$6e87302b124dfd8f = "js-SharedCss-__form__header_text__hL6le";
$f2250e33cdd6f35d$export$4be61d40313a3d60 = "js-SharedCss-__form__form_container__8t0mS";
$f2250e33cdd6f35d$export$1237798dc640739a = "js-SharedCss-__form__label__-4ECi";
$f2250e33cdd6f35d$export$1e077af29af3389c = "js-SharedCss-__form__input_field__BVoWy";
$f2250e33cdd6f35d$export$a38812d1aa1302d9 = "js-SharedCss-__form__fieldset__lXtYM";
$f2250e33cdd6f35d$export$6eae7689ca139ede = "js-SharedCss-__form__submit_btn__iyc-e";
$f2250e33cdd6f35d$export$9c30223ca0a664fb = "js-SharedCss-__form__link__SAM0A";
$f2250e33cdd6f35d$export$6a64d2fc98121048 = "js-SharedCss-__form__form_description__l1S3c";
$f2250e33cdd6f35d$export$b07e517d22efa1ca = "js-SharedCss-__form__checkbox__tyP1E";
$f2250e33cdd6f35d$export$3e5d400ec6d58aff = "js-SharedCss-__form__forgot_password_link__qCRzv";
$f2250e33cdd6f35d$export$6dde455074644275 = "js-SharedCss-__form__resend_confirmation_link__irSTM";

});

parcelRegister("JjFQA", function(module, exports) {
"use strict";
function $088376ebfb5fac11$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $088376ebfb5fac11$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $088376ebfb5fac11$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $088376ebfb5fac11$var$CredentialsForm;

var $088376ebfb5fac11$var$_react = $088376ebfb5fac11$var$_interopRequireWildcard((parcelRequire("acw62")));

var $088376ebfb5fac11$var$formStyles = $088376ebfb5fac11$var$_interopRequireWildcard((parcelRequire("kMVI2")));

var $4fGPb = parcelRequire("4fGPb");

var $088376ebfb5fac11$var$_Footer = $088376ebfb5fac11$var$_interopRequireDefault((parcelRequire("8ALkM")));
function $088376ebfb5fac11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $088376ebfb5fac11$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($088376ebfb5fac11$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $088376ebfb5fac11$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $088376ebfb5fac11$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $088376ebfb5fac11$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $088376ebfb5fac11$var$_slicedToArray(r, e) {
    return $088376ebfb5fac11$var$_arrayWithHoles(r) || $088376ebfb5fac11$var$_iterableToArrayLimit(r, e) || $088376ebfb5fac11$var$_unsupportedIterableToArray(r, e) || $088376ebfb5fac11$var$_nonIterableRest();
}
function $088376ebfb5fac11$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $088376ebfb5fac11$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $088376ebfb5fac11$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $088376ebfb5fac11$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $088376ebfb5fac11$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $088376ebfb5fac11$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $088376ebfb5fac11$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

(parcelRequire("8vghX")).config();
function $088376ebfb5fac11$var$CredentialsForm(_ref) {
    var authenticate = _ref.authenticate;
    var _useState = (0, $088376ebfb5fac11$var$_react.useState)(''), _useState2 = $088376ebfb5fac11$var$_slicedToArray(_useState, 2), email = _useState2[0], setEmail = _useState2[1];
    var _useState3 = (0, $088376ebfb5fac11$var$_react.useState)(''), _useState4 = $088376ebfb5fac11$var$_slicedToArray(_useState3, 2), password = _useState4[0], setPassword = _useState4[1];
    var handleSubmit = function handleSubmit(e) {
        e.preventDefault();
        authenticate(email, password);
    };
    return /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("div", null, /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("div", {
        className: $088376ebfb5fac11$var$formStyles.header
    }, /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("div", {
        className: $088376ebfb5fac11$var$formStyles.logo
    }, /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("h1", null, "Blueleaf")), /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("div", {
        className: $088376ebfb5fac11$var$formStyles.header_text
    }, /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("h2", null, "Sign In"), /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("p", null, "Welcome back!"))), /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("div", {
        className: $088376ebfb5fac11$var$formStyles.form_container
    }, /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("form", {
        id: "login-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("div", {
        className: $088376ebfb5fac11$var$formStyles.fieldset
    }, /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("label", {
        className: $088376ebfb5fac11$var$formStyles.label
    }, "Email Address"), /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("input", {
        className: $088376ebfb5fac11$var$formStyles.input_field,
        type: "email",
        value: email,
        onChange: function onChange(e) {
            return setEmail(e.target.value);
        }
    })), /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("div", {
        className: $088376ebfb5fac11$var$formStyles.fieldset
    }, /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("label", {
        className: $088376ebfb5fac11$var$formStyles.label
    }, "Password"), /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("input", {
        className: $088376ebfb5fac11$var$formStyles.input_field,
        type: "password",
        value: password,
        onChange: function onChange(e) {
            return setPassword(e.target.value);
        }
    })), /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement("input", {
        className: $088376ebfb5fac11$var$formStyles.submit_btn,
        type: "submit",
        value: "Sign In"
    }), /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement($4fGPb.Link, {
        className: $088376ebfb5fac11$var$formStyles.link,
        to: "/forgot_password"
    }, "Forgot your password?"))), /*#__PURE__*/ $088376ebfb5fac11$var$_react["default"].createElement($088376ebfb5fac11$var$_Footer["default"], null));
}

});
parcelRegister("4fGPb", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $3189c83282a9a1c6$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $3189c83282a9a1c6$export$a6c7ac8248d6e38a);

var $kfZjc = parcelRequire("kfZjc");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $3np4r = parcelRequire("3np4r");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bv4qN = parcelRequire("bv4qN");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3189c83282a9a1c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3189c83282a9a1c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $3189c83282a9a1c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3189c83282a9a1c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $3np4r.createLocation)(to, null, null, currentLocation) : to;
};
var $3189c83282a9a1c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef === "undefined") $3189c83282a9a1c6$var$forwardRef = $3189c83282a9a1c6$var$forwardRefShim;
function $3189c83282a9a1c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3189c83282a9a1c6$var$LinkAnchor = $3189c83282a9a1c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1En50.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $8nd05.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3189c83282a9a1c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $3189c83282a9a1c6$export$a6c7ac8248d6e38a = $3189c83282a9a1c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3189c83282a9a1c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1En50.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var history = context.history;
        var location = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $8nd05.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3189c83282a9a1c6$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $3np4r.createPath)(context.location) === (0, $3np4r.createPath)($3189c83282a9a1c6$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props);
    });
});
var $3189c83282a9a1c6$var$toType, $3189c83282a9a1c6$var$refType;
var $3189c83282a9a1c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef$1 === "undefined") $3189c83282a9a1c6$var$forwardRef$1 = $3189c83282a9a1c6$var$forwardRefShim$1;
function $3189c83282a9a1c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3189c83282a9a1c6$export$b0d92dbee9b5b60d = $3189c83282a9a1c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1En50.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $kfZjc.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $3189c83282a9a1c6$var$joinClassnames(className, activeClassName);
            style = (0, $8nd05.default)({}, style, activeStyle);
        }
        var props = (0, $8nd05.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim$1 !== $3189c83282a9a1c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3189c83282a9a1c6$export$a6c7ac8248d6e38a, props);
    });
});
var $3189c83282a9a1c6$var$ariaCurrentType;

});
parcelRegister("kfZjc", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", () => $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07);
$parcel$export(module.exports, "Router", () => $ebf4c3fe5600f7ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Redirect", () => $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e);
$parcel$export(module.exports, "matchPath", () => $ebf4c3fe5600f7ed$export$81336c211d5ff295);
$parcel$export(module.exports, "Route", () => $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Switch", () => $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262);
$parcel$export(module.exports, "useParams", () => $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");


var $3np4r = parcelRequire("3np4r");


var $82FDD = parcelRequire("82FDD");

var $bv4qN = parcelRequire("bv4qN");

var $8nd05 = parcelRequire("8nd05");

var $8ugx5 = parcelRequire("8ugx5");
parcelRequire("dtksX");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $82FDD.default)();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$c213558b66925821 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router-History");
var $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $ebf4c3fe5600f7ed$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ebf4c3fe5600f7ed$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $ebf4c3fe5600f7ed$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ebf4c3fe5600f7ed$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ebf4c3fe5600f7ed$var$messageType;
var $ebf4c3fe5600f7ed$var$cache = {};
var $ebf4c3fe5600f7ed$var$cacheLimit = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount = 0;
function $ebf4c3fe5600f7ed$var$compilePath(path) {
    if ($ebf4c3fe5600f7ed$var$cache[path]) return $ebf4c3fe5600f7ed$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($8ugx5))).compile(path);
    if ($ebf4c3fe5600f7ed$var$cacheCount < $ebf4c3fe5600f7ed$var$cacheLimit) {
        $ebf4c3fe5600f7ed$var$cache[path] = generator;
        $ebf4c3fe5600f7ed$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ebf4c3fe5600f7ed$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ebf4c3fe5600f7ed$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $3np4r.createLocation)(computedMatch ? typeof to === "string" ? $ebf4c3fe5600f7ed$export$82476f982757e71e(to, computedMatch.params) : (0, $8nd05.default)({}, to, {
            pathname: $ebf4c3fe5600f7ed$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $3np4r.createLocation)(prevProps.to);
                if (!(0, $3np4r.locationsAreEqual)(prevLocation, (0, $8nd05.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $ebf4c3fe5600f7ed$var$cache$1 = {};
var $ebf4c3fe5600f7ed$var$cacheLimit$1 = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount$1 = 0;
function $ebf4c3fe5600f7ed$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ebf4c3fe5600f7ed$var$cache$1[cacheKey] || ($ebf4c3fe5600f7ed$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($8ugx5)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ebf4c3fe5600f7ed$var$cacheCount$1 < $ebf4c3fe5600f7ed$var$cacheLimit$1) {
        pathCache[path] = result;
        $ebf4c3fe5600f7ed$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ebf4c3fe5600f7ed$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ebf4c3fe5600f7ed$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ebf4c3fe5600f7ed$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 0;
}
function $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $bv4qN.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $8nd05.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $ebf4c3fe5600f7ed$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $ebf4c3fe5600f7ed$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ebf4c3fe5600f7ed$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: $ebf4c3fe5600f7ed$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ebf4c3fe5600f7ed$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ebf4c3fe5600f7ed$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ebf4c3fe5600f7ed$var$createURL(location) {
    return typeof location === "string" ? location : (0, $3np4r.createPath)(location);
}
function $ebf4c3fe5600f7ed$var$staticHandler(methodName) {
    return function() {
        (0, $bv4qN.default)(false);
    };
}
function $ebf4c3fe5600f7ed$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ebf4c3fe5600f7ed$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        _this.handleBlock = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ebf4c3fe5600f7ed$var$addBasename(basename, (0, $3np4r.createLocation)(location));
        context.url = $ebf4c3fe5600f7ed$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $1En50.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ebf4c3fe5600f7ed$var$addLeadingSlash(basename + $ebf4c3fe5600f7ed$var$createURL(path));
            },
            action: "POP",
            location: $ebf4c3fe5600f7ed$var$stripBasename(basename, (0, $3np4r.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ebf4c3fe5600f7ed$var$staticHandler("go"),
            goBack: $ebf4c3fe5600f7ed$var$staticHandler("goBack"),
            goForward: $ebf4c3fe5600f7ed$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, (0, $8nd05.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, (0, $8nd05.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $ebf4c3fe5600f7ed$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $1En50.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component);
}
var $ebf4c3fe5600f7ed$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext;
function $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$c213558b66925821);
}
function $ebf4c3fe5600f7ed$export$45d76561a5302f2b() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).location;
}
function $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef() {
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ebf4c3fe5600f7ed$export$632be4bb944c1bc7(path) {
    var location = $ebf4c3fe5600f7ed$export$45d76561a5302f2b();
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, path) : match;
}
var $ebf4c3fe5600f7ed$var$global, $ebf4c3fe5600f7ed$var$key, $ebf4c3fe5600f7ed$var$buildNames, $ebf4c3fe5600f7ed$var$initialBuildName, $ebf4c3fe5600f7ed$var$secondaryBuildName;

});
parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $VFVve.default)(subClass, superClass);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("3np4r", function(module, exports) {

$parcel$export(module.exports, "createPath", () => $2756f79476f0245f$export$fe53371bee54353d);
$parcel$export(module.exports, "createLocation", () => $2756f79476f0245f$export$90c043f1c57770b8);
$parcel$export(module.exports, "locationsAreEqual", () => $2756f79476f0245f$export$c3e8bb440bd55b18);
$parcel$export(module.exports, "createBrowserHistory", () => $2756f79476f0245f$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $2756f79476f0245f$export$b71fdd3798280242);
$parcel$export(module.exports, "createMemoryHistory", () => $2756f79476f0245f$export$2b76ad033c6e6d08);

var $8nd05 = parcelRequire("8nd05");

var $WYl7Q = parcelRequire("WYl7Q");

var $9t72y = parcelRequire("9t72y");


var $bv4qN = parcelRequire("bv4qN");
function $2756f79476f0245f$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $2756f79476f0245f$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $2756f79476f0245f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $2756f79476f0245f$var$stripBasename(path, prefix) {
    return $2756f79476f0245f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $2756f79476f0245f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $2756f79476f0245f$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $2756f79476f0245f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $2756f79476f0245f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $2756f79476f0245f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $8nd05.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $WYl7Q.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $2756f79476f0245f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $9t72y.default)(a.state, b.state);
}
function $2756f79476f0245f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $2756f79476f0245f$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $2756f79476f0245f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $2756f79476f0245f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $2756f79476f0245f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $2756f79476f0245f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $2756f79476f0245f$var$PopStateEvent = 'popstate';
var $2756f79476f0245f$var$HashChangeEvent = 'hashchange';
function $2756f79476f0245f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $2756f79476f0245f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $2756f79476f0245f$var$supportsHistory();
    var needsHashChangeListener = !$2756f79476f0245f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($2756f79476f0245f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($2756f79476f0245f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($2756f79476f0245f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $2756f79476f0245f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $2756f79476f0245f$var$HashChangeEvent$1 = 'hashchange';
var $2756f79476f0245f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $2756f79476f0245f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $2756f79476f0245f$var$stripLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    },
    slash: {
        encodePath: $2756f79476f0245f$var$addLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    }
};
function $2756f79476f0245f$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $2756f79476f0245f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $2756f79476f0245f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $2756f79476f0245f$var$replaceHashPath(path) {
    window.location.replace($2756f79476f0245f$var$stripHash(window.location.href) + '#' + path);
}
function $2756f79476f0245f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $2756f79476f0245f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($2756f79476f0245f$var$getHashPath());
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $2756f79476f0245f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $2756f79476f0245f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $2756f79476f0245f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $2756f79476f0245f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $2756f79476f0245f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $2756f79476f0245f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $2756f79476f0245f$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $2756f79476f0245f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $2756f79476f0245f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $2756f79476f0245f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $2756f79476f0245f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, createKey()) : $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $2756f79476f0245f$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $2756f79476f0245f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("WYl7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b14391bdc5d7d11$export$2e2bcd8739ae039);
function $0b14391bdc5d7d11$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0b14391bdc5d7d11$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0b14391bdc5d7d11$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $0b14391bdc5d7d11$var$isAbsolute(to);
    var isFromAbs = from && $0b14391bdc5d7d11$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0b14391bdc5d7d11$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$0b14391bdc5d7d11$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $0b14391bdc5d7d11$export$2e2bcd8739ae039 = $0b14391bdc5d7d11$var$resolvePathname;

});

parcelRegister("9t72y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e4c488965e5c6e8$export$2e2bcd8739ae039);
function $6e4c488965e5c6e8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6e4c488965e5c6e8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6e4c488965e5c6e8$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $6e4c488965e5c6e8$var$valueOf(a);
        var bValue = $6e4c488965e5c6e8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6e4c488965e5c6e8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6e4c488965e5c6e8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6e4c488965e5c6e8$export$2e2bcd8739ae039 = $6e4c488965e5c6e8$var$valueEqual;

});

parcelRegister("bv4qN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f606e562c81b96$export$2e2bcd8739ae039);
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = 'Invariant failed';
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? $85f606e562c81b96$var$prefix + ": " + provided : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}

});


parcelRegister("82FDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5daecf22ac820441$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $g7ajw = parcelRequire("g7ajw");

var $c9Z8w = parcelRequire("c9Z8w");

var $5daecf22ac820441$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $5daecf22ac820441$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
function $5daecf22ac820441$var$getUniqueId() {
    var key = '__global_unique_id__';
    return $5daecf22ac820441$var$commonjsGlobal[key] = ($5daecf22ac820441$var$commonjsGlobal[key] || 0) + 1;
}
function $5daecf22ac820441$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5daecf22ac820441$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $5daecf22ac820441$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $5daecf22ac820441$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + $5daecf22ac820441$var$getUniqueId() + '__';
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $g7ajw.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $5daecf22ac820441$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($5daecf22ac820441$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : $5daecf22ac820441$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $acw62.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $g7ajw.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5daecf22ac820441$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5daecf22ac820441$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $5daecf22ac820441$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $acw62.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $5daecf22ac820441$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext || $5daecf22ac820441$var$createReactContext;
var $5daecf22ac820441$export$2e2bcd8739ae039 = $5daecf22ac820441$var$index;

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});




parcelRegister("8ugx5", function(module, exports) {

var $a0lxx = parcelRequire("a0lxx");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $62ddf3174d9df941$var$pathToRegexp;
module.exports.parse = $62ddf3174d9df941$var$parse;
module.exports.compile = $62ddf3174d9df941$var$compile;
module.exports.tokensToFunction = $62ddf3174d9df941$var$tokensToFunction;
module.exports.tokensToRegExp = $62ddf3174d9df941$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $62ddf3174d9df941$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $62ddf3174d9df941$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $62ddf3174d9df941$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $62ddf3174d9df941$var$escapeGroup(pattern) : asterisk ? '.*' : '[^' + $62ddf3174d9df941$var$escapeString(delimiter) + ']+?'
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $62ddf3174d9df941$var$compile(str, options) {
    return $62ddf3174d9df941$var$tokensToFunction($62ddf3174d9df941$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $62ddf3174d9df941$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $62ddf3174d9df941$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $62ddf3174d9df941$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($a0lxx(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $62ddf3174d9df941$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $62ddf3174d9df941$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $62ddf3174d9df941$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($62ddf3174d9df941$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $62ddf3174d9df941$var$flags(options));
    return $62ddf3174d9df941$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$stringToRegexp(path, keys, options) {
    return $62ddf3174d9df941$var$tokensToRegExp($62ddf3174d9df941$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$tokensToRegExp(tokens, keys, options) {
    if (!$a0lxx(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $62ddf3174d9df941$var$escapeString(token);
        else {
            var prefix = $62ddf3174d9df941$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $62ddf3174d9df941$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $62ddf3174d9df941$var$attachKeys(new RegExp('^' + route, $62ddf3174d9df941$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$pathToRegexp(path, keys, options) {
    if (!$a0lxx(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $62ddf3174d9df941$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($a0lxx(path)) return $62ddf3174d9df941$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $62ddf3174d9df941$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("a0lxx", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});


parcelRegister("dtksX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bilNr"));

});
parcelRegister("bilNr", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $839248794b2aa02f$export$2b8d127b894957b9, (v) => $839248794b2aa02f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $839248794b2aa02f$export$cea3a54a6425200c, (v) => $839248794b2aa02f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $839248794b2aa02f$export$a7c73072b1a182ae, (v) => $839248794b2aa02f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $839248794b2aa02f$export$9f27bc3417b4524d, (v) => $839248794b2aa02f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $839248794b2aa02f$export$db77ccec0bb4ccac, (v) => $839248794b2aa02f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $839248794b2aa02f$export$8392c0c9d3dcbd35, (v) => $839248794b2aa02f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $839248794b2aa02f$export$ffb0004e005737fa, (v) => $839248794b2aa02f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $839248794b2aa02f$export$b624eff549462981, (v) => $839248794b2aa02f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $839248794b2aa02f$export$7897aa7841a5380c, (v) => $839248794b2aa02f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $839248794b2aa02f$export$602eac185826482c, (v) => $839248794b2aa02f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $839248794b2aa02f$export$e2c29f18771995cb, (v) => $839248794b2aa02f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $839248794b2aa02f$export$5f8d39834fd61797, (v) => $839248794b2aa02f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $839248794b2aa02f$export$74bf444e3cd11ea5, (v) => $839248794b2aa02f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $839248794b2aa02f$export$92387174baf9b227, (v) => $839248794b2aa02f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $839248794b2aa02f$export$ec112efeb987d9c6, (v) => $839248794b2aa02f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $839248794b2aa02f$export$b706b080d889d2c9, (v) => $839248794b2aa02f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $839248794b2aa02f$export$5be5a87408f70ddc, (v) => $839248794b2aa02f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $839248794b2aa02f$export$45a5e7f76e0caa8d, (v) => $839248794b2aa02f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $839248794b2aa02f$export$455c2e768291efa6, (v) => $839248794b2aa02f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $839248794b2aa02f$export$9522e17588c12572, (v) => $839248794b2aa02f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $839248794b2aa02f$export$2110ac352bb060b9, (v) => $839248794b2aa02f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $839248794b2aa02f$export$56885ab8b9c456ab, (v) => $839248794b2aa02f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $839248794b2aa02f$export$d927fcb6adf8f9de, (v) => $839248794b2aa02f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $839248794b2aa02f$export$b82d16f27459e05a, (v) => $839248794b2aa02f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $839248794b2aa02f$export$522c17b4f5e123e8, (v) => $839248794b2aa02f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $839248794b2aa02f$export$1aabd8a0274ecfd6, (v) => $839248794b2aa02f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $839248794b2aa02f$export$9b621391a187a31a, (v) => $839248794b2aa02f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $839248794b2aa02f$export$f5bbd400c2f4426f, (v) => $839248794b2aa02f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839248794b2aa02f$export$2b8d127b894957b9;
var $839248794b2aa02f$export$cea3a54a6425200c;
var $839248794b2aa02f$export$a7c73072b1a182ae;
var $839248794b2aa02f$export$9f27bc3417b4524d;
var $839248794b2aa02f$export$db77ccec0bb4ccac;
var $839248794b2aa02f$export$8392c0c9d3dcbd35;
var $839248794b2aa02f$export$ffb0004e005737fa;
var $839248794b2aa02f$export$b624eff549462981;
var $839248794b2aa02f$export$7897aa7841a5380c;
var $839248794b2aa02f$export$602eac185826482c;
var $839248794b2aa02f$export$e2c29f18771995cb;
var $839248794b2aa02f$export$5f8d39834fd61797;
var $839248794b2aa02f$export$74bf444e3cd11ea5;
var $839248794b2aa02f$export$92387174baf9b227;
var $839248794b2aa02f$export$ec112efeb987d9c6;
var $839248794b2aa02f$export$b706b080d889d2c9;
var $839248794b2aa02f$export$5be5a87408f70ddc;
var $839248794b2aa02f$export$45a5e7f76e0caa8d;
var $839248794b2aa02f$export$455c2e768291efa6;
var $839248794b2aa02f$export$9522e17588c12572;
var $839248794b2aa02f$export$2110ac352bb060b9;
var $839248794b2aa02f$export$56885ab8b9c456ab;
var $839248794b2aa02f$export$d927fcb6adf8f9de;
var $839248794b2aa02f$export$b82d16f27459e05a;
var $839248794b2aa02f$export$522c17b4f5e123e8;
var $839248794b2aa02f$export$1aabd8a0274ecfd6;
var $839248794b2aa02f$export$9b621391a187a31a;
var $839248794b2aa02f$export$f5bbd400c2f4426f;
'use strict';
var $839248794b2aa02f$var$b = "function" === typeof Symbol && Symbol.for, $839248794b2aa02f$var$c = $839248794b2aa02f$var$b ? Symbol.for("react.element") : 60103, $839248794b2aa02f$var$d = $839248794b2aa02f$var$b ? Symbol.for("react.portal") : 60106, $839248794b2aa02f$var$e = $839248794b2aa02f$var$b ? Symbol.for("react.fragment") : 60107, $839248794b2aa02f$var$f = $839248794b2aa02f$var$b ? Symbol.for("react.strict_mode") : 60108, $839248794b2aa02f$var$g = $839248794b2aa02f$var$b ? Symbol.for("react.profiler") : 60114, $839248794b2aa02f$var$h = $839248794b2aa02f$var$b ? Symbol.for("react.provider") : 60109, $839248794b2aa02f$var$k = $839248794b2aa02f$var$b ? Symbol.for("react.context") : 60110, $839248794b2aa02f$var$l = $839248794b2aa02f$var$b ? Symbol.for("react.async_mode") : 60111, $839248794b2aa02f$var$m = $839248794b2aa02f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $839248794b2aa02f$var$n = $839248794b2aa02f$var$b ? Symbol.for("react.forward_ref") : 60112, $839248794b2aa02f$var$p = $839248794b2aa02f$var$b ? Symbol.for("react.suspense") : 60113, $839248794b2aa02f$var$q = $839248794b2aa02f$var$b ? Symbol.for("react.suspense_list") : 60120, $839248794b2aa02f$var$r = $839248794b2aa02f$var$b ? Symbol.for("react.memo") : 60115, $839248794b2aa02f$var$t = $839248794b2aa02f$var$b ? Symbol.for("react.lazy") : 60116, $839248794b2aa02f$var$v = $839248794b2aa02f$var$b ? Symbol.for("react.block") : 60121, $839248794b2aa02f$var$w = $839248794b2aa02f$var$b ? Symbol.for("react.fundamental") : 60117, $839248794b2aa02f$var$x = $839248794b2aa02f$var$b ? Symbol.for("react.responder") : 60118, $839248794b2aa02f$var$y = $839248794b2aa02f$var$b ? Symbol.for("react.scope") : 60119;
function $839248794b2aa02f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $839248794b2aa02f$var$c:
                switch(a = a.type, a){
                    case $839248794b2aa02f$var$l:
                    case $839248794b2aa02f$var$m:
                    case $839248794b2aa02f$var$e:
                    case $839248794b2aa02f$var$g:
                    case $839248794b2aa02f$var$f:
                    case $839248794b2aa02f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $839248794b2aa02f$var$k:
                            case $839248794b2aa02f$var$n:
                            case $839248794b2aa02f$var$t:
                            case $839248794b2aa02f$var$r:
                            case $839248794b2aa02f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $839248794b2aa02f$var$d:
                return u;
        }
    }
}
function $839248794b2aa02f$var$A(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$m;
}
$839248794b2aa02f$export$2b8d127b894957b9 = $839248794b2aa02f$var$l;
$839248794b2aa02f$export$cea3a54a6425200c = $839248794b2aa02f$var$m;
$839248794b2aa02f$export$a7c73072b1a182ae = $839248794b2aa02f$var$k;
$839248794b2aa02f$export$9f27bc3417b4524d = $839248794b2aa02f$var$h;
$839248794b2aa02f$export$db77ccec0bb4ccac = $839248794b2aa02f$var$c;
$839248794b2aa02f$export$8392c0c9d3dcbd35 = $839248794b2aa02f$var$n;
$839248794b2aa02f$export$ffb0004e005737fa = $839248794b2aa02f$var$e;
$839248794b2aa02f$export$b624eff549462981 = $839248794b2aa02f$var$t;
$839248794b2aa02f$export$7897aa7841a5380c = $839248794b2aa02f$var$r;
$839248794b2aa02f$export$602eac185826482c = $839248794b2aa02f$var$d;
$839248794b2aa02f$export$e2c29f18771995cb = $839248794b2aa02f$var$g;
$839248794b2aa02f$export$5f8d39834fd61797 = $839248794b2aa02f$var$f;
$839248794b2aa02f$export$74bf444e3cd11ea5 = $839248794b2aa02f$var$p;
$839248794b2aa02f$export$92387174baf9b227 = function(a) {
    return $839248794b2aa02f$var$A(a) || $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$l;
};
$839248794b2aa02f$export$ec112efeb987d9c6 = $839248794b2aa02f$var$A;
$839248794b2aa02f$export$b706b080d889d2c9 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$k;
};
$839248794b2aa02f$export$5be5a87408f70ddc = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$h;
};
$839248794b2aa02f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $839248794b2aa02f$var$c;
};
$839248794b2aa02f$export$455c2e768291efa6 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$n;
};
$839248794b2aa02f$export$9522e17588c12572 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$e;
};
$839248794b2aa02f$export$2110ac352bb060b9 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$t;
};
$839248794b2aa02f$export$56885ab8b9c456ab = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$r;
};
$839248794b2aa02f$export$d927fcb6adf8f9de = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$d;
};
$839248794b2aa02f$export$b82d16f27459e05a = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$g;
};
$839248794b2aa02f$export$522c17b4f5e123e8 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$f;
};
$839248794b2aa02f$export$1aabd8a0274ecfd6 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$p;
};
$839248794b2aa02f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $839248794b2aa02f$var$e || a === $839248794b2aa02f$var$m || a === $839248794b2aa02f$var$g || a === $839248794b2aa02f$var$f || a === $839248794b2aa02f$var$p || a === $839248794b2aa02f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $839248794b2aa02f$var$t || a.$$typeof === $839248794b2aa02f$var$r || a.$$typeof === $839248794b2aa02f$var$h || a.$$typeof === $839248794b2aa02f$var$k || a.$$typeof === $839248794b2aa02f$var$n || a.$$typeof === $839248794b2aa02f$var$w || a.$$typeof === $839248794b2aa02f$var$x || a.$$typeof === $839248794b2aa02f$var$y || a.$$typeof === $839248794b2aa02f$var$v);
};
$839248794b2aa02f$export$f5bbd400c2f4426f = $839248794b2aa02f$var$z;

});


parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});





parcelRegister("8ALkM", function(module, exports) {
"use strict";
function $6416671af9271dfd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6416671af9271dfd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6416671af9271dfd$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6416671af9271dfd$var$Footer;

var $6416671af9271dfd$var$_react = $6416671af9271dfd$var$_interopRequireDefault((parcelRequire("acw62")));

var $6416671af9271dfd$var$styles = $6416671af9271dfd$var$_interopRequireWildcard((parcelRequire("bcOeW")));
function $6416671af9271dfd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6416671af9271dfd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6416671af9271dfd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $6416671af9271dfd$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $6416671af9271dfd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6416671af9271dfd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}

if (null) null.accept("./footer.css", function() {
    (parcelRequire("bcOeW"));
});
function $6416671af9271dfd$var$Footer() {
    var year = new Date().getFullYear();
    return /*#__PURE__*/ $6416671af9271dfd$var$_react["default"].createElement("div", {
        className: $6416671af9271dfd$var$styles.footer
    }, /*#__PURE__*/ $6416671af9271dfd$var$_react["default"].createElement("span", {
        className: $6416671af9271dfd$var$styles.legal
    }, "2010-".concat(year, " Blueleaf Wealth, Inc. All rights reserved. Patent pending.")));
}

});
parcelRegister("bcOeW", function(module, exports) {

$parcel$export(module.exports, "footer", () => $8287c9507fddccab$export$adb608be33961c98, (v) => $8287c9507fddccab$export$adb608be33961c98 = v);
$parcel$export(module.exports, "legal", () => $8287c9507fddccab$export$29c248a685096bf5, (v) => $8287c9507fddccab$export$29c248a685096bf5 = v);
var $8287c9507fddccab$export$adb608be33961c98;
var $8287c9507fddccab$export$29c248a685096bf5;
"use strict";
$8287c9507fddccab$export$adb608be33961c98 = "js-SharedComponents-__footer__footer__4EWmk";
$8287c9507fddccab$export$29c248a685096bf5 = "js-SharedComponents-__footer__legal__o8sxM";

});


parcelRegister("8vghX", function(module, exports) {

$parcel$export(module.exports, "config", () => $630dda8d81b1b9e8$export$e506a1d27d1eaa20, (v) => $630dda8d81b1b9e8$export$e506a1d27d1eaa20 = v);
/* @flow */ /*::

type DotenvParseOptions = {
  debug?: boolean
}

// keys and values from src
type DotenvParseOutput = { [string]: string }

type DotenvConfigOptions = {
  path?: string, // path to .env file
  encoding?: string, // encoding of .env file
  debug?: string // turn on logging for debugging purposes
}

type DotenvConfigOutput = {
  parsed?: DotenvParseOutput,
  error?: Error
}

*/ var $630dda8d81b1b9e8$export$e506a1d27d1eaa20;
var $630dda8d81b1b9e8$export$98e6a39c04603d36;

var $hPtJY = parcelRequire("hPtJY");

var $kjyEk = parcelRequire("kjyEk");

var $59kwG = parcelRequire("59kwG");
function $630dda8d81b1b9e8$var$log(message /*: string */ ) {
    console.log(`[dotenv][DEBUG] ${message}`);
}
const $630dda8d81b1b9e8$var$NEWLINE = '\n';
const $630dda8d81b1b9e8$var$RE_INI_KEY_VAL = /^\s*([\w.-]+)\s*=\s*(.*)?\s*$/;
const $630dda8d81b1b9e8$var$RE_NEWLINES = /\\n/g;
const $630dda8d81b1b9e8$var$NEWLINES_MATCH = /\n|\r|\r\n/;
// Parses src into an Object
function $630dda8d81b1b9e8$var$parse(src /*: string | Buffer */ , options /*: ?DotenvParseOptions */ ) /*: DotenvParseOutput */ {
    const debug = Boolean(options && options.debug);
    const obj = {};
    // convert Buffers before splitting into lines and processing
    src.toString().split($630dda8d81b1b9e8$var$NEWLINES_MATCH).forEach(function(line, idx) {
        // matching "KEY' and 'VAL' in 'KEY=VAL'
        const keyValueArr = line.match($630dda8d81b1b9e8$var$RE_INI_KEY_VAL);
        // matched?
        if (keyValueArr != null) {
            const key = keyValueArr[1];
            // default undefined or missing values to empty string
            let val = keyValueArr[2] || '';
            const end = val.length - 1;
            const isDoubleQuoted = val[0] === '"' && val[end] === '"';
            const isSingleQuoted = val[0] === "'" && val[end] === "'";
            // if single or double quoted, remove quotes
            if (isSingleQuoted || isDoubleQuoted) {
                val = val.substring(1, end);
                // if double quoted, expand newlines
                if (isDoubleQuoted) val = val.replace($630dda8d81b1b9e8$var$RE_NEWLINES, $630dda8d81b1b9e8$var$NEWLINE);
            } else // remove surrounding whitespace
            val = val.trim();
            obj[key] = val;
        } else if (debug) $630dda8d81b1b9e8$var$log(`did not match key and value when parsing line ${idx + 1}: ${line}`);
    });
    return obj;
}
// Populates process.env from .env file
function $630dda8d81b1b9e8$var$config(options /*: ?DotenvConfigOptions */ ) /*: DotenvConfigOutput */ {
    let dotenvPath = $59kwG.resolve($hPtJY.cwd(), '.env');
    let encoding /*: string */  = 'utf8';
    let debug = false;
    if (options) {
        if (options.path != null) dotenvPath = options.path;
        if (options.encoding != null) encoding = options.encoding;
        if (options.debug != null) debug = true;
    }
    try {
        // specifying an encoding returns a string instead of a buffer
        const parsed = $630dda8d81b1b9e8$var$parse($kjyEk.readFileSync(dotenvPath, {
            encoding: encoding
        }), {
            debug: debug
        });
        Object.keys(parsed).forEach(function(key) {
            if (!Object.prototype.hasOwnProperty.call($hPtJY.env, key)) parsed[key];
            else if (debug) $630dda8d81b1b9e8$var$log(`"${key}" is already defined in \`process.env\` and will not be overwritten`);
        });
        return {
            parsed: parsed
        };
    } catch (e) {
        return {
            error: e
        };
    }
}
$630dda8d81b1b9e8$export$e506a1d27d1eaa20 = $630dda8d81b1b9e8$var$config;
$630dda8d81b1b9e8$export$98e6a39c04603d36 = $630dda8d81b1b9e8$var$parse;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("59kwG", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $hPtJY.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return '';
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
module.exports = $3bfdb7183e8721d6$var$posix;

});



parcelRegister("gwdxu", function(module, exports) {
"use strict";
function $c06a23149e6a7247$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c06a23149e6a7247$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c06a23149e6a7247$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c06a23149e6a7247$var$MfaForm;

var $c06a23149e6a7247$var$_react = $c06a23149e6a7247$var$_interopRequireWildcard((parcelRequire("acw62")));

var $c06a23149e6a7247$var$alertStyles = $c06a23149e6a7247$var$_interopRequireWildcard((parcelRequire("jbsrN")));

var $c06a23149e6a7247$var$styles = $c06a23149e6a7247$var$_interopRequireWildcard((parcelRequire("kMVI2")));

var $g3rxA = parcelRequire("g3rxA");

var $dwN01 = parcelRequire("dwN01");

var $c06a23149e6a7247$var$_AlertTypes = $c06a23149e6a7247$var$_interopRequireDefault((parcelRequire("5LA7J")));

var $c06a23149e6a7247$var$_Footer = $c06a23149e6a7247$var$_interopRequireDefault((parcelRequire("8ALkM")));

var $c06a23149e6a7247$var$_Logger = $c06a23149e6a7247$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $c06a23149e6a7247$var$_reactTopLoadingBar = $c06a23149e6a7247$var$_interopRequireDefault((parcelRequire("1KSzM")));
function $c06a23149e6a7247$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $c06a23149e6a7247$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c06a23149e6a7247$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c06a23149e6a7247$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $c06a23149e6a7247$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $c06a23149e6a7247$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c06a23149e6a7247$var$_slicedToArray(r, e) {
    return $c06a23149e6a7247$var$_arrayWithHoles(r) || $c06a23149e6a7247$var$_iterableToArrayLimit(r, e) || $c06a23149e6a7247$var$_unsupportedIterableToArray(r, e) || $c06a23149e6a7247$var$_nonIterableRest();
}
function $c06a23149e6a7247$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c06a23149e6a7247$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c06a23149e6a7247$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c06a23149e6a7247$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c06a23149e6a7247$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $c06a23149e6a7247$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c06a23149e6a7247$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

if (null) null.accept("../SharedCss/alert.css", function() {
    (parcelRequire("jbsrN"));
});

(parcelRequire("8vghX")).config();
function $c06a23149e6a7247$var$MfaForm(props) {
    var cognitoUser = props.cognitoUser, destination = props.destination;
    var _useState = (0, $c06a23149e6a7247$var$_react.useState)(''), _useState2 = $c06a23149e6a7247$var$_slicedToArray(_useState, 2), code = _useState2[0], setCode = _useState2[1];
    var _useState3 = (0, $c06a23149e6a7247$var$_react.useState)(''), _useState4 = $c06a23149e6a7247$var$_slicedToArray(_useState3, 2), alertType = _useState4[0], setAlertType = _useState4[1];
    var _useState5 = (0, $c06a23149e6a7247$var$_react.useState)(''), _useState6 = $c06a23149e6a7247$var$_slicedToArray(_useState5, 2), errorMessage = _useState6[0], setErrorMessage = _useState6[1];
    var loadingRef = (0, $c06a23149e6a7247$var$_react.useRef)(null);
    var params = new URLSearchParams(window.location.search);
    var returnToUrl = params.get('return_to');
    var handleSubmit = function handleSubmit(e) {
        $c06a23149e6a7247$var$_Logger["default"].start('MFA submit');
        loadingRef.current.continuousStart();
        e.preventDefault();
        cognitoUser.sendMFACode(code, {
            onSuccess: function onSuccess(tokens) {
                $c06a23149e6a7247$var$_Logger["default"].done('MFA submit');
                (0, $dwN01.signIn)(tokens);
                if (returnToUrl) (0, $g3rxA.signInExternalHostWithCustomRedirect)(returnToUrl);
                else (0, $g3rxA.signInExternalHost)();
            },
            onFailure: function onFailure(err) {
                loadingRef.current.complete();
                $c06a23149e6a7247$var$_Logger["default"].error('MFA submit', err);
                setAlertType($c06a23149e6a7247$var$_AlertTypes["default"].UPDATE_FAILED);
                setErrorMessage(err.message || JSON.stringify(err));
            }
        });
    };
    var renderAlert = function renderAlert() {
        if (alertType === $c06a23149e6a7247$var$_AlertTypes["default"].UPDATE_FAILED) return /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("div", {
            className: [
                $c06a23149e6a7247$var$alertStyles.alert,
                $c06a23149e6a7247$var$alertStyles.error
            ].join(' ')
        }, errorMessage);
    };
    return /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("div", {
        className: $c06a23149e6a7247$var$styles.container
    }, renderAlert(), /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement($c06a23149e6a7247$var$_reactTopLoadingBar["default"], {
        color: "#f11946",
        ref: loadingRef
    }), /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("div", {
        className: $c06a23149e6a7247$var$styles.header
    }, /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("div", {
        className: $c06a23149e6a7247$var$styles.logo
    }, /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("h1", null, "Blueleaf")), /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("div", {
        className: $c06a23149e6a7247$var$styles.header_text
    }, /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("h2", null, "Verify your identity"))), /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("div", {
        className: $c06a23149e6a7247$var$styles.form_container
    }, /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("form", {
        id: "forgot-password-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("div", {
        className: $c06a23149e6a7247$var$styles.form_description
    }, "We\u2019ve sent a temporary access code to your phone number ending ", destination), /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("div", {
        className: $c06a23149e6a7247$var$styles.fieldset
    }, /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("label", {
        className: $c06a23149e6a7247$var$styles.label
    }, "Enter code"), /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("input", {
        className: $c06a23149e6a7247$var$styles.input_field,
        type: "text",
        value: code,
        onChange: function onChange(e) {
            return setCode(e.target.value);
        }
    })), /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("input", {
        id: "submit-btn",
        className: $c06a23149e6a7247$var$styles.submit_btn,
        type: "submit",
        value: "Verify"
    }), /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement("a", {
        id: "sign-in-btn",
        className: $c06a23149e6a7247$var$styles.link,
        href: "/"
    }, "Didn\u2019t receive your code? Try login again."))), /*#__PURE__*/ $c06a23149e6a7247$var$_react["default"].createElement($c06a23149e6a7247$var$_Footer["default"], null));
}

});
parcelRegister("g3rxA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getExternalHostUrl = $bb024a2586a05a0a$var$getExternalHostUrl;
module.exports.setExternalHost = $bb024a2586a05a0a$var$setExternalHost;
module.exports.signInExternalHost = $bb024a2586a05a0a$var$signInExternalHost;
module.exports.signInExternalHostWithCustomRedirect = $bb024a2586a05a0a$var$signInExternalHostWithCustomRedirect;
module.exports.signOutExternalHost = $bb024a2586a05a0a$var$signOutExternalHost;

var $bb024a2586a05a0a$var$_mono = $bb024a2586a05a0a$var$_interopRequireDefault((parcelRequire("qkIgO")));

var $bb024a2586a05a0a$var$_Logger = $bb024a2586a05a0a$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $dwN01 = parcelRequire("dwN01");
function $bb024a2586a05a0a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}

(parcelRequire("8vghX")).config();
var $bb024a2586a05a0a$var$SUPPORTED_EXTERNAL_HOSTS = [
    'mono'
];
var $bb024a2586a05a0a$var$DEFAULT_EXTERNAL_HOST = 'mono';
var $bb024a2586a05a0a$var$getExternalHostName = function getExternalHostName() {
    var externalHostName = localStorage.getItem('externalHostName');
    if ($bb024a2586a05a0a$var$SUPPORTED_EXTERNAL_HOSTS.indexOf(externalHostName) === -1) return $bb024a2586a05a0a$var$DEFAULT_EXTERNAL_HOST;
    else return externalHostName;
};
var $bb024a2586a05a0a$var$getExternalHost = function getExternalHost() {
    var externalHostName = $bb024a2586a05a0a$var$getExternalHostName();
    var externalHost = {
        mono: $bb024a2586a05a0a$var$_mono["default"]
    }[externalHostName] || $bb024a2586a05a0a$var$_mono["default"];
    $bb024a2586a05a0a$var$_Logger["default"].info('External Host', {
        name: externalHostName,
        object: externalHost
    });
    return externalHost;
};
function $bb024a2586a05a0a$var$getExternalHostUrl() {
    return localStorage.getItem('externalHostUrl') || "https://secure.blueleaf.com";
}
function $bb024a2586a05a0a$var$signInExternalHost() {
    $bb024a2586a05a0a$var$_Logger["default"].start('Sign in external Host');
    var externalHost = $bb024a2586a05a0a$var$getExternalHost();
    return externalHost.signIn((0, $dwN01.getTokens)()).then(function(response) {
        $bb024a2586a05a0a$var$_Logger["default"].done('Sign in external Host');
        externalHost.afterSignedIn();
    })["catch"](function(error) {
        $bb024a2586a05a0a$var$_Logger["default"].error('sign in external host', error);
    });
}
function $bb024a2586a05a0a$var$signOutExternalHost() {
    $bb024a2586a05a0a$var$_Logger["default"].start('Sign out external Host');
    return $bb024a2586a05a0a$var$getExternalHost().signOut((0, $dwN01.getTokens)()).then(function() {
        $bb024a2586a05a0a$var$_Logger["default"].done('Sign out external Host');
    })["catch"](function(error) {
        $bb024a2586a05a0a$var$_Logger["default"].error('sign out external host', error);
    });
}
function $bb024a2586a05a0a$var$setExternalHost() {
    var params = new URLSearchParams(window.location.search);
    var externalHostName = params.get('external_host');
    var externalHostUrl = params.get('external_host_url');
    if (externalHostName) {
        if (externalHostUrl.indexOf('localhost') === -1) externalHostUrl = externalHostUrl.replace('http', 'https');
        $bb024a2586a05a0a$var$_Logger["default"].info('set External Host', {
            name: externalHostName,
            url: externalHostUrl
        });
        localStorage.setItem('externalHostName', externalHostName);
        localStorage.setItem('externalHostUrl', externalHostUrl);
    }
}
function $bb024a2586a05a0a$var$signInExternalHostWithCustomRedirect(url) {
    var externalHost = $bb024a2586a05a0a$var$getExternalHost();
    return externalHost.signIn((0, $dwN01.getTokens)()).then(function(response) {
        window.location.href = url;
    })["catch"](function(error) {
        $bb024a2586a05a0a$var$_Logger["default"].error('sign in external host', error);
    });
}

});
parcelRegister("qkIgO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCustomSignInSetting = module.exports["default"] = module.exports.checkCognitoStatus = void 0;

var $g3rxA = parcelRequire("g3rxA");

(parcelRequire("8vghX")).config();
var $04f27efff0330c20$var$signIn = function signIn(tokens) {
    var params = $04f27efff0330c20$var$getRequestParams('POST', tokens);
    return fetch("".concat((0, $g3rxA.getExternalHostUrl)(), "/handle_authentication"), params);
};
var $04f27efff0330c20$var$signOut = function signOut(tokens) {
    var params = $04f27efff0330c20$var$getRequestParams('DELETE', tokens);
    return fetch("".concat((0, $g3rxA.getExternalHostUrl)(), "/handle_authentication"), params);
};
var $04f27efff0330c20$var$afterSignedIn = function afterSignedIn() {
    window.location.href = (0, $g3rxA.getExternalHostUrl)();
};
var $04f27efff0330c20$var$getCustomSignInSetting = module.exports.getCustomSignInSetting = function getCustomSignInSetting(advisorId) {
    return fetch("".concat((0, $g3rxA.getExternalHostUrl)(), "/api/v1/advisors/").concat(advisorId, "/custom_login_setting.json")).then(function(response) {
        return response.json();
    });
};
var $04f27efff0330c20$var$checkCognitoStatus = module.exports.checkCognitoStatus = function checkCognitoStatus(email) {
    return fetch("".concat((0, $g3rxA.getExternalHostUrl)(), "/api/v1/check_cognito_status.json?email=").concat(encodeURIComponent(email))).then(function(response) {
        return response.json();
    });
};
var $04f27efff0330c20$var$getRequestParams = function getRequestParams(method, tokens) {
    return {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            AccessToken: tokens.accessToken,
            Authorization: "Bearer ".concat(tokens.idToken),
            RefreshToken: tokens.refreshToken
        },
        credentials: 'include'
    };
};
var $04f27efff0330c20$var$_default = module.exports["default"] = {
    signIn: $04f27efff0330c20$var$signIn,
    afterSignedIn: $04f27efff0330c20$var$afterSignedIn,
    signOut: $04f27efff0330c20$var$signOut
};

});

parcelRegister("2ChR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

(parcelRequire("8vghX")).config();
var $1e7cfb30dae6e948$var$start = function start(msg) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $1e7cfb30dae6e948$var$info("Start ".concat(msg), params);
};
var $1e7cfb30dae6e948$var$done = function done(msg) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $1e7cfb30dae6e948$var$info("Done ".concat(msg), params);
};
var $1e7cfb30dae6e948$var$info = function info(msg) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return;
};
var $1e7cfb30dae6e948$var$error = function error(msg) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return;
};
var $1e7cfb30dae6e948$var$_default = module.exports["default"] = {
    info: $1e7cfb30dae6e948$var$info,
    error: $1e7cfb30dae6e948$var$error,
    start: $1e7cfb30dae6e948$var$start,
    done: $1e7cfb30dae6e948$var$done
};

});

parcelRegister("dwN01", function(module, exports) {
"use strict";
function $9d9445c3761e3e83$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9d9445c3761e3e83$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9d9445c3761e3e83$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.authenticateCognito = $9d9445c3761e3e83$var$authenticateCognito;
module.exports.clearTokens = $9d9445c3761e3e83$var$clearTokens;
module.exports.fetchUserData = $9d9445c3761e3e83$var$fetchUserData;
module.exports.getAccessToken = $9d9445c3761e3e83$var$getAccessToken;
module.exports.getAuthenticatedUser = $9d9445c3761e3e83$var$getAuthenticatedUser;
module.exports.getAuthenticatedUserData = $9d9445c3761e3e83$var$getAuthenticatedUserData;
module.exports.getIdToken = $9d9445c3761e3e83$var$getIdToken;
module.exports.getRefreshToken = $9d9445c3761e3e83$var$getRefreshToken;
module.exports.getTokens = $9d9445c3761e3e83$var$getTokens;
module.exports.hasTokens = $9d9445c3761e3e83$var$hasTokens;
module.exports.setAuthenticatedUser = $9d9445c3761e3e83$var$setAuthenticatedUser;
module.exports.setTokens = $9d9445c3761e3e83$var$setTokens;
module.exports.signIn = $9d9445c3761e3e83$var$signIn;
module.exports.signOut = $9d9445c3761e3e83$var$signOut;

var $9d9445c3761e3e83$var$_UserData = $9d9445c3761e3e83$var$_interopRequireDefault((parcelRequire("lIGFB")));

var $9d9445c3761e3e83$var$AmazonCognitoIdentity = $9d9445c3761e3e83$var$_interopRequireWildcard((parcelRequire("Ym30y")));

var $g3rxA = parcelRequire("g3rxA");

var $9d9445c3761e3e83$var$_Logger = $9d9445c3761e3e83$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $1XggU = parcelRequire("1XggU");
function $9d9445c3761e3e83$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9d9445c3761e3e83$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $9d9445c3761e3e83$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $9d9445c3761e3e83$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $9d9445c3761e3e83$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $9d9445c3761e3e83$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}

(parcelRequire("8vghX")).config();
function $9d9445c3761e3e83$var$authenticateCognito(callback) {
    var userPool = new $9d9445c3761e3e83$var$AmazonCognitoIdentity.CognitoUserPool({
        UserPoolId: "us-east-1_dghkmntO0",
        ClientId: "745dij271n5sgodrapt1ofef22"
    });
    var cognitoUser = userPool.getCurrentUser();
    if (cognitoUser === undefined || cognitoUser === null) {
        $9d9445c3761e3e83$var$_Logger["default"].error('Cognito user not found');
        $9d9445c3761e3e83$var$signOut();
    } else cognitoUser.getSession(function(errSession, cognitoTokens) {
        if (errSession) {
            $9d9445c3761e3e83$var$_Logger["default"].error('Get session failed', errSession);
            $9d9445c3761e3e83$var$signOut();
        }
        // Cognito JS library refresh token implicitly so we don't have to it ourselves,
        // however we need to set the token back into our localstorage to use later
        $9d9445c3761e3e83$var$setTokens(cognitoTokens);
        cognitoUser.getUserData(function(err, data) {
            if (err) {
                $9d9445c3761e3e83$var$_Logger["default"].error('Load user data failed', err);
                $9d9445c3761e3e83$var$signOut();
            } else {
                $9d9445c3761e3e83$var$_Logger["default"].info('Load user data successfully');
                $9d9445c3761e3e83$var$setAuthenticatedUser(cognitoUser, data);
                callback();
            }
        }, {
            bypassCache: true
        });
    });
}
function $9d9445c3761e3e83$var$fetchUserData() {
    $9d9445c3761e3e83$var$_Logger["default"].start('Fetch user data');
    var userPool = new $9d9445c3761e3e83$var$AmazonCognitoIdentity.CognitoUserPool({
        UserPoolId: "us-east-1_dghkmntO0",
        ClientId: "745dij271n5sgodrapt1ofef22"
    });
    var cognitoUser = userPool.getCurrentUser();
    cognitoUser.getSession(function() {
        cognitoUser.getUserData(function(err, data) {
            if (err) $9d9445c3761e3e83$var$_Logger["default"].error('Fetch user data', err);
            else {
                $9d9445c3761e3e83$var$_Logger["default"].done('Fetch user data', data);
                $9d9445c3761e3e83$var$setAuthenticatedUser(cognitoUser, data);
            }
        }, {
            bypassCache: true
        });
    });
}
function $9d9445c3761e3e83$var$hasTokens() {
    return localStorage.getItem('accessToken') !== null;
}
function $9d9445c3761e3e83$var$setAuthenticatedUser(cognitoUser, rawUserData) {
    $9d9445c3761e3e83$var$_Logger["default"].info('Set Authenticated user', cognitoUser);
    window.authenticatedUser = cognitoUser;
    $9d9445c3761e3e83$var$_Logger["default"].info('Set Authenticated user data', rawUserData);
    window.authenticatedUserData = new $9d9445c3761e3e83$var$_UserData["default"](rawUserData);
}
function $9d9445c3761e3e83$var$getAuthenticatedUser() {
    return window.authenticatedUser;
}
function $9d9445c3761e3e83$var$getAuthenticatedUserData() {
    return window.authenticatedUserData;
}
function $9d9445c3761e3e83$var$signIn(tokens) {
    $9d9445c3761e3e83$var$setTokens(tokens);
}
function $9d9445c3761e3e83$var$getIdToken() {
    return localStorage.getItem('idToken');
}
function $9d9445c3761e3e83$var$getAccessToken() {
    return localStorage.getItem('accessToken');
}
function $9d9445c3761e3e83$var$getRefreshToken() {
    return localStorage.getItem('refreshToken');
}
function $9d9445c3761e3e83$var$signOutReactApp() {
    // Signout client side
    $9d9445c3761e3e83$var$clearTokens();
    (0, $1XggU.clearAdvisorCustomLogin)();
    if ($9d9445c3761e3e83$var$getAuthenticatedUser() !== null && $9d9445c3761e3e83$var$getAuthenticatedUser() !== undefined) $9d9445c3761e3e83$var$getAuthenticatedUser().signOut();
}
function $9d9445c3761e3e83$var$signOut() {
    $9d9445c3761e3e83$var$_Logger["default"].start('Sign out');
    // Signout all external hosts
    return (0, $g3rxA.signOutExternalHost)().then(function() {
        $9d9445c3761e3e83$var$_Logger["default"].done('Sign out');
        $9d9445c3761e3e83$var$signOutReactApp();
        var params = new URLSearchParams(window.location.search);
        var advisorId = params.get('advisor_id');
        var url = '/';
        if (advisorId) // After signed out, if user is still on a subdomain ( can be detected by the query param "advisor_id" )
        // then we want to render the custom login page
        url += "?advisor_id=".concat(advisorId);
        location.href = url;
    })["catch"](function(err) {
        $9d9445c3761e3e83$var$_Logger["default"].done('Sign out external host', err);
        $9d9445c3761e3e83$var$signOutReactApp();
        location.href = '/';
    });
}
function $9d9445c3761e3e83$var$setTokens(tokens) {
    localStorage.setItem('idToken', tokens.idToken.jwtToken);
    localStorage.setItem('refreshToken', tokens.refreshToken.token);
    localStorage.setItem('accessToken', tokens.accessToken.jwtToken);
}
function $9d9445c3761e3e83$var$clearTokens(tokens) {
    localStorage.removeItem('idToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('accessToken');
}
function $9d9445c3761e3e83$var$getTokens() {
    return {
        idToken: localStorage.getItem('idToken'),
        refreshToken: localStorage.getItem('refreshToken'),
        accessToken: localStorage.getItem('accessToken')
    };
}

});
parcelRegister("lIGFB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $fcfece6e59701fc9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fcfece6e59701fc9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fcfece6e59701fc9$var$_typeof(o);
}
function $fcfece6e59701fc9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $fcfece6e59701fc9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $fcfece6e59701fc9$var$_toPropertyKey(o.key), o);
    }
}
function $fcfece6e59701fc9$var$_createClass(e, r, t) {
    return r && $fcfece6e59701fc9$var$_defineProperties(e.prototype, r), t && $fcfece6e59701fc9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $fcfece6e59701fc9$var$_toPropertyKey(t) {
    var i = $fcfece6e59701fc9$var$_toPrimitive(t, "string");
    return "symbol" == $fcfece6e59701fc9$var$_typeof(i) ? i : i + "";
}
function $fcfece6e59701fc9$var$_toPrimitive(t, r) {
    if ("object" != $fcfece6e59701fc9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fcfece6e59701fc9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fcfece6e59701fc9$var$UserData = module.exports["default"] = /*#__PURE__*/ function() {
    function UserData(userData) {
        $fcfece6e59701fc9$var$_classCallCheck(this, UserData);
        this.userData = userData;
    }
    return $fcfece6e59701fc9$var$_createClass(UserData, [
        {
            key: "getAttr",
            value: function getAttr(attrName) {
                var attr = this.userData.UserAttributes.filter(function(attr) {
                    return attr.Name === attrName;
                })[0];
                if (attr) return attr.Value;
            }
        },
        {
            key: "isSmsMfaActivated",
            value: function isSmsMfaActivated() {
                if (this.userData.UserMFASettingList) return this.userData.UserMFASettingList.indexOf('SMS_MFA') !== -1;
                else return false;
            }
        }
    ]);
}();

});

parcelRegister("Ym30y", function(module, exports) {

$parcel$export(module.exports, "AuthenticationDetails", () => (parcelRequire("5zoIb")).default);
$parcel$export(module.exports, "AuthenticationHelper", () => (parcelRequire("b4DK1")).default);
$parcel$export(module.exports, "CognitoAccessToken", () => (parcelRequire("bcFEY")).default);
$parcel$export(module.exports, "CognitoIdToken", () => (parcelRequire("cfFz4")).default);
$parcel$export(module.exports, "CognitoRefreshToken", () => (parcelRequire("gXTS7")).default);
$parcel$export(module.exports, "CognitoUser", () => (parcelRequire("9UvTj")).default);
$parcel$export(module.exports, "CognitoUserAttribute", () => (parcelRequire("4PRoF")).default);
$parcel$export(module.exports, "CognitoUserPool", () => (parcelRequire("foBd2")).default);
$parcel$export(module.exports, "CognitoUserSession", () => (parcelRequire("bbF2X")).default);
$parcel$export(module.exports, "CookieStorage", () => (parcelRequire("i2gj0")).default);
$parcel$export(module.exports, "DateHelper", () => (parcelRequire("ewYam")).default);
$parcel$export(module.exports, "appendToCognitoUserAgent", () => (parcelRequire("8ZOc6")).appendToCognitoUserAgent);
$parcel$export(module.exports, "WordArray", () => (parcelRequire("8gx9f")).default);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $5zoIb = parcelRequire("5zoIb");

var $b4DK1 = parcelRequire("b4DK1");

var $bcFEY = parcelRequire("bcFEY");

var $cfFz4 = parcelRequire("cfFz4");

var $gXTS7 = parcelRequire("gXTS7");

var $9UvTj = parcelRequire("9UvTj");

var $4PRoF = parcelRequire("4PRoF");

var $foBd2 = parcelRequire("foBd2");

var $bbF2X = parcelRequire("bbF2X");

var $i2gj0 = parcelRequire("i2gj0");

var $ewYam = parcelRequire("ewYam");

var $8ZOc6 = parcelRequire("8ZOc6");

var $8gx9f = parcelRequire("8gx9f");

});
parcelRegister("5zoIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $010becf709f0452a$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $010becf709f0452a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();

});

parcelRegister("b4DK1", function(module, exports) {

$parcel$export(module.exports, "default", () => $80fee53f057853d0$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $aXQL7 = parcelRequire("aXQL7");

var $3OBZa = parcelRequire("3OBZa");
parcelRequire("dOqqi");

var $dCBbD = parcelRequire("dCBbD");

var $WS9F7 = parcelRequire("WS9F7");

var $8gx9f = parcelRequire("8gx9f");

var $6BaWr = parcelRequire("6BaWr");
/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $80fee53f057853d0$var$randomBytes(nBytes) {
    return (0, $aXQL7.Buffer).from(new (0, $8gx9f.default)().random(nBytes).toString(), 'hex');
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $80fee53f057853d0$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $80fee53f057853d0$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $80fee53f057853d0$var$newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';
/** @class */ var $80fee53f057853d0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $6BaWr.default)($80fee53f057853d0$var$initN, 16);
        this.g = new (0, $6BaWr.default)('2', 16);
        this.k = new (0, $6BaWr.default)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $aXQL7.Buffer).from('Caldera Derived Key', 'utf8');
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $80fee53f057853d0$var$randomBytes(128).toString('hex');
        var randomBigInt = new (0, $6BaWr.default)(hexRandom, 16); // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $80fee53f057853d0$var$randomBytes(40).toString('base64');
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $80fee53f057853d0$var$randomBytes(16).toString('hex'); // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $6BaWr.default)(hexRandom, 16));
        this.g.modPow(new (0, $6BaWr.default)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $6BaWr.default).ZERO)) callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $6BaWr.default)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var str = buf instanceof (0, $aXQL7.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(buf) : buf;
        var hashHex = (0, (/*@__PURE__*/$parcel$interopDefault($dCBbD)))(str).toString();
        return new Array(64 - hashHex.length).join('0') + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $aXQL7.Buffer).from(hexStr, 'hex'));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsWordArray = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create((0, $aXQL7.Buffer).concat([
            this.infoBits,
            (0, $aXQL7.Buffer).from(String.fromCharCode(1), 'utf8')
        ]));
        var ikmWordArray = ikm instanceof (0, $aXQL7.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(ikm) : ikm;
        var saltWordArray = salt instanceof (0, $aXQL7.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(salt) : salt;
        var prk = (0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(ikmWordArray, saltWordArray);
        var hmac = (0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(infoBitsWordArray, prk);
        return (0, $aXQL7.Buffer).from(hmac.toString(), 'hex').slice(0, 16);
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $6BaWr.default).ZERO)) throw new Error('B cannot be zero.');
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $6BaWr.default).ZERO)) throw new Error('U cannot be zero.');
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $6BaWr.default)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $aXQL7.Buffer).from(_this4.padHex(sValue), 'hex'), (0, $aXQL7.Buffer).from(_this4.padHex(_this4.UValue), 'hex'));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $80fee53f057853d0$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $6BaWr.default))) throw new Error('Not a BigInteger');
        var isNegative = bigInt.compareTo((0, $6BaWr.default).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $80fee53f057853d0$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split('').map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return '0123456789ABCDEF'.charAt(invertedNibble);
            }).join('');
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $6BaWr.default)(invertedNibbles, 16).add((0, $6BaWr.default).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith('FF8')) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();

});
parcelRegister("aXQL7", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $7fb856e564cccfe9$export$a143d493d941bafc, (v) => $7fb856e564cccfe9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $7fb856e564cccfe9$export$f99ded8fe4b79145, (v) => $7fb856e564cccfe9$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $7fb856e564cccfe9$export$a143d493d941bafc;
var $7fb856e564cccfe9$export$e4cf37d7f6fb9e0a;
var $7fb856e564cccfe9$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $7fb856e564cccfe9$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");

var $767Wy = parcelRequire("767Wy");
$7fb856e564cccfe9$export$a143d493d941bafc = $7fb856e564cccfe9$var$Buffer;
$7fb856e564cccfe9$export$e4cf37d7f6fb9e0a = $7fb856e564cccfe9$var$SlowBuffer;
$7fb856e564cccfe9$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $7fb856e564cccfe9$var$typedArraySupport();
$7fb856e564cccfe9$export$599f31c3813fae4d = $7fb856e564cccfe9$var$kMaxLength();
function $7fb856e564cccfe9$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $7fb856e564cccfe9$var$kMaxLength() {
    return $7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $7fb856e564cccfe9$var$createBuffer(that, length) {
    if ($7fb856e564cccfe9$var$kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $7fb856e564cccfe9$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $7fb856e564cccfe9$var$Buffer(arg, encodingOrOffset, length) {
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $7fb856e564cccfe9$var$Buffer)) return new $7fb856e564cccfe9$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return $7fb856e564cccfe9$var$allocUnsafe(this, arg);
    }
    return $7fb856e564cccfe9$var$from(this, arg, encodingOrOffset, length);
}
$7fb856e564cccfe9$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$7fb856e564cccfe9$var$Buffer._augment = function(arr) {
    arr.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    return arr;
};
function $7fb856e564cccfe9$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return $7fb856e564cccfe9$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return $7fb856e564cccfe9$var$fromString(that, value, encodingOrOffset);
    return $7fb856e564cccfe9$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $7fb856e564cccfe9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $7fb856e564cccfe9$var$from(null, value, encodingOrOffset, length);
};
if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $7fb856e564cccfe9$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $7fb856e564cccfe9$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && $7fb856e564cccfe9$var$Buffer[Symbol.species] === $7fb856e564cccfe9$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($7fb856e564cccfe9$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $7fb856e564cccfe9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $7fb856e564cccfe9$var$alloc(that, size, fill, encoding) {
    $7fb856e564cccfe9$var$assertSize(size);
    if (size <= 0) return $7fb856e564cccfe9$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? $7fb856e564cccfe9$var$createBuffer(that, size).fill(fill, encoding) : $7fb856e564cccfe9$var$createBuffer(that, size).fill(fill);
    return $7fb856e564cccfe9$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $7fb856e564cccfe9$var$Buffer.alloc = function(size, fill, encoding) {
    return $7fb856e564cccfe9$var$alloc(null, size, fill, encoding);
};
function $7fb856e564cccfe9$var$allocUnsafe(that, size) {
    $7fb856e564cccfe9$var$assertSize(size);
    that = $7fb856e564cccfe9$var$createBuffer(that, size < 0 ? 0 : $7fb856e564cccfe9$var$checked(size) | 0);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $7fb856e564cccfe9$var$Buffer.allocUnsafe = function(size) {
    return $7fb856e564cccfe9$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $7fb856e564cccfe9$var$Buffer.allocUnsafeSlow = function(size) {
    return $7fb856e564cccfe9$var$allocUnsafe(null, size);
};
function $7fb856e564cccfe9$var$fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$7fb856e564cccfe9$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $7fb856e564cccfe9$var$byteLength(string, encoding) | 0;
    that = $7fb856e564cccfe9$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $7fb856e564cccfe9$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $7fb856e564cccfe9$var$checked(array.length) | 0;
    that = $7fb856e564cccfe9$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $7fb856e564cccfe9$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $7fb856e564cccfe9$var$fromArrayLike(that, array);
    return that;
}
function $7fb856e564cccfe9$var$fromObject(that, obj) {
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(obj)) {
        var len = $7fb856e564cccfe9$var$checked(obj.length) | 0;
        that = $7fb856e564cccfe9$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || $7fb856e564cccfe9$var$isnan(obj.length)) return $7fb856e564cccfe9$var$createBuffer(that, 0);
            return $7fb856e564cccfe9$var$fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && $767Wy(obj.data)) return $7fb856e564cccfe9$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function $7fb856e564cccfe9$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $7fb856e564cccfe9$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $7fb856e564cccfe9$var$kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function $7fb856e564cccfe9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $7fb856e564cccfe9$var$Buffer.alloc(+length);
}
$7fb856e564cccfe9$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$7fb856e564cccfe9$var$Buffer.compare = function compare(a, b) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(a) || !$7fb856e564cccfe9$var$Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$7fb856e564cccfe9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$7fb856e564cccfe9$var$Buffer.concat = function concat(list, length) {
    if (!$767Wy(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $7fb856e564cccfe9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $7fb856e564cccfe9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$7fb856e564cccfe9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $7fb856e564cccfe9$var$byteLength(string, encoding) {
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return $7fb856e564cccfe9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $7fb856e564cccfe9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $7fb856e564cccfe9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$7fb856e564cccfe9$var$Buffer.byteLength = $7fb856e564cccfe9$var$byteLength;
function $7fb856e564cccfe9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $7fb856e564cccfe9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $7fb856e564cccfe9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $7fb856e564cccfe9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $7fb856e564cccfe9$var$latin1Slice(this, start, end);
        case 'base64':
            return $7fb856e564cccfe9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $7fb856e564cccfe9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$7fb856e564cccfe9$var$Buffer.prototype._isBuffer = true;
function $7fb856e564cccfe9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$7fb856e564cccfe9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$7fb856e564cccfe9$var$swap(this, i, i + 1);
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $7fb856e564cccfe9$var$swap(this, i, i + 3);
        $7fb856e564cccfe9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $7fb856e564cccfe9$var$swap(this, i, i + 7);
        $7fb856e564cccfe9$var$swap(this, i + 1, i + 6);
        $7fb856e564cccfe9$var$swap(this, i + 2, i + 5);
        $7fb856e564cccfe9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return $7fb856e564cccfe9$var$utf8Slice(this, 0, length);
    return $7fb856e564cccfe9$var$slowToString.apply(this, arguments);
};
$7fb856e564cccfe9$var$Buffer.prototype.equals = function equals(b) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $7fb856e564cccfe9$var$Buffer.compare(this, b) === 0;
};
$7fb856e564cccfe9$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $7fb856e564cccfe9$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
$7fb856e564cccfe9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $7fb856e564cccfe9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $7fb856e564cccfe9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $7fb856e564cccfe9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $7fb856e564cccfe9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $7fb856e564cccfe9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$7fb856e564cccfe9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$7fb856e564cccfe9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $7fb856e564cccfe9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$7fb856e564cccfe9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $7fb856e564cccfe9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $7fb856e564cccfe9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $7fb856e564cccfe9$var$utf8Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $7fb856e564cccfe9$var$asciiWrite(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$asciiToBytes(string), buf, offset, length);
}
function $7fb856e564cccfe9$var$latin1Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$asciiWrite(buf, string, offset, length);
}
function $7fb856e564cccfe9$var$base64Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$base64ToBytes(string), buf, offset, length);
}
function $7fb856e564cccfe9$var$ucs2Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$7fb856e564cccfe9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $7fb856e564cccfe9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $7fb856e564cccfe9$var$utf8Write(this, string, offset, length);
        case 'ascii':
            return $7fb856e564cccfe9$var$asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return $7fb856e564cccfe9$var$latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $7fb856e564cccfe9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $7fb856e564cccfe9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$7fb856e564cccfe9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $7fb856e564cccfe9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $7fb856e564cccfe9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $7fb856e564cccfe9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $7fb856e564cccfe9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $7fb856e564cccfe9$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $7fb856e564cccfe9$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $7fb856e564cccfe9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $7fb856e564cccfe9$var$toHex(buf[i]);
    return out;
}
function $7fb856e564cccfe9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$7fb856e564cccfe9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $7fb856e564cccfe9$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $7fb856e564cccfe9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$7fb856e564cccfe9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$7fb856e564cccfe9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$7fb856e564cccfe9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$7fb856e564cccfe9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$7fb856e564cccfe9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$7fb856e564cccfe9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $7fb856e564cccfe9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $7fb856e564cccfe9$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $7fb856e564cccfe9$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $7fb856e564cccfe9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeFloat(this, value, offset, true, noAssert);
};
$7fb856e564cccfe9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeFloat(this, value, offset, false, noAssert);
};
function $7fb856e564cccfe9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeDouble(this, value, offset, true, noAssert);
};
$7fb856e564cccfe9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$7fb856e564cccfe9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$7fb856e564cccfe9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$7fb856e564cccfe9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $7fb856e564cccfe9$var$Buffer.isBuffer(val) ? val : $7fb856e564cccfe9$var$utf8ToBytes(new $7fb856e564cccfe9$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $7fb856e564cccfe9$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $7fb856e564cccfe9$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $7fb856e564cccfe9$var$stringtrim(str).replace($7fb856e564cccfe9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $7fb856e564cccfe9$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function $7fb856e564cccfe9$var$toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function $7fb856e564cccfe9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $7fb856e564cccfe9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $7fb856e564cccfe9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $7fb856e564cccfe9$var$base64ToBytes(str) {
    return $kuxul.toByteArray($7fb856e564cccfe9$var$base64clean(str));
}
function $7fb856e564cccfe9$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $7fb856e564cccfe9$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});

parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == '[object Array]';
};

});


parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("kjyEk"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("dOqqi", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("dCBbD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("WS9F7", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("6gSsW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("8gx9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $604987de3d14fe69$export$2e2bcd8739ae039);

var $fgwpu = parcelRequire("fgwpu");
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $604987de3d14fe69$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes; // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join('');
}
var $604987de3d14fe69$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $fgwpu.default)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $604987de3d14fe69$var$hexStringify(this);
    };
    return WordArray;
}();

});
parcelRegister("fgwpu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1d17d9b5b43e6ab$export$2e2bcd8739ae039);
var $b1d17d9b5b43e6ab$var$crypto; // Native crypto from window (Browser)
if (typeof window !== 'undefined' && window.crypto) $b1d17d9b5b43e6ab$var$crypto = window.crypto;
 // Native (experimental IE 11) crypto from window (Browser)
if (!$b1d17d9b5b43e6ab$var$crypto && typeof window !== 'undefined' && window.msCrypto) $b1d17d9b5b43e6ab$var$crypto = window.msCrypto;
 // Native crypto from global (NodeJS)
if (!$b1d17d9b5b43e6ab$var$crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) $b1d17d9b5b43e6ab$var$crypto = $parcel$global.crypto;
 // Native crypto import via require (NodeJS)

if (!$b1d17d9b5b43e6ab$var$crypto && true) try {
    $b1d17d9b5b43e6ab$var$crypto = (parcelRequire("kjyEk"));
} catch (err) {}
function $b1d17d9b5b43e6ab$export$2e2bcd8739ae039() {
    if ($b1d17d9b5b43e6ab$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $b1d17d9b5b43e6ab$var$crypto.getRandomValues === 'function') try {
            return $b1d17d9b5b43e6ab$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
         // Use randomBytes method (NodeJS)
        if (typeof $b1d17d9b5b43e6ab$var$crypto.randomBytes === 'function') try {
            return $b1d17d9b5b43e6ab$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error('Native crypto module could not be used to get secure random number.');
}

});


parcelRegister("6BaWr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cdeaf8f1e22336b$export$2e2bcd8739ae039);
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $4cdeaf8f1e22336b$export$2e2bcd8739ae039 = $4cdeaf8f1e22336b$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $4cdeaf8f1e22336b$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
} // return new, unset BigInteger
function $4cdeaf8f1e22336b$var$nbi() {
    return new $4cdeaf8f1e22336b$var$BigInteger(null);
} // Bits per digit
var $4cdeaf8f1e22336b$var$dbits; // JavaScript engine analysis
var $4cdeaf8f1e22336b$var$canary = 0xdeadbeefcafe;
var $4cdeaf8f1e22336b$var$j_lm = ($4cdeaf8f1e22336b$var$canary & 0xffffff) == 0xefcafe; // am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $4cdeaf8f1e22336b$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
} // am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $4cdeaf8f1e22336b$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
} // Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $4cdeaf8f1e22336b$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $4cdeaf8f1e22336b$var$inBrowser = typeof navigator !== 'undefined';
if ($4cdeaf8f1e22336b$var$inBrowser && $4cdeaf8f1e22336b$var$j_lm && navigator.appName == 'Microsoft Internet Explorer') {
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am2;
    $4cdeaf8f1e22336b$var$dbits = 30;
} else if ($4cdeaf8f1e22336b$var$inBrowser && $4cdeaf8f1e22336b$var$j_lm && navigator.appName != 'Netscape') {
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am1;
    $4cdeaf8f1e22336b$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am3;
    $4cdeaf8f1e22336b$var$dbits = 28;
}
$4cdeaf8f1e22336b$var$BigInteger.prototype.DB = $4cdeaf8f1e22336b$var$dbits;
$4cdeaf8f1e22336b$var$BigInteger.prototype.DM = (1 << $4cdeaf8f1e22336b$var$dbits) - 1;
$4cdeaf8f1e22336b$var$BigInteger.prototype.DV = 1 << $4cdeaf8f1e22336b$var$dbits;
var $4cdeaf8f1e22336b$var$BI_FP = 52;
$4cdeaf8f1e22336b$var$BigInteger.prototype.FV = Math.pow(2, $4cdeaf8f1e22336b$var$BI_FP);
$4cdeaf8f1e22336b$var$BigInteger.prototype.F1 = $4cdeaf8f1e22336b$var$BI_FP - $4cdeaf8f1e22336b$var$dbits;
$4cdeaf8f1e22336b$var$BigInteger.prototype.F2 = 2 * $4cdeaf8f1e22336b$var$dbits - $4cdeaf8f1e22336b$var$BI_FP; // Digit conversions
var $4cdeaf8f1e22336b$var$BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
var $4cdeaf8f1e22336b$var$BI_RC = new Array();
var $4cdeaf8f1e22336b$var$rr, $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = '0'.charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 0; $4cdeaf8f1e22336b$var$vv <= 9; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = 'a'.charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 10; $4cdeaf8f1e22336b$var$vv < 36; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = 'A'.charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 10; $4cdeaf8f1e22336b$var$vv < 36; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
function $4cdeaf8f1e22336b$var$int2char(n) {
    return $4cdeaf8f1e22336b$var$BI_RM.charAt(n);
}
function $4cdeaf8f1e22336b$var$intAt(s, i) {
    var c = $4cdeaf8f1e22336b$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
} // (protected) copy this to r
function $4cdeaf8f1e22336b$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
} // (protected) set from integer value x, -DV <= x < DV
function $4cdeaf8f1e22336b$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
} // return bigint initialized to value
function $4cdeaf8f1e22336b$var$nbv(i) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    r.fromInt(i);
    return r;
} // (protected) set from string and radix
function $4cdeaf8f1e22336b$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $4cdeaf8f1e22336b$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == '-') mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(this, this);
} // (protected) clamp off excess high words
function $4cdeaf8f1e22336b$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
} // (public) return string representation in given radix
function $4cdeaf8f1e22336b$var$bnToString(b) {
    if (this.s < 0) return '-' + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    var km = (1 << k) - 1, d, m = false, r = '', i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $4cdeaf8f1e22336b$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $4cdeaf8f1e22336b$var$int2char(d);
        }
    }
    return m ? r : '0';
} // (public) -this
function $4cdeaf8f1e22336b$var$bnNegate() {
    var r = $4cdeaf8f1e22336b$var$nbi();
    $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(this, r);
    return r;
} // (public) |this|
function $4cdeaf8f1e22336b$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
} // (public) return + if this > a, - if this < a, 0 if equal
function $4cdeaf8f1e22336b$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0){
        if ((r = this[i] - a[i]) != 0) return r;
    }
    return 0;
} // returns bit length of the integer x
function $4cdeaf8f1e22336b$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
} // (public) return the number of bits in "this"
function $4cdeaf8f1e22336b$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $4cdeaf8f1e22336b$var$nbits(this[this.t - 1] ^ this.s & this.DM);
} // (protected) r = this << n*DB
function $4cdeaf8f1e22336b$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
} // (protected) r = this >> n*DB
function $4cdeaf8f1e22336b$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
} // (protected) r = this << n
function $4cdeaf8f1e22336b$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
} // (protected) r = this >> n
function $4cdeaf8f1e22336b$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
} // (protected) r = this - a
function $4cdeaf8f1e22336b$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
} // (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $4cdeaf8f1e22336b$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(r, r);
} // (protected) r = this^2, r != this (HAC 14.16)
function $4cdeaf8f1e22336b$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
} // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $4cdeaf8f1e22336b$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $4cdeaf8f1e22336b$var$nbi();
    var y = $4cdeaf8f1e22336b$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $4cdeaf8f1e22336b$var$nbits(pm[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $4cdeaf8f1e22336b$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $4cdeaf8f1e22336b$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(r, r);
} // (public) this mod a
function $4cdeaf8f1e22336b$var$bnMod(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($4cdeaf8f1e22336b$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
} // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $4cdeaf8f1e22336b$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $4cdeaf8f1e22336b$var$bnEquals(a) {
    return this.compareTo(a) == 0;
} // (protected) r = this + a
function $4cdeaf8f1e22336b$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
} // (public) this + a
function $4cdeaf8f1e22336b$var$bnAdd(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.addTo(a, r);
    return r;
} // (public) this - a
function $4cdeaf8f1e22336b$var$bnSubtract(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.subTo(a, r);
    return r;
} // (public) this * a
function $4cdeaf8f1e22336b$var$bnMultiply(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.multiplyTo(a, r);
    return r;
} // (public) this / a
function $4cdeaf8f1e22336b$var$bnDivide(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.divRemTo(a, r, null);
    return r;
} // Montgomery reduction
function $4cdeaf8f1e22336b$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
} // xR mod m
function $4cdeaf8f1e22336b$var$montConvert(x) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($4cdeaf8f1e22336b$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
} // x/R mod m
function $4cdeaf8f1e22336b$var$montRevert(x) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
} // x = x/R mod m (HAC 14.32)
function $4cdeaf8f1e22336b$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM; // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t); // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
} // r = "x^2/R mod m"; x != r
function $4cdeaf8f1e22336b$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
} // r = "xy/R mod m"; x,y != r
function $4cdeaf8f1e22336b$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$4cdeaf8f1e22336b$var$Montgomery.prototype.convert = $4cdeaf8f1e22336b$var$montConvert;
$4cdeaf8f1e22336b$var$Montgomery.prototype.revert = $4cdeaf8f1e22336b$var$montRevert;
$4cdeaf8f1e22336b$var$Montgomery.prototype.reduce = $4cdeaf8f1e22336b$var$montReduce;
$4cdeaf8f1e22336b$var$Montgomery.prototype.mulTo = $4cdeaf8f1e22336b$var$montMulTo;
$4cdeaf8f1e22336b$var$Montgomery.prototype.sqrTo = $4cdeaf8f1e22336b$var$montSqrTo; // (public) this^e % m (HAC 14.85)
function $4cdeaf8f1e22336b$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $4cdeaf8f1e22336b$var$nbv(1), z = new $4cdeaf8f1e22336b$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6; // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $4cdeaf8f1e22336b$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $4cdeaf8f1e22336b$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $4cdeaf8f1e22336b$var$nbi(), t;
    i = $4cdeaf8f1e22336b$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
} // protected
$4cdeaf8f1e22336b$var$BigInteger.prototype.copyTo = $4cdeaf8f1e22336b$var$bnpCopyTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.fromInt = $4cdeaf8f1e22336b$var$bnpFromInt;
$4cdeaf8f1e22336b$var$BigInteger.prototype.fromString = $4cdeaf8f1e22336b$var$bnpFromString;
$4cdeaf8f1e22336b$var$BigInteger.prototype.clamp = $4cdeaf8f1e22336b$var$bnpClamp;
$4cdeaf8f1e22336b$var$BigInteger.prototype.dlShiftTo = $4cdeaf8f1e22336b$var$bnpDLShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.drShiftTo = $4cdeaf8f1e22336b$var$bnpDRShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.lShiftTo = $4cdeaf8f1e22336b$var$bnpLShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.rShiftTo = $4cdeaf8f1e22336b$var$bnpRShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.subTo = $4cdeaf8f1e22336b$var$bnpSubTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.multiplyTo = $4cdeaf8f1e22336b$var$bnpMultiplyTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.squareTo = $4cdeaf8f1e22336b$var$bnpSquareTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.divRemTo = $4cdeaf8f1e22336b$var$bnpDivRemTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.invDigit = $4cdeaf8f1e22336b$var$bnpInvDigit;
$4cdeaf8f1e22336b$var$BigInteger.prototype.addTo = $4cdeaf8f1e22336b$var$bnpAddTo; // public
$4cdeaf8f1e22336b$var$BigInteger.prototype.toString = $4cdeaf8f1e22336b$var$bnToString;
$4cdeaf8f1e22336b$var$BigInteger.prototype.negate = $4cdeaf8f1e22336b$var$bnNegate;
$4cdeaf8f1e22336b$var$BigInteger.prototype.abs = $4cdeaf8f1e22336b$var$bnAbs;
$4cdeaf8f1e22336b$var$BigInteger.prototype.compareTo = $4cdeaf8f1e22336b$var$bnCompareTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.bitLength = $4cdeaf8f1e22336b$var$bnBitLength;
$4cdeaf8f1e22336b$var$BigInteger.prototype.mod = $4cdeaf8f1e22336b$var$bnMod;
$4cdeaf8f1e22336b$var$BigInteger.prototype.equals = $4cdeaf8f1e22336b$var$bnEquals;
$4cdeaf8f1e22336b$var$BigInteger.prototype.add = $4cdeaf8f1e22336b$var$bnAdd;
$4cdeaf8f1e22336b$var$BigInteger.prototype.subtract = $4cdeaf8f1e22336b$var$bnSubtract;
$4cdeaf8f1e22336b$var$BigInteger.prototype.multiply = $4cdeaf8f1e22336b$var$bnMultiply;
$4cdeaf8f1e22336b$var$BigInteger.prototype.divide = $4cdeaf8f1e22336b$var$bnDivide;
$4cdeaf8f1e22336b$var$BigInteger.prototype.modPow = $4cdeaf8f1e22336b$var$bnModPow; // "constants"
$4cdeaf8f1e22336b$var$BigInteger.ZERO = $4cdeaf8f1e22336b$var$nbv(0);
$4cdeaf8f1e22336b$var$BigInteger.ONE = $4cdeaf8f1e22336b$var$nbv(1);

});


parcelRegister("bcFEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8281217ccf88c1bf$export$2e2bcd8739ae039);

var $5nZH5 = parcelRequire("5nZH5");
function $8281217ccf88c1bf$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8281217ccf88c1bf$var$_setPrototypeOf(subClass, superClass);
}
function $8281217ccf88c1bf$var$_setPrototypeOf(o, p) {
    $8281217ccf88c1bf$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8281217ccf88c1bf$var$_setPrototypeOf(o, p);
}
/** @class */ var $8281217ccf88c1bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $8281217ccf88c1bf$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || '') || this;
    }
    return CognitoAccessToken;
}((0, $5nZH5.default));

});
parcelRegister("5nZH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebef4e0e2340f79$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $aXQL7 = parcelRequire("aXQL7");
/** @class */ var $3ebef4e0e2340f79$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || '';
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split('.')[1];
        try {
            return JSON.parse((0, $aXQL7.Buffer).from(payload, 'base64').toString('utf8'));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();

});


parcelRegister("cfFz4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eb7209a41983bfc$export$2e2bcd8739ae039);

var $5nZH5 = parcelRequire("5nZH5");
function $8eb7209a41983bfc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8eb7209a41983bfc$var$_setPrototypeOf(subClass, superClass);
}
function $8eb7209a41983bfc$var$_setPrototypeOf(o, p) {
    $8eb7209a41983bfc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8eb7209a41983bfc$var$_setPrototypeOf(o, p);
}
/** @class */ var $8eb7209a41983bfc$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $8eb7209a41983bfc$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || '') || this;
    }
    return CognitoIdToken;
}((0, $5nZH5.default));

});

parcelRegister("gXTS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59d7f07074bc9f5$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $c59d7f07074bc9f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || '';
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();

});

parcelRegister("9UvTj", function(module, exports) {

$parcel$export(module.exports, "default", () => $737214f2f07cda56$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $aXQL7 = parcelRequire("aXQL7");

var $3OBZa = parcelRequire("3OBZa");
parcelRequire("dOqqi");

var $33Dov = parcelRequire("33Dov");

var $WS9F7 = parcelRequire("WS9F7");

var $6BaWr = parcelRequire("6BaWr");

var $b4DK1 = parcelRequire("b4DK1");

var $bcFEY = parcelRequire("bcFEY");

var $cfFz4 = parcelRequire("cfFz4");

var $gXTS7 = parcelRequire("gXTS7");

var $bbF2X = parcelRequire("bbF2X");

var $ewYam = parcelRequire("ewYam");

var $4PRoF = parcelRequire("4PRoF");

var $e0O2m = parcelRequire("e0O2m");
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $737214f2f07cda56$var$isBrowser = typeof navigator !== 'undefined';
var $737214f2f07cda56$var$userAgent = $737214f2f07cda56$var$isBrowser ? navigator.userAgent : 'nodejs';
/** @class */ var $737214f2f07cda56$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error('Username and Pool information are required.');
        this.username = data.Username || '';
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = 'USER_SRP_AUTH';
        this.storage = data.Storage || new (0, $e0O2m.default)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'CUSTOM_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === 'CUSTOM_CHALLENGE') {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === 'USER_PASSWORD_AUTH') return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === 'USER_SRP_AUTH' || this.authenticationFlowType === 'CUSTOM_AUTH') return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error('Authentication flow type is invalid.'));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $b4DK1.default)(this.pool.getUserPoolId().split('_')[1]);
        var dateHelper = new (0, $ewYam.default)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === 'CUSTOM_AUTH') authParameters.CHALLENGE_NAME = 'SRP_A';
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request('InitiateAuth', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $6BaWr.default)(challengeParameters.SRP_B, 16);
                salt = new (0, $6BaWr.default)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create((0, $aXQL7.Buffer).concat([
                        (0, $aXQL7.Buffer).from(_this2.pool.getUserPoolId().split('_')[1], 'utf8'),
                        (0, $aXQL7.Buffer).from(_this2.username, 'utf8'),
                        (0, $aXQL7.Buffer).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $aXQL7.Buffer).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($33Dov))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request('RespondToAuthChallenge', challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: 'PASSWORD_VERIFIER',
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error('PASSWORD parameter is required'));
            return;
        }
        var authenticationHelper = new (0, $b4DK1.default)(this.pool.getUserPoolId().split('_')[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'USER_PASSWORD_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
         // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === 'SMS_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'SELECT_MFA_TYPE') {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === 'MFA_SETUP') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === 'SOFTWARE_TOKEN_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'CUSTOM_CHALLENGE') {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === 'DEVICE_SRP_AUTH') {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $aXQL7.Buffer).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                PasswordVerifier: (0, $aXQL7.Buffer).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request('ConfirmDevice', {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $737214f2f07cda56$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error('New password is required.'));
        var authenticationHelper = new (0, $b4DK1.default)(this.pool.getUserPoolId().split('_')[1]);
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: 'NEW_PASSWORD_REQUIRED',
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $b4DK1.default)(this.deviceGroupKey);
        var dateHelper = new (0, $ewYam.default)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: 'DEVICE_SRP_AUTH',
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $6BaWr.default)(challengeParameters.SRP_B, 16);
                var salt = new (0, $6BaWr.default)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create((0, $aXQL7.Buffer).concat([
                        (0, $aXQL7.Buffer).from(_this6.deviceGroupKey, 'utf8'),
                        (0, $aXQL7.Buffer).from(_this6.deviceKey, 'utf8'),
                        (0, $aXQL7.Buffer).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $aXQL7.Buffer).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($33Dov))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request('RespondToAuthChallenge', jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmSignUp', jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $b4DK1.default)(this.pool.getUserPoolId().split('_')[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: 'CUSTOM_CHALLENGE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || 'SMS_MFA';
        if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === 'DEVICE_SRP_AUTH') {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $b4DK1.default)(_this8.pool.getUserPoolId().split('_')[1]);
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $aXQL7.Buffer).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                    PasswordVerifier: (0, $aXQL7.Buffer).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request('ConfirmDevice', {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $737214f2f07cda56$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('ChangePassword', {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: 'SMS',
            AttributeName: 'phone_number'
        };
        mfaOptions.push(mfaEnabled);
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('SetUserMFAPreference', {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('UpdateUserAttributes', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
             // update cached user
            return _this10.getUserData(function() {
                return callback(null, 'SUCCESS');
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $4PRoF.default)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error('User is not authenticated'), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUserAttributes', {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
             // update cached user
            return _this14.getUserData(function() {
                return callback(null, 'SUCCESS');
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request('ResendConfirmationCode', jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error('Username is null. Cannot retrieve a new session'), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $cfFz4.default)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $bcFEY.default)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $gXTS7.default)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $bbF2X.default)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: 'REFRESH_TOKEN_AUTH',
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === 'NotAuthorizedException') _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $cfFz4.default)(authResult);
        var accessToken = new (0, $bcFEY.default)(authResult);
        var refreshToken = new (0, $gXTS7.default)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $bbF2X.default)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ForgotPassword', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmForgotPassword', jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetUserAttributeVerificationCode', {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('VerifyUserAttribute', {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('ForgetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'not_remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request('ListDevices', requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GlobalSignOut', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== 'function') {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== 'function') throw new Error('Invalid revokeTokenCallback. It should be a function.');
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error('User is not authenticated');
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error('No Access token available');
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === 'function') try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {}
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry('RevokeToken', {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: 'SELECT_MFA_TYPE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === 'SMS_MFA') return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === 'SOFTWARE_TOKEN_MFA') return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('AssociateSoftwareToken', {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request('AssociateSoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('VerifySoftwareToken', {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: 'MFA_SETUP',
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request('RespondToAuthChallenge', jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request('VerifySoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();

});
parcelRegister("33Dov", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("bbF2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $82508fd376aeac3c$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $82508fd376aeac3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error('Id token and Access Token must be present.');
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();

});

parcelRegister("ewYam", function(module, exports) {

$parcel$export(module.exports, "default", () => $a942b99a35e53a72$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $a942b99a35e53a72$var$monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
var $a942b99a35e53a72$var$weekNames = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
/** @class */ var $a942b99a35e53a72$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $a942b99a35e53a72$var$weekNames[now.getUTCDay()];
        var month = $a942b99a35e53a72$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear(); // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();

});

parcelRegister("4PRoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $38555859a52f4863$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $38555859a52f4863$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || '';
        this.Value = Value || '';
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();

});

parcelRegister("e0O2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $a337e11db75e0691$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $a337e11db75e0691$var$dataMemory = {};
var $a337e11db75e0691$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $a337e11db75e0691$var$dataMemory[key] = value;
        return $a337e11db75e0691$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($a337e11db75e0691$var$dataMemory, key) ? $a337e11db75e0691$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $a337e11db75e0691$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $a337e11db75e0691$var$dataMemory = {};
        return $a337e11db75e0691$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $a337e11db75e0691$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.cognito.test-ls', 1);
            this.storageWindow.removeItem('aws.cognito.test-ls');
        } catch (exception) {
            this.storageWindow = $a337e11db75e0691$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

});


parcelRegister("foBd2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b355f5e976985f5d$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $g3D2k = parcelRequire("g3D2k");

var $9UvTj = parcelRequire("9UvTj");

var $e0O2m = parcelRequire("e0O2m");
var $b355f5e976985f5d$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $b355f5e976985f5d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error('Both UserPoolId and ClientId are required.');
        if (UserPoolId.length > $b355f5e976985f5d$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error('Invalid UserPoolId format.');
        var region = UserPoolId.split('_')[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $g3D2k.default)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $e0O2m.default)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request('SignUp', jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $9UvTj.default)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $9UvTj.default)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();

});
parcelRegister("g3D2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb0b3502dd43cbf5$export$2e2bcd8739ae039);
parcelRequire("5MPpy");

var $8ZOc6 = parcelRequire("8ZOc6");
function $bb0b3502dd43cbf5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $bb0b3502dd43cbf5$var$_setPrototypeOf(subClass, superClass);
}
function $bb0b3502dd43cbf5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bb0b3502dd43cbf5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bb0b3502dd43cbf5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bb0b3502dd43cbf5$var$_construct(Class, arguments, $bb0b3502dd43cbf5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bb0b3502dd43cbf5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bb0b3502dd43cbf5$var$_wrapNativeSuper(Class);
}
function $bb0b3502dd43cbf5$var$_construct(Parent, args, Class) {
    if ($bb0b3502dd43cbf5$var$_isNativeReflectConstruct()) $bb0b3502dd43cbf5$var$_construct = Reflect.construct.bind();
    else $bb0b3502dd43cbf5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bb0b3502dd43cbf5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bb0b3502dd43cbf5$var$_construct.apply(null, arguments);
}
function $bb0b3502dd43cbf5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bb0b3502dd43cbf5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bb0b3502dd43cbf5$var$_setPrototypeOf(o, p) {
    $bb0b3502dd43cbf5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bb0b3502dd43cbf5$var$_setPrototypeOf(o, p);
}
function $bb0b3502dd43cbf5$var$_getPrototypeOf(o) {
    $bb0b3502dd43cbf5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bb0b3502dd43cbf5$var$_getPrototypeOf(o);
}
var $bb0b3502dd43cbf5$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $bb0b3502dd43cbf5$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $bb0b3502dd43cbf5$var$_wrapNativeSuper(Error));
/** @class */ var $bb0b3502dd43cbf5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $bb0b3502dd43cbf5$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $bb0b3502dd43cbf5$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            'Content-Type': 'application/x-amz-json-1.1',
            'X-Amz-Target': "AWSCognitoIdentityProviderService." + operation,
            'X-Amz-User-Agent': (0, $8ZOc6.default).prototype.userAgent
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error('Network error');
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data; // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split('#').pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get('x-amzn-errortype')) try {
                var code = response.headers.get('x-amzn-errortype').split(':')[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            } // otherwise check if error is Network error
            else if (err instanceof Error && err.message === 'Network error') err.code = 'NetworkError';
            return callback(err);
        });
    };
    return Client;
}();
var $bb0b3502dd43cbf5$var$logger = {
    debug: function debug() {}
};
/**
 * For now, all errors are retryable.
 */ var $bb0b3502dd43cbf5$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $bb0b3502dd43cbf5$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $bb0b3502dd43cbf5$var$_wrapNativeSuper(Error));
var $bb0b3502dd43cbf5$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = 'nonRetryable';
    return obj && obj[key];
};
function $bb0b3502dd43cbf5$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== 'function') throw Error('functionToRetry must be a function');
    $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $bb0b3502dd43cbf5$var$logger.debug("error on " + functionToRetry.name, err);
        if ($bb0b3502dd43cbf5$var$isNonRetryableError(err)) {
            $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $bb0b3502dd43cbf5$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $bb0b3502dd43cbf5$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $bb0b3502dd43cbf5$var$MAX_DELAY_MS = 300000;
function $bb0b3502dd43cbf5$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $bb0b3502dd43cbf5$var$MAX_DELAY_MS;
    return $bb0b3502dd43cbf5$var$retry(functionToRetry, args, $bb0b3502dd43cbf5$var$jitteredBackoff(maxDelayMs));
}

});
parcelRegister("5MPpy", function(module, exports) {


module.exports = self.fetch || (self.fetch = (parcelRequire("laOt8")).default || (parcelRequire("laOt8")));

});
parcelRegister("laOt8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f6a1ae3267718cab$export$2e2bcd8739ae039);
function $f6a1ae3267718cab$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});


parcelRegister("8ZOc6", function(module, exports) {

$parcel$export(module.exports, "appendToCognitoUserAgent", () => $68caf4bd6c7da8b9$export$ad34c5a3baecdb02);
$parcel$export(module.exports, "default", () => $68caf4bd6c7da8b9$export$2e2bcd8739ae039);

var $hUce8 = parcelRequire("hUce8");
function $68caf4bd6c7da8b9$var$UserAgent() {} // public
$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = (0, $hUce8.getUserAgent)();
var $68caf4bd6c7da8b9$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent && !$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent.includes(content)) $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent.concat(' ', content);
    if (!$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent || $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent === '') $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = content;
}; // class for defining the amzn user-agent
var $68caf4bd6c7da8b9$export$2e2bcd8739ae039 = $68caf4bd6c7da8b9$var$UserAgent;

});
parcelRegister("hUce8", function(module, exports) {

$parcel$export(module.exports, "getUserAgent", () => $d09126a5f5299c10$export$7935961ef7719cb0);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $OhSBJ = parcelRequire("OhSBJ");
var $d09126a5f5299c10$var$BASE_USER_AGENT = "aws-amplify/" + (0, $OhSBJ.version);
var $d09126a5f5299c10$export$2dffd0b5373a4389 = {
    userAgent: $d09126a5f5299c10$var$BASE_USER_AGENT + " js",
    product: '',
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== 'undefined' && navigator.product) {
    $d09126a5f5299c10$export$2dffd0b5373a4389.product = navigator.product || '';
    $d09126a5f5299c10$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case 'ReactNative':
            $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent = $d09126a5f5299c10$var$BASE_USER_AGENT + " react-native";
            $d09126a5f5299c10$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent = $d09126a5f5299c10$var$BASE_USER_AGENT + " js";
            $d09126a5f5299c10$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $d09126a5f5299c10$export$7935961ef7719cb0 = function getUserAgent() {
    return $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $d09126a5f5299c10$export$2e2bcd8739ae039 = $d09126a5f5299c10$export$2dffd0b5373a4389;

});
parcelRegister("OhSBJ", function(module, exports) {

$parcel$export(module.exports, "version", () => $09728a2d1518e4a6$export$83d89fbfd8236492);
// generated by genversion
var $09728a2d1518e4a6$export$83d89fbfd8236492 = '5.0.4';

});





parcelRegister("i2gj0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2150fd716ee36a9$export$2e2bcd8739ae039);

var $eZeDV = parcelRequire("eZeDV");
/** @class */ var $d2150fd716ee36a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   */ function CookieStorage(data) {
        if (data.domain) this.domain = data.domain;
        else throw new Error('The domain of cookieStorage can not be undefined.');
        if (data.path) this.path = data.path;
        else this.path = '/';
        if (Object.prototype.hasOwnProperty.call(data, 'expires')) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, 'secure')) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, 'sameSite')) {
            if (![
                'strict',
                'lax',
                'none'
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === 'none' && !this.secure) throw new Error('sameSite = None requires the Secure attribute in latest browser versions.');
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $eZeDV.set(key, value, options);
        return $eZeDV.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $eZeDV.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $eZeDV.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $eZeDV.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();

});
parcelRegister("eZeDV", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});



parcelRegister("1XggU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAdvisorCustomLogin = $16c7ec5df7728577$var$clearAdvisorCustomLogin;
module.exports.getAdvisorCustomLogin = $16c7ec5df7728577$var$getAdvisorCustomLogin;
module.exports.setAdvisorCustomLogin = $16c7ec5df7728577$var$setAdvisorCustomLogin;

var $16c7ec5df7728577$var$_Logger = $16c7ec5df7728577$var$_interopRequireDefault((parcelRequire("2ChR8")));
function $16c7ec5df7728577$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $16c7ec5df7728577$var$setAdvisorCustomLogin() {
    var query = new URLSearchParams(location.search);
    var advisorId = query.get('advisor_id');
    if (advisorId) {
        localStorage.setItem('customLoginAdvisorId', advisorId);
        $16c7ec5df7728577$var$_Logger["default"].info('Set customLoginAdvisorId', advisorId);
    }
}
function $16c7ec5df7728577$var$getAdvisorCustomLogin() {
    return localStorage.getItem('customLoginAdvisorId');
}
function $16c7ec5df7728577$var$clearAdvisorCustomLogin() {
    return localStorage.removeItem('customLoginAdvisorId');
}

});



parcelRegister("5LA7J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $432d5cf7f6952e2e$var$_default = module.exports["default"] = {
    UPDATE_FAILED: 'UPDATE_FAILED',
    UPDATE_SUCCESSFULLY: 'UPDATE_SUCCESSFULLY',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    RESET_PASSWORD_SUCCESSFULLY: 'RESET_PASSWORD_SUCCESSFULLY',
    USER_NOT_CONFIRMED: 'USER_NOT_CONFIRMED',
    LOGIN_SUCCESSFULLY: 'LOGIN_SUCCESSFULLY',
    RESENT_CONFIRMATION: 'RESENT_CONFIRMATION',
    CONFIRM_SIGN_UP_SUCCESSFULLY: 'CONFIRM_SIGN_UP_SUCCESSFULLY',
    FLASH: 'FLASH'
};

});

parcelRegister("1KSzM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $14746bf92d7161f0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $14746bf92d7161f0$var$noop = ()=>{};
function $14746bf92d7161f0$var$useInterval(callback, delay, immediate) {
    const savedCallback = (0, $acw62.useRef)($14746bf92d7161f0$var$noop);
    (0, $acw62.useEffect)(()=>{
        savedCallback.current = callback;
    });
    (0, $acw62.useEffect)(()=>{
        if (!immediate) return;
        if (delay === null || delay === false) return;
        savedCallback.current();
    }, [
        immediate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (delay === null || delay === false) return undefined;
        const tick = ()=>savedCallback.current();
        const id = setInterval(tick, delay);
        return ()=>clearInterval(id);
    }, [
        delay
    ]);
}
function $14746bf92d7161f0$var$randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
const $14746bf92d7161f0$var$LoadingBar = (0, $acw62.forwardRef)(({ progress: progress, height: _height = 2, className: _className = '', color: _color = 'red', background: _background = 'transparent', onLoaderFinished: onLoaderFinished, transitionTime: _transitionTime = 300, loaderSpeed: _loaderSpeed = 500, waitingTime: _waitingTime = 1000, shadow: _shadow = true, containerStyle: _containerStyle = {}, style: _style = {}, shadowStyle: shadowStyleProp = {}, containerClassName: _containerClassName = '' }, ref)=>{
    const isMounted = (0, $acw62.useRef)(false);
    const [localProgress, localProgressSet] = (0, $acw62.useState)(0);
    const [pressedContinuous, setPressedContinuous] = (0, $acw62.useState)({
        active: false,
        startingValue: 20,
        refreshRate: 1000
    });
    const [usingProps, setUsingProps] = (0, $acw62.useState)(false);
    const [pressedStaticStart, setStaticStartPressed] = (0, $acw62.useState)({
        active: false,
        value: 20
    });
    const initialLoaderStyle = {
        height: '100%',
        background: _color,
        transition: `all ${_loaderSpeed}ms ease`,
        width: '0%'
    };
    const loaderContainerStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        height: _height,
        background: _background,
        zIndex: 99999999999,
        width: "100%"
    };
    const initialShadowStyles = {
        boxShadow: `0 0 10px ${_color}, 0 0 10px ${_color}`,
        width: '5%',
        opacity: 1,
        position: 'absolute',
        height: '100%',
        transition: `all ${_loaderSpeed}ms ease`,
        transform: 'rotate(3deg) translate(0px, -4px)',
        left: '-10rem'
    };
    const [loaderStyle, loaderStyleSet] = (0, $acw62.useState)(initialLoaderStyle);
    const [shadowStyle, shadowStyleSet] = (0, $acw62.useState)(initialShadowStyles);
    (0, $acw62.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            continuousStart (startingValue, refreshRate = 1000) {
                if (pressedStaticStart.active) return;
                if (usingProps) {
                    console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
                    return;
                }
                const val = startingValue || $14746bf92d7161f0$var$randomInt(10, 20);
                setPressedContinuous({
                    active: true,
                    refreshRate: refreshRate,
                    startingValue: startingValue
                });
                localProgressSet(val);
                checkIfFull(val);
            },
            staticStart (startingValue) {
                if (pressedContinuous.active) return;
                if (usingProps) {
                    console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
                    return;
                }
                const val = startingValue || $14746bf92d7161f0$var$randomInt(30, 50);
                setStaticStartPressed({
                    active: true,
                    value: val
                });
                localProgressSet(val);
                checkIfFull(val);
            },
            complete () {
                if (usingProps) {
                    console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
                    return;
                }
                localProgressSet(100);
                checkIfFull(100);
            }
        }));
    (0, $acw62.useEffect)(()=>{
        loaderStyleSet({
            ...loaderStyle,
            background: _color
        });
        shadowStyleSet({
            ...shadowStyle,
            boxShadow: `0 0 10px ${_color}, 0 0 5px ${_color}`
        });
    }, [
        _color
    ]);
    (0, $acw62.useEffect)(()=>{
        if (ref) {
            if (ref && progress !== undefined) {
                console.warn('react-top-loading-bar: You can\'t use both controlling by props and ref methods to control the bar! Please use only props or only ref methods! Ref methods will override props if "ref" property is available.');
                return;
            }
            checkIfFull(localProgress);
            setUsingProps(false);
        } else {
            if (progress) checkIfFull(progress);
            setUsingProps(true);
        }
    }, [
        progress
    ]);
    const checkIfFull = (_progress)=>{
        if (_progress >= 100) {
            loaderStyleSet({
                ...loaderStyle,
                width: '100%'
            });
            if (_shadow) shadowStyleSet({
                ...shadowStyle,
                left: _progress - 10 + '%'
            });
            setTimeout(()=>{
                if (!isMounted.current) return;
                loaderStyleSet({
                    ...loaderStyle,
                    opacity: 0,
                    width: '100%',
                    transition: `all ${_transitionTime}ms ease-out`,
                    color: _color
                });
                setTimeout(()=>{
                    if (!isMounted.current) return;
                    if (pressedContinuous.active) {
                        setPressedContinuous({
                            ...pressedContinuous,
                            active: false
                        });
                        localProgressSet(0);
                        checkIfFull(0);
                    }
                    if (pressedStaticStart.active) {
                        setStaticStartPressed({
                            ...pressedStaticStart,
                            active: false
                        });
                        localProgressSet(0);
                        checkIfFull(0);
                    }
                    if (onLoaderFinished) onLoaderFinished();
                    localProgressSet(0);
                    checkIfFull(0);
                }, _transitionTime);
            }, _waitingTime);
        } else {
            loaderStyleSet((_loaderStyle)=>{
                return {
                    ..._loaderStyle,
                    width: _progress + '%',
                    opacity: 1,
                    transition: _progress > 0 ? `all ${_loaderSpeed}ms ease` : ''
                };
            });
            if (_shadow) shadowStyleSet({
                ...shadowStyle,
                left: _progress - 5.5 + '%',
                transition: _progress > 0 ? `all ${_loaderSpeed}ms ease` : ''
            });
        }
    };
    $14746bf92d7161f0$var$useInterval(()=>{
        const random = $14746bf92d7161f0$var$randomInt(10, 20);
        if (localProgress + random < 90) {
            localProgressSet(localProgress + random);
            checkIfFull(localProgress + random);
        }
    }, pressedContinuous.active ? pressedContinuous.refreshRate : null);
    return (0, $acw62.createElement)("div", {
        className: _containerClassName,
        style: {
            ...loaderContainerStyle,
            ..._containerStyle
        }
    }, (0, $acw62.createElement)("div", {
        className: _className,
        style: {
            ...loaderStyle,
            ..._style
        }
    }, _shadow ? (0, $acw62.createElement)("div", {
        style: {
            ...shadowStyle,
            ...shadowStyleProp
        }
    }) : null));
});
var $14746bf92d7161f0$export$2e2bcd8739ae039 = $14746bf92d7161f0$var$LoadingBar;

});


parcelRegister("a0NPf", function(module, exports) {
"use strict";
function $74a08dd07d2c8ee0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $74a08dd07d2c8ee0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $74a08dd07d2c8ee0$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $74a08dd07d2c8ee0$var$NewPasswordForm;

var $74a08dd07d2c8ee0$var$_react = $74a08dd07d2c8ee0$var$_interopRequireWildcard((parcelRequire("acw62")));

var $74a08dd07d2c8ee0$var$alertStyles = $74a08dd07d2c8ee0$var$_interopRequireWildcard((parcelRequire("jbsrN")));

var $74a08dd07d2c8ee0$var$styles = $74a08dd07d2c8ee0$var$_interopRequireWildcard((parcelRequire("kMVI2")));

var $g3rxA = parcelRequire("g3rxA");

var $dwN01 = parcelRequire("dwN01");

var $74a08dd07d2c8ee0$var$_Footer = $74a08dd07d2c8ee0$var$_interopRequireDefault((parcelRequire("8ALkM")));

var $74a08dd07d2c8ee0$var$_reactTopLoadingBar = $74a08dd07d2c8ee0$var$_interopRequireDefault((parcelRequire("1KSzM")));

var $74a08dd07d2c8ee0$var$_AlertTypes = $74a08dd07d2c8ee0$var$_interopRequireDefault((parcelRequire("5LA7J")));

var $74a08dd07d2c8ee0$var$_MfaForm = $74a08dd07d2c8ee0$var$_interopRequireDefault((parcelRequire("gwdxu")));
function $74a08dd07d2c8ee0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $74a08dd07d2c8ee0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($74a08dd07d2c8ee0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $74a08dd07d2c8ee0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $74a08dd07d2c8ee0$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $74a08dd07d2c8ee0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $74a08dd07d2c8ee0$var$_slicedToArray(r, e) {
    return $74a08dd07d2c8ee0$var$_arrayWithHoles(r) || $74a08dd07d2c8ee0$var$_iterableToArrayLimit(r, e) || $74a08dd07d2c8ee0$var$_unsupportedIterableToArray(r, e) || $74a08dd07d2c8ee0$var$_nonIterableRest();
}
function $74a08dd07d2c8ee0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $74a08dd07d2c8ee0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $74a08dd07d2c8ee0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $74a08dd07d2c8ee0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $74a08dd07d2c8ee0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $74a08dd07d2c8ee0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $74a08dd07d2c8ee0$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

if (null) null.accept("../SharedCss/alert.css", function() {
    (parcelRequire("jbsrN"));
});

(parcelRequire("8vghX")).config();
function $74a08dd07d2c8ee0$var$NewPasswordForm(props) {
    var cognitoUser = props.cognitoUser, sessionUserAttributes = props.sessionUserAttributes;
    var _useState = (0, $74a08dd07d2c8ee0$var$_react.useState)(''), _useState2 = $74a08dd07d2c8ee0$var$_slicedToArray(_useState, 2), password = _useState2[0], setPassword = _useState2[1];
    var _useState3 = (0, $74a08dd07d2c8ee0$var$_react.useState)(''), _useState4 = $74a08dd07d2c8ee0$var$_slicedToArray(_useState3, 2), errorMessage = _useState4[0], setErrorMessage = _useState4[1];
    var _useState5 = (0, $74a08dd07d2c8ee0$var$_react.useState)(''), _useState6 = $74a08dd07d2c8ee0$var$_slicedToArray(_useState5, 2), confirmation = _useState6[0], setConfirmation = _useState6[1];
    var _useState7 = (0, $74a08dd07d2c8ee0$var$_react.useState)(''), _useState8 = $74a08dd07d2c8ee0$var$_slicedToArray(_useState7, 2), alertType = _useState8[0], setAlertType = _useState8[1];
    var _useState9 = (0, $74a08dd07d2c8ee0$var$_react.useState)(false), _useState10 = $74a08dd07d2c8ee0$var$_slicedToArray(_useState9, 2), showMfaForm = _useState10[0], setShowMfaForm = _useState10[1];
    var _useState11 = (0, $74a08dd07d2c8ee0$var$_react.useState)(''), _useState12 = $74a08dd07d2c8ee0$var$_slicedToArray(_useState11, 2), session = _useState12[0], setSession = _useState12[1];
    var _useState13 = (0, $74a08dd07d2c8ee0$var$_react.useState)(''), _useState14 = $74a08dd07d2c8ee0$var$_slicedToArray(_useState13, 2), destination = _useState14[0], setDestination = _useState14[1];
    var loadingRef = (0, $74a08dd07d2c8ee0$var$_react.useRef)(null);
    var handleSubmit = function handleSubmit(e) {
        e.preventDefault();
        if (password !== confirmation) {
            setAlertType($74a08dd07d2c8ee0$var$_AlertTypes["default"].UPDATE_FAILED);
            setErrorMessage('Password and password confirmation do not match');
            return false;
        }
        if (password.trim().length === 0) {
            setAlertType($74a08dd07d2c8ee0$var$_AlertTypes["default"].UPDATE_FAILED);
            setErrorMessage('Please enter your password');
            return false;
        }
        loadingRef.current.continuousStart();
        // Make sure these attributes not submitted along with the password reset request, otherwise
        // it will return an error.
        delete sessionUserAttributes.phone_number;
        delete sessionUserAttributes.phone_number_verified;
        cognitoUser.completeNewPasswordChallenge(password, sessionUserAttributes, {
            onSuccess: function onSuccess(tokens) {
                (0, $dwN01.signIn)(tokens);
                (0, $g3rxA.signInExternalHost)().then(function() {
                    loadingRef.current.complete();
                });
            },
            mfaRequired: function mfaRequired(codeDeliveryDetails, params) {
                setSession(cognitoUser);
                setDestination(params.CODE_DELIVERY_DESTINATION);
                setShowMfaForm(true);
            },
            onFailure: function onFailure(err) {
                loadingRef.current.complete();
                setAlertType($74a08dd07d2c8ee0$var$_AlertTypes["default"].UPDATE_FAILED);
                setErrorMessage(err.message);
            }
        });
    };
    var renderAlert = function renderAlert() {
        if (alertType === $74a08dd07d2c8ee0$var$_AlertTypes["default"].UPDATE_FAILED) return /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("div", {
            className: [
                $74a08dd07d2c8ee0$var$alertStyles.alert,
                $74a08dd07d2c8ee0$var$alertStyles.error
            ].join(' ')
        }, errorMessage);
    };
    if (showMfaForm) return /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement($74a08dd07d2c8ee0$var$_MfaForm["default"], {
        cognitoUser: session,
        destination: destination
    });
    else return /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("div", {
        className: $74a08dd07d2c8ee0$var$styles.container
    }, renderAlert(), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement($74a08dd07d2c8ee0$var$_reactTopLoadingBar["default"], {
        color: "#f11946",
        ref: loadingRef
    }), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("div", {
        className: $74a08dd07d2c8ee0$var$styles.header
    }, /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("div", {
        className: $74a08dd07d2c8ee0$var$styles.logo
    }, /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("h1", null, "Blueleaf")), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("div", {
        className: $74a08dd07d2c8ee0$var$styles.header_text
    }, /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("h2", null, "Set your new password"))), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("div", {
        className: $74a08dd07d2c8ee0$var$styles.form_container
    }, /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("form", {
        id: "new-password-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("div", {
        className: $74a08dd07d2c8ee0$var$styles.fieldset
    }, /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("label", {
        className: $74a08dd07d2c8ee0$var$styles.label
    }, "Password"), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("input", {
        className: $74a08dd07d2c8ee0$var$styles.input_field,
        id: "password",
        type: "password",
        value: password,
        onChange: function onChange(e) {
            return setPassword(e.target.value);
        }
    })), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("div", {
        className: $74a08dd07d2c8ee0$var$styles.fieldset
    }, /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("label", {
        className: $74a08dd07d2c8ee0$var$styles.label
    }, "Confirm your new password"), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("input", {
        className: $74a08dd07d2c8ee0$var$styles.input_field,
        type: "password",
        value: confirmation,
        onChange: function onChange(e) {
            return setConfirmation(e.target.value);
        }
    })), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("input", {
        id: "submit-btn",
        className: $74a08dd07d2c8ee0$var$styles.submit_btn,
        type: "submit",
        value: "Set"
    }), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement("a", {
        id: "sign-in-btn",
        className: $74a08dd07d2c8ee0$var$styles.link,
        href: "/"
    }, "Back to sign in"))), /*#__PURE__*/ $74a08dd07d2c8ee0$var$_react["default"].createElement($74a08dd07d2c8ee0$var$_Footer["default"], null));
}

});

parcelRegister("f2HJd", function(module, exports) {
"use strict";
function $af38f677c7a27790$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $af38f677c7a27790$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $af38f677c7a27790$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $af38f677c7a27790$var$CustomLogin;

var $af38f677c7a27790$var$_react = $af38f677c7a27790$var$_interopRequireWildcard((parcelRequire("acw62")));

var $qkIgO = parcelRequire("qkIgO");

var $af38f677c7a27790$var$_AdvisorGenericLogin = $af38f677c7a27790$var$_interopRequireDefault((parcelRequire("6SPLx")));

var $af38f677c7a27790$var$_Logger = $af38f677c7a27790$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $1XggU = parcelRequire("1XggU");

var $af38f677c7a27790$var$styles = $af38f677c7a27790$var$_interopRequireWildcard((parcelRequire("2VekI")));
function $af38f677c7a27790$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $af38f677c7a27790$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($af38f677c7a27790$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $af38f677c7a27790$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $af38f677c7a27790$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $af38f677c7a27790$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $af38f677c7a27790$var$_slicedToArray(r, e) {
    return $af38f677c7a27790$var$_arrayWithHoles(r) || $af38f677c7a27790$var$_iterableToArrayLimit(r, e) || $af38f677c7a27790$var$_unsupportedIterableToArray(r, e) || $af38f677c7a27790$var$_nonIterableRest();
}
function $af38f677c7a27790$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af38f677c7a27790$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $af38f677c7a27790$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $af38f677c7a27790$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $af38f677c7a27790$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $af38f677c7a27790$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $af38f677c7a27790$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

// This is not a typical React component because it is not a controlled one. The html code
// is fed from outside
//
// We store the email & password in normal variables (customLoginEmail, customLoginPassword) ,
// instead of State because we cannot hook the setState method into the inner html, therefor these
// variables must stay outside of the component otherwise they will be reset everytime the component rerenders
//
// The most ugly part is how to handle events from the elements. Again, we cannot hook the react handlers to
// inner html therefor we must hook the event to the parent DIV element and wait for the events from the inner inputs
// to propagate there, it is ugly but it works and thanksfully we do not have very complicated form otherwise it would
// be FEASIBLE
if (null) null.accept("./index.css", function() {
    (parcelRequire("2VekI"));
});
function $af38f677c7a27790$var$CustomLogin(_ref) {
    var advisorId = _ref.advisorId, authenticate = _ref.authenticate;
    var _useState = (0, $af38f677c7a27790$var$_react.useState)(''), _useState2 = $af38f677c7a27790$var$_slicedToArray(_useState, 2), htmlCode = _useState2[0], setHtmlCode = _useState2[1];
    var _useState3 = (0, $af38f677c7a27790$var$_react.useState)(false), _useState4 = $af38f677c7a27790$var$_slicedToArray(_useState3, 2), showGenericForm = _useState4[0], setShowGenericForm = _useState4[1];
    var _useState5 = (0, $af38f677c7a27790$var$_react.useState)(false), _useState6 = $af38f677c7a27790$var$_slicedToArray(_useState5, 2), showCustomForm = _useState6[0], setShowCustomForm = _useState6[1];
    var _useState7 = (0, $af38f677c7a27790$var$_react.useState)(false), _useState8 = $af38f677c7a27790$var$_slicedToArray(_useState7, 2), advisor = _useState8[0], setAdvisor = _useState8[1];
    var authenticateCustom = function authenticateCustom() {
        var emailField = document.querySelectorAll('input[type=email]')[0] || document.querySelectorAll('input[type=text]')[0];
        var email = emailField.value;
        var password = document.querySelectorAll('input[type=password]')[0].value;
        authenticate(email, password);
    };
    var handleOnClick = function handleOnClick(e) {
        if (e.target.type === 'submit') {
            e.preventDefault();
            authenticateCustom();
        }
    };
    var handleOnKeyUp = function handleOnKeyUp(e) {
        if (e.key === 'Enter') authenticateCustom();
    };
    (0, $af38f677c7a27790$var$_react.useEffect)(function() {
        (0, $qkIgO.getCustomSignInSetting)(advisorId).then(function(response) {
            if (response.generic === false) {
                setHtmlCode(response.html_code + '<style>' + response.css_code + '</style>');
                setShowCustomForm(true);
            } else {
                setShowGenericForm(true);
                setAdvisor(response.advisor);
            }
        })["catch"](function(err) {
            $af38f677c7a27790$var$_Logger["default"].error("Fetching custom login for advisor ".concat(advisorId), err);
            (0, $1XggU.clearAdvisorCustomLogin)();
            location.href = '/';
        });
    }, []);
    if (showCustomForm) return /*#__PURE__*/ $af38f677c7a27790$var$_react["default"].createElement("div", {
        className: [
            $af38f677c7a27790$var$styles.custom_login_container,
            'custom'
        ].join(' ')
    }, /*#__PURE__*/ $af38f677c7a27790$var$_react["default"].createElement("div", {
        onKeyUp: handleOnKeyUp,
        onClick: handleOnClick,
        dangerouslySetInnerHTML: {
            __html: htmlCode
        }
    }));
    else if (showGenericForm) return /*#__PURE__*/ $af38f677c7a27790$var$_react["default"].createElement($af38f677c7a27790$var$_AdvisorGenericLogin["default"], {
        authenticate: authenticate,
        advisor: advisor
    });
    else return /*#__PURE__*/ $af38f677c7a27790$var$_react["default"].createElement("div", null, "Loading");
}

});
parcelRegister("6SPLx", function(module, exports) {
"use strict";
function $502ff0d336abbce5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $502ff0d336abbce5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $502ff0d336abbce5$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $502ff0d336abbce5$var$AdvisorGenericLogin;

var $502ff0d336abbce5$var$_react = $502ff0d336abbce5$var$_interopRequireWildcard((parcelRequire("acw62")));

var $4fGPb = parcelRequire("4fGPb");

var $502ff0d336abbce5$var$styles = $502ff0d336abbce5$var$_interopRequireWildcard((parcelRequire("5G9ll")));
function $502ff0d336abbce5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($502ff0d336abbce5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $502ff0d336abbce5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $502ff0d336abbce5$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $502ff0d336abbce5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $502ff0d336abbce5$var$_slicedToArray(r, e) {
    return $502ff0d336abbce5$var$_arrayWithHoles(r) || $502ff0d336abbce5$var$_iterableToArrayLimit(r, e) || $502ff0d336abbce5$var$_unsupportedIterableToArray(r, e) || $502ff0d336abbce5$var$_nonIterableRest();
}
function $502ff0d336abbce5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $502ff0d336abbce5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $502ff0d336abbce5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $502ff0d336abbce5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $502ff0d336abbce5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $502ff0d336abbce5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $502ff0d336abbce5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("./index.css", function() {
    (parcelRequire("5G9ll"));
});
function $502ff0d336abbce5$var$AdvisorGenericLogin(_ref) {
    var authenticate = _ref.authenticate, advisor = _ref.advisor;
    var year = new Date().getFullYear();
    var _useState = (0, $502ff0d336abbce5$var$_react.useState)(''), _useState2 = $502ff0d336abbce5$var$_slicedToArray(_useState, 2), email = _useState2[0], setEmail = _useState2[1];
    var _useState3 = (0, $502ff0d336abbce5$var$_react.useState)(''), _useState4 = $502ff0d336abbce5$var$_slicedToArray(_useState3, 2), password = _useState4[0], setPassword = _useState4[1];
    var handleSubmit = function handleSubmit(e) {
        e.preventDefault();
        authenticate(email, password);
    };
    return /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.generic_container
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.generic_container_inner
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.header
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.pic
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("img", {
        src: advisor.large_photo_full_url
    })), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.brand
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.sign_in_to
    }, "Sign in to..."), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.advisor_title_container
    }, advisor.practice_name || advisor.full_name || advisor.email), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.advisor_name
    }, advisor.full_name_and_advisor_title))), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.form_container
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("form", {
        id: "generic-login-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.fieldset
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("label", {
        className: $502ff0d336abbce5$var$styles.label
    }, " Email Address "), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("input", {
        className: $502ff0d336abbce5$var$styles.input_field,
        type: "email",
        value: email,
        onChange: function onChange(e) {
            return setEmail(e.target.value);
        }
    })), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.fieldset
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("label", {
        className: $502ff0d336abbce5$var$styles.label
    }, " Password "), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("input", {
        className: $502ff0d336abbce5$var$styles.input_field,
        type: "password",
        value: password,
        onChange: function onChange(e) {
            return setPassword(e.target.value);
        }
    })), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.fieldset
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("input", {
        className: $502ff0d336abbce5$var$styles.submit_btn,
        type: "submit",
        value: "Sign in"
    }), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement($4fGPb.Link, {
        className: $502ff0d336abbce5$var$styles.link,
        to: "/forgot_password"
    }, "Forgot your password?"))), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.message
    }, /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.message_header
    }, "Welcome back!"), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.message_body
    }, "Having trouble and need help signing in to your account?", /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("a", {
        className: $502ff0d336abbce5$var$styles.email_support_link,
        href: "mailto:vipsupport@blueleaf.com"
    }, " Email VIP Support "), "for assistance.")))), /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("div", {
        className: $502ff0d336abbce5$var$styles.footer
    }, advisor.subdomain, ".blueleaf.com is provided by your financial advisor through Blueleaf. \xA9 ", year, " Blueleaf Wealth, Inc. All rights reserved.", /*#__PURE__*/ $502ff0d336abbce5$var$_react["default"].createElement("br", null), advisor.disclaimer));
}

});
parcelRegister("5G9ll", function(module, exports) {

$parcel$export(module.exports, "generic_container", () => $42281f6466544be8$export$684c17bf53867958, (v) => $42281f6466544be8$export$684c17bf53867958 = v);
$parcel$export(module.exports, "generic_container_inner", () => $42281f6466544be8$export$daaca0c50c0846b8, (v) => $42281f6466544be8$export$daaca0c50c0846b8 = v);
$parcel$export(module.exports, "header", () => $42281f6466544be8$export$38e42c68cf43b5d4, (v) => $42281f6466544be8$export$38e42c68cf43b5d4 = v);
$parcel$export(module.exports, "pic", () => $42281f6466544be8$export$3d0f079c962d35a4, (v) => $42281f6466544be8$export$3d0f079c962d35a4 = v);
$parcel$export(module.exports, "brand", () => $42281f6466544be8$export$96ff94e0adb1d772, (v) => $42281f6466544be8$export$96ff94e0adb1d772 = v);
$parcel$export(module.exports, "sign_in_to", () => $42281f6466544be8$export$901b5dc6872fcf8a, (v) => $42281f6466544be8$export$901b5dc6872fcf8a = v);
$parcel$export(module.exports, "advisor_title_container", () => $42281f6466544be8$export$cb649edd0a8bb1c2, (v) => $42281f6466544be8$export$cb649edd0a8bb1c2 = v);
$parcel$export(module.exports, "advisor_name", () => $42281f6466544be8$export$a252c9b8ac4fd16b, (v) => $42281f6466544be8$export$a252c9b8ac4fd16b = v);
$parcel$export(module.exports, "form_container", () => $42281f6466544be8$export$4be61d40313a3d60, (v) => $42281f6466544be8$export$4be61d40313a3d60 = v);
$parcel$export(module.exports, "fieldset", () => $42281f6466544be8$export$a38812d1aa1302d9, (v) => $42281f6466544be8$export$a38812d1aa1302d9 = v);
$parcel$export(module.exports, "label", () => $42281f6466544be8$export$1237798dc640739a, (v) => $42281f6466544be8$export$1237798dc640739a = v);
$parcel$export(module.exports, "input_field", () => $42281f6466544be8$export$1e077af29af3389c, (v) => $42281f6466544be8$export$1e077af29af3389c = v);
$parcel$export(module.exports, "message", () => $42281f6466544be8$export$a8ecead220dd38a6, (v) => $42281f6466544be8$export$a8ecead220dd38a6 = v);
$parcel$export(module.exports, "message_header", () => $42281f6466544be8$export$d05170ef07531a03, (v) => $42281f6466544be8$export$d05170ef07531a03 = v);
$parcel$export(module.exports, "message_body", () => $42281f6466544be8$export$4f5da1d95fa07389, (v) => $42281f6466544be8$export$4f5da1d95fa07389 = v);
$parcel$export(module.exports, "submit_btn", () => $42281f6466544be8$export$6eae7689ca139ede, (v) => $42281f6466544be8$export$6eae7689ca139ede = v);
$parcel$export(module.exports, "footer", () => $42281f6466544be8$export$adb608be33961c98, (v) => $42281f6466544be8$export$adb608be33961c98 = v);
$parcel$export(module.exports, "link", () => $42281f6466544be8$export$9c30223ca0a664fb, (v) => $42281f6466544be8$export$9c30223ca0a664fb = v);
$parcel$export(module.exports, "email_support_link", () => $42281f6466544be8$export$ab568e7bd39b713e, (v) => $42281f6466544be8$export$ab568e7bd39b713e = v);
var $42281f6466544be8$export$684c17bf53867958;
var $42281f6466544be8$export$daaca0c50c0846b8;
var $42281f6466544be8$export$38e42c68cf43b5d4;
var $42281f6466544be8$export$3d0f079c962d35a4;
var $42281f6466544be8$export$96ff94e0adb1d772;
var $42281f6466544be8$export$901b5dc6872fcf8a;
var $42281f6466544be8$export$cb649edd0a8bb1c2;
var $42281f6466544be8$export$a252c9b8ac4fd16b;
var $42281f6466544be8$export$4be61d40313a3d60;
var $42281f6466544be8$export$a38812d1aa1302d9;
var $42281f6466544be8$export$1237798dc640739a;
var $42281f6466544be8$export$1e077af29af3389c;
var $42281f6466544be8$export$a8ecead220dd38a6;
var $42281f6466544be8$export$d05170ef07531a03;
var $42281f6466544be8$export$4f5da1d95fa07389;
var $42281f6466544be8$export$6eae7689ca139ede;
var $42281f6466544be8$export$adb608be33961c98;
var $42281f6466544be8$export$9c30223ca0a664fb;
var $42281f6466544be8$export$ab568e7bd39b713e;
"use strict";
$42281f6466544be8$export$684c17bf53867958 = "js-AdvisorGenericLogin-__index__generic_container__miL3T";
$42281f6466544be8$export$daaca0c50c0846b8 = "js-AdvisorGenericLogin-__index__generic_container_inner__cKGRE";
$42281f6466544be8$export$38e42c68cf43b5d4 = "js-AdvisorGenericLogin-__index__header__ZKBCA";
$42281f6466544be8$export$3d0f079c962d35a4 = "js-AdvisorGenericLogin-__index__pic__bwc41";
$42281f6466544be8$export$96ff94e0adb1d772 = "js-AdvisorGenericLogin-__index__brand__n8gne";
$42281f6466544be8$export$901b5dc6872fcf8a = "js-AdvisorGenericLogin-__index__sign_in_to__LV2gc";
$42281f6466544be8$export$cb649edd0a8bb1c2 = "js-AdvisorGenericLogin-__index__advisor_title_container__AiRxF";
$42281f6466544be8$export$a252c9b8ac4fd16b = "js-AdvisorGenericLogin-__index__advisor_name__zN5oV";
$42281f6466544be8$export$4be61d40313a3d60 = "js-AdvisorGenericLogin-__index__form_container__t5C5j";
$42281f6466544be8$export$a38812d1aa1302d9 = "js-AdvisorGenericLogin-__index__fieldset__eyudN";
$42281f6466544be8$export$1237798dc640739a = "js-AdvisorGenericLogin-__index__label__3v5KC";
$42281f6466544be8$export$1e077af29af3389c = "js-AdvisorGenericLogin-__index__input_field__IliKn";
$42281f6466544be8$export$a8ecead220dd38a6 = "js-AdvisorGenericLogin-__index__message__Lzlaq";
$42281f6466544be8$export$d05170ef07531a03 = "js-AdvisorGenericLogin-__index__message_header__fAr95";
$42281f6466544be8$export$4f5da1d95fa07389 = "js-AdvisorGenericLogin-__index__message_body__Vhl2i";
$42281f6466544be8$export$6eae7689ca139ede = "js-AdvisorGenericLogin-__index__submit_btn__-Je4-";
$42281f6466544be8$export$adb608be33961c98 = "js-AdvisorGenericLogin-__index__footer__VmIzK";
$42281f6466544be8$export$9c30223ca0a664fb = "js-AdvisorGenericLogin-__index__link__1-hYy";
$42281f6466544be8$export$ab568e7bd39b713e = "js-AdvisorGenericLogin-__index__email_support_link__pSLeq";

});


parcelRegister("2VekI", function(module, exports) {

$parcel$export(module.exports, "custom_login_container", () => $220c05e61cbacc5b$export$d6d1ce3fa472291c, (v) => $220c05e61cbacc5b$export$d6d1ce3fa472291c = v);
var $220c05e61cbacc5b$export$d6d1ce3fa472291c;
"use strict";
$220c05e61cbacc5b$export$d6d1ce3fa472291c = "js-CustomLogin-__index__custom_login_container__juuKG";

});


parcelRegister("2gSw0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $1a775cfe54b58231$var$setMessage = function setMessage(message) {
    sessionStorage.setItem('flashMessage', message);
};
var $1a775cfe54b58231$var$getMessage = function getMessage() {
    var message = sessionStorage.getItem('flashMessage');
    setTimeout(function() {
        sessionStorage.removeItem('flashMessage');
    }, 5000);
    return message;
};
var $1a775cfe54b58231$var$_default = module.exports["default"] = {
    setMessage: $1a775cfe54b58231$var$setMessage,
    getMessage: $1a775cfe54b58231$var$getMessage
};

});


parcelRegister("2fnLT", function(module, exports) {
"use strict";
function $1a2f6bfc8001a559$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1a2f6bfc8001a559$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1a2f6bfc8001a559$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $1a2f6bfc8001a559$var$ForgotPasswordForm;

var $1a2f6bfc8001a559$var$_react = $1a2f6bfc8001a559$var$_interopRequireWildcard((parcelRequire("acw62")));

var $1a2f6bfc8001a559$var$alertStyles = $1a2f6bfc8001a559$var$_interopRequireWildcard((parcelRequire("jbsrN")));

var $1a2f6bfc8001a559$var$styles = $1a2f6bfc8001a559$var$_interopRequireWildcard((parcelRequire("kMVI2")));

var $4fGPb = parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");

var $1a2f6bfc8001a559$var$_Flash = $1a2f6bfc8001a559$var$_interopRequireDefault((parcelRequire("2gSw0")));

var $1a2f6bfc8001a559$var$_Logger = $1a2f6bfc8001a559$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $1a2f6bfc8001a559$var$_AlertTypes = $1a2f6bfc8001a559$var$_interopRequireDefault((parcelRequire("5LA7J")));

var $1a2f6bfc8001a559$var$_Footer = $1a2f6bfc8001a559$var$_interopRequireDefault((parcelRequire("8ALkM")));

var $1a2f6bfc8001a559$var$_reactTopLoadingBar = $1a2f6bfc8001a559$var$_interopRequireDefault((parcelRequire("1KSzM")));

var $qkIgO = parcelRequire("qkIgO");
function $1a2f6bfc8001a559$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $1a2f6bfc8001a559$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1a2f6bfc8001a559$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1a2f6bfc8001a559$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $1a2f6bfc8001a559$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $1a2f6bfc8001a559$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1a2f6bfc8001a559$var$_slicedToArray(r, e) {
    return $1a2f6bfc8001a559$var$_arrayWithHoles(r) || $1a2f6bfc8001a559$var$_iterableToArrayLimit(r, e) || $1a2f6bfc8001a559$var$_unsupportedIterableToArray(r, e) || $1a2f6bfc8001a559$var$_nonIterableRest();
}
function $1a2f6bfc8001a559$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1a2f6bfc8001a559$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1a2f6bfc8001a559$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1a2f6bfc8001a559$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1a2f6bfc8001a559$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1a2f6bfc8001a559$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1a2f6bfc8001a559$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

if (null) null.accept("../SharedCss/alert.css", function() {
    (parcelRequire("jbsrN"));
});

(parcelRequire("8vghX")).config();
function $1a2f6bfc8001a559$var$ForgotPasswordForm(props) {
    var CognitoIdentityLib = props.CognitoIdentityLib;
    var _useState = (0, $1a2f6bfc8001a559$var$_react.useState)(''), _useState2 = $1a2f6bfc8001a559$var$_slicedToArray(_useState, 2), email = _useState2[0], setEmail = _useState2[1];
    var _useState3 = (0, $1a2f6bfc8001a559$var$_react.useState)(''), _useState4 = $1a2f6bfc8001a559$var$_slicedToArray(_useState3, 2), alertType = _useState4[0], setAlertType = _useState4[1];
    var _useState5 = (0, $1a2f6bfc8001a559$var$_react.useState)(''), _useState6 = $1a2f6bfc8001a559$var$_slicedToArray(_useState5, 2), errorMessage = _useState6[0], setErrorMessage = _useState6[1];
    var _useState7 = (0, $1a2f6bfc8001a559$var$_react.useState)(false), _useState8 = $1a2f6bfc8001a559$var$_slicedToArray(_useState7, 2), redirect = _useState8[0], setRedirect = _useState8[1];
    var loadingRef = (0, $1a2f6bfc8001a559$var$_react.useRef)(null);
    var handleSubmit = function handleSubmit(e) {
        $1a2f6bfc8001a559$var$_Logger["default"].start('Submit Forgot Password', {
            email: email
        });
        e.preventDefault();
        setAlertType('');
        loadingRef.current.continuousStart();
        var userPool = new CognitoIdentityLib.CognitoUserPool({
            UserPoolId: "us-east-1_dghkmntO0",
            ClientId: "745dij271n5sgodrapt1ofef22"
        });
        var userData = {
            Username: email,
            Pool: userPool
        };
        var cognitoUser = new CognitoIdentityLib.CognitoUser(userData);
        var contactUsMessage = 'If your email address is registered in our system, you will receive an email from Blueleaf. Need help? Contact us <a href="mailto:vipsupport@blueleaf.com">here</a>.';
        (0, $qkIgO.checkCognitoStatus)(email).then(function(response) {
            if (response.status === 'UNCONFIRMED') {
                loadingRef.current.complete();
                $1a2f6bfc8001a559$var$_Flash["default"].setMessage(contactUsMessage);
                setRedirect(true);
                return;
            }
            if (response.status === 'NOT_FOUND') {
                loadingRef.current.complete();
                $1a2f6bfc8001a559$var$_Flash["default"].setMessage(contactUsMessage);
                setRedirect(true);
                return;
            }
            cognitoUser.forgotPassword({
                onSuccess: function onSuccess(result) {
                    loadingRef.current.complete();
                    $1a2f6bfc8001a559$var$_Logger["default"].done('Submit Forgot Password', {
                        email: email
                    });
                    $1a2f6bfc8001a559$var$_Flash["default"].setMessage(contactUsMessage);
                    setRedirect(true);
                },
                onFailure: function onFailure(err) {
                    loadingRef.current.complete();
                    $1a2f6bfc8001a559$var$_Logger["default"].error('Submit Forgot Password', err);
                    setAlertType($1a2f6bfc8001a559$var$_AlertTypes["default"].UPDATE_FAILED);
                    setErrorMessage(err.message || JSON.stringify(err));
                }
            });
        });
    };
    var renderAlert = function renderAlert() {
        if (alertType === $1a2f6bfc8001a559$var$_AlertTypes["default"].UPDATE_FAILED) {
            var markup = {
                __html: errorMessage
            };
            return /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("div", {
                className: [
                    $1a2f6bfc8001a559$var$alertStyles.alert,
                    $1a2f6bfc8001a559$var$alertStyles.error
                ].join(' '),
                dangerouslySetInnerHTML: markup
            });
        }
    };
    if (redirect) return /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement($kfZjc.Redirect, {
        id: "login-redirect",
        to: "/"
    });
    return /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("div", {
        className: $1a2f6bfc8001a559$var$styles.container
    }, renderAlert(), /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement($1a2f6bfc8001a559$var$_reactTopLoadingBar["default"], {
        color: "#f11946",
        ref: loadingRef
    }), /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("div", {
        className: $1a2f6bfc8001a559$var$styles.header
    }, /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("div", {
        className: $1a2f6bfc8001a559$var$styles.logo
    }, /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("h1", null, "Blueleaf")), /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("div", {
        className: $1a2f6bfc8001a559$var$styles.header_text
    }, /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("h2", null, "Forgot your password?"))), /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("div", {
        className: $1a2f6bfc8001a559$var$styles.form_container
    }, /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("form", {
        id: "forgot-password-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("div", {
        className: $1a2f6bfc8001a559$var$styles.form_description
    }, "If your email address is in our system and confirmed by you, you'll receive a link to reset your password. Should you still need to confirm your email address, we'll send you a confirmation link and then you'll be able to sign in"), /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("div", {
        className: $1a2f6bfc8001a559$var$styles.fieldset
    }, /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("label", {
        className: $1a2f6bfc8001a559$var$styles.label
    }, "Your Email Address"), /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("input", {
        className: $1a2f6bfc8001a559$var$styles.input_field,
        type: "email",
        value: email,
        onChange: function onChange(e) {
            return setEmail(e.target.value);
        }
    })), /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement("input", {
        id: "submit-btn",
        className: $1a2f6bfc8001a559$var$styles.submit_btn,
        type: "submit",
        value: "Reset Password"
    }), /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement($4fGPb.Link, {
        id: "sign-in-btn",
        className: $1a2f6bfc8001a559$var$styles.link,
        to: "/"
    }, "Back to sign in"))), /*#__PURE__*/ $1a2f6bfc8001a559$var$_react["default"].createElement($1a2f6bfc8001a559$var$_Footer["default"], null));
}

});

parcelRegister("etINR", function(module, exports) {
"use strict";
function $a8a6872108255b3c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a8a6872108255b3c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a8a6872108255b3c$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a8a6872108255b3c$var$MfaSettings;

var $a8a6872108255b3c$var$_react = $a8a6872108255b3c$var$_interopRequireWildcard((parcelRequire("acw62")));

var $a8a6872108255b3c$var$alertStyles = $a8a6872108255b3c$var$_interopRequireWildcard((parcelRequire("jbsrN")));

var $a8a6872108255b3c$var$formStyles = $a8a6872108255b3c$var$_interopRequireWildcard((parcelRequire("kMVI2")));

var $dwN01 = parcelRequire("dwN01");

var $a8a6872108255b3c$var$_MessageBus = $a8a6872108255b3c$var$_interopRequireDefault((parcelRequire("i9Koa")));

var $a8a6872108255b3c$var$_Menu = $a8a6872108255b3c$var$_interopRequireDefault((parcelRequire("9E8aK")));

var $a8a6872108255b3c$var$_Logger = $a8a6872108255b3c$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $a8a6872108255b3c$var$_Footer = $a8a6872108255b3c$var$_interopRequireDefault((parcelRequire("8ALkM")));

var $a8a6872108255b3c$var$_AlertTypes = $a8a6872108255b3c$var$_interopRequireDefault((parcelRequire("5LA7J")));

var $a8a6872108255b3c$var$_reactTopLoadingBar = $a8a6872108255b3c$var$_interopRequireDefault((parcelRequire("1KSzM")));

var $dFuh9 = parcelRequire("dFuh9");

var $lj4el = parcelRequire("lj4el");
function $a8a6872108255b3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $a8a6872108255b3c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a8a6872108255b3c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a8a6872108255b3c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $a8a6872108255b3c$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $a8a6872108255b3c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a8a6872108255b3c$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $a8a6872108255b3c$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $a8a6872108255b3c$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($a8a6872108255b3c$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $a8a6872108255b3c$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $a8a6872108255b3c$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $a8a6872108255b3c$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $a8a6872108255b3c$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $a8a6872108255b3c$var$_slicedToArray(r, e) {
    return $a8a6872108255b3c$var$_arrayWithHoles(r) || $a8a6872108255b3c$var$_iterableToArrayLimit(r, e) || $a8a6872108255b3c$var$_unsupportedIterableToArray(r, e) || $a8a6872108255b3c$var$_nonIterableRest();
}
function $a8a6872108255b3c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a8a6872108255b3c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a8a6872108255b3c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a8a6872108255b3c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a8a6872108255b3c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a8a6872108255b3c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a8a6872108255b3c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

if (null) null.accept("../SharedCss/alert.css", function() {
    (parcelRequire("jbsrN"));
});

(parcelRequire("8vghX")).config();
function $a8a6872108255b3c$var$MfaSettings(props) {
    var CognitoIdentityLib = props.CognitoIdentityLib;
    var cognitoUser = (0, $dwN01.getAuthenticatedUser)();
    var userData = (0, $dwN01.getAuthenticatedUserData)();
    var currentPhoneNumber = userData.getAttr('phone_number') || '';
    var currentMfaEnabled = userData.isSmsMfaActivated();
    var _useState = (0, $a8a6872108255b3c$var$_react.useState)(currentMfaEnabled), _useState2 = $a8a6872108255b3c$var$_slicedToArray(_useState, 2), mfaEnabled = _useState2[0], setMfaEnabled = _useState2[1];
    var _useState3 = (0, $a8a6872108255b3c$var$_react.useState)(currentPhoneNumber), _useState4 = $a8a6872108255b3c$var$_slicedToArray(_useState3, 2), phone = _useState4[0], setPhone = _useState4[1];
    var _useState5 = (0, $a8a6872108255b3c$var$_react.useState)(''), _useState6 = $a8a6872108255b3c$var$_slicedToArray(_useState5, 2), alertType = _useState6[0], setAlertType = _useState6[1];
    var _useState7 = (0, $a8a6872108255b3c$var$_react.useState)(''), _useState8 = $a8a6872108255b3c$var$_slicedToArray(_useState7, 2), errorMessage = _useState8[0], setErrorMessage = _useState8[1];
    var loadingRef = (0, $a8a6872108255b3c$var$_react.useRef)(null);
    var userId = userData.getAttr('custom:bl_id');
    (0, $lj4el.trackPendo)('Visit Mfa Settings', {
        userId: userId
    });
    var updateUserAttributes = function updateUserAttributes() {
        return new Promise(function(resolve, reject) {
            var formattedPhone = (0, $dFuh9.formatPhoneNumber)(phone);
            var attribute = {
                Name: 'phone_number',
                Value: formattedPhone
            };
            $a8a6872108255b3c$var$_Logger["default"].start('Update User Attributes', attribute);
            var attributeList = [
                new CognitoIdentityLib.CognitoUserAttribute(attribute)
            ];
            cognitoUser.updateAttributes(attributeList, function(err, result) {
                if (err) reject(err);
                $a8a6872108255b3c$var$_Logger["default"].done('Update User Attributes', attribute);
                setPhone(formattedPhone);
                resolve('done');
            });
        });
    };
    var updateUserMfa = function updateUserMfa() {
        return new Promise(function(resolve, reject) {
            var settings = {};
            if (mfaEnabled) settings = {
                PreferredMfa: true,
                Enabled: true
            };
            else settings = {
                Enabled: false
            };
            $a8a6872108255b3c$var$_Logger["default"].start('Update User MFA', settings);
            cognitoUser.setUserMfaPreference(settings, null, function(err, result) {
                if (err) reject(err);
                $a8a6872108255b3c$var$_Logger["default"].done('Update User MFA', settings);
                setAlertType($a8a6872108255b3c$var$_AlertTypes["default"].UPDATE_SUCCESSFULLY);
                resolve('done');
            });
        });
    };
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = $a8a6872108255b3c$var$_asyncToGenerator(/*#__PURE__*/ $a8a6872108255b3c$var$_regeneratorRuntime().mark(function _callee(e) {
            return $a8a6872108255b3c$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        setAlertType('');
                        e.preventDefault();
                        if (!(phone === currentPhoneNumber && mfaEnabled === currentMfaEnabled)) {
                            _context.next = 4;
                            break;
                        }
                        return _context.abrupt("return");
                    case 4:
                        loadingRef.current.continuousStart();
                        if (!(mfaEnabled && phone.trim().length === 0)) {
                            _context.next = 9;
                            break;
                        }
                        setAlertType($a8a6872108255b3c$var$_AlertTypes["default"].UPDATE_FAILED);
                        setErrorMessage('Phone number is required for MFA');
                        return _context.abrupt("return");
                    case 9:
                        _context.prev = 9;
                        if (!(phone === currentPhoneNumber && mfaEnabled !== currentMfaEnabled)) {
                            _context.next = 15;
                            break;
                        }
                        _context.next = 13;
                        return updateUserMfa();
                    case 13:
                        _context.next = 25;
                        break;
                    case 15:
                        if (!(phone !== currentPhoneNumber && mfaEnabled !== currentMfaEnabled)) {
                            _context.next = 22;
                            break;
                        }
                        _context.next = 18;
                        return updateUserAttributes();
                    case 18:
                        _context.next = 20;
                        return updateUserMfa();
                    case 20:
                        _context.next = 25;
                        break;
                    case 22:
                        if (!(phone !== currentPhoneNumber && mfaEnabled === currentMfaEnabled)) {
                            _context.next = 25;
                            break;
                        }
                        _context.next = 25;
                        return updateUserAttributes();
                    case 25:
                        loadingRef.current.complete();
                        emitUserAttrsChange();
                        (0, $dwN01.fetchUserData)();
                        setAlertType($a8a6872108255b3c$var$_AlertTypes["default"].UPDATE_SUCCESSFULLY);
                        (0, $lj4el.trackPendo)('Updated Mfa Settings', {
                            userId: userId
                        });
                        _context.next = 38;
                        break;
                    case 32:
                        _context.prev = 32;
                        _context.t0 = _context["catch"](9);
                        loadingRef.current.complete();
                        setAlertType($a8a6872108255b3c$var$_AlertTypes["default"].UPDATE_FAILED);
                        setErrorMessage(_context.t0.message || JSON.stringify(_context.t0));
                        (0, $lj4el.trackPendo)('Failed to Update Mfa Settings', {
                            userId: userId,
                            error: _context.t0.message
                        });
                    case 38:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    9,
                    32
                ]
            ]);
        }));
        return function handleSubmit(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    var emitUserAttrsChange = function emitUserAttrsChange() {
        $a8a6872108255b3c$var$_MessageBus["default"].emitUserAttrsChange({
            username: userData.getAttr('sub'),
            bl_id: userData.getAttr('custom:bl_id')
        });
    };
    var renderAlert = function renderAlert() {
        if (alertType === $a8a6872108255b3c$var$_AlertTypes["default"].UPDATE_FAILED) return /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", {
            className: [
                $a8a6872108255b3c$var$alertStyles.alert,
                $a8a6872108255b3c$var$alertStyles.error,
                $a8a6872108255b3c$var$alertStyles.render_with_menu
            ].join(' ')
        }, errorMessage);
        else if (alertType === $a8a6872108255b3c$var$_AlertTypes["default"].UPDATE_SUCCESSFULLY) return /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", {
            className: [
                $a8a6872108255b3c$var$alertStyles.alert,
                $a8a6872108255b3c$var$alertStyles.success,
                $a8a6872108255b3c$var$alertStyles.render_with_menu
            ].join(' ')
        }, "Update settings successfully.");
    };
    return /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", {
        className: $a8a6872108255b3c$var$formStyles.container
    }, renderAlert(), /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement($a8a6872108255b3c$var$_reactTopLoadingBar["default"], {
        color: "#f11946",
        ref: loadingRef
    }), /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement($a8a6872108255b3c$var$_Menu["default"], {
        highlighted: "mfa_settings"
    }), /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", null, /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", {
        className: $a8a6872108255b3c$var$formStyles.header
    }, /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", {
        className: $a8a6872108255b3c$var$formStyles.logo
    }, /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("h1", null, "Blueleaf")), /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", {
        className: $a8a6872108255b3c$var$formStyles.header_text
    }, /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("h2", null, "Update your MFA settings"))), /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", {
        className: $a8a6872108255b3c$var$formStyles.form_container
    }, /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("form", {
        id: "new-password-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", {
        className: $a8a6872108255b3c$var$formStyles.fieldset
    }, /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("label", {
        className: $a8a6872108255b3c$var$formStyles.label
    }, "Phone Number"), /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("input", {
        className: $a8a6872108255b3c$var$formStyles.input_field,
        id: "phone-number",
        type: "text",
        value: phone,
        onChange: function onChange(e) {
            return setPhone(e.target.value);
        }
    })), /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("div", {
        className: $a8a6872108255b3c$var$formStyles.fieldset
    }, /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("label", {
        className: $a8a6872108255b3c$var$formStyles.label
    }, "Activate SMS mfa", /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("input", {
        className: $a8a6872108255b3c$var$formStyles.checkbox,
        type: "checkbox",
        checked: mfaEnabled,
        onChange: function onChange(e) {
            return setMfaEnabled(e.target.checked);
        }
    }))), /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement("input", {
        id: "submit-btn",
        className: $a8a6872108255b3c$var$formStyles.submit_btn,
        type: "submit",
        value: "Set"
    }))), /*#__PURE__*/ $a8a6872108255b3c$var$_react["default"].createElement($a8a6872108255b3c$var$_Footer["default"], null)));
}

});
parcelRegister("i9Koa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $dwN01 = parcelRequire("dwN01");

var $d37d0d1a866c9132$var$_Logger = $d37d0d1a866c9132$var$_interopRequireDefault((parcelRequire("2ChR8")));
function $d37d0d1a866c9132$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}

(parcelRequire("8vghX")).config();
var $d37d0d1a866c9132$var$putRecord = function putRecord(tokens, attrs) {
    $d37d0d1a866c9132$var$_Logger["default"].start('Put new record to Message Bus', attrs);
    var metadata = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: "Bearer ".concat(tokens.idToken)
        },
        body: JSON.stringify(attrs)
    };
    return fetch("".concat("https://vwbmcq7wda.execute-api.us-east-1.amazonaws.com/production", "/put_record"), metadata).then(function() {
        $d37d0d1a866c9132$var$_Logger["default"].done('Put new record to Message Bus', attrs);
    })["catch"](function(err) {
        $d37d0d1a866c9132$var$_Logger["default"].error('Put new record to Message Bus', err);
    });
};
var $d37d0d1a866c9132$var$emitUserAttrsChange = function emitUserAttrsChange(attrs) {
    var tokens = (0, $dwN01.getTokens)();
    attrs.message_type = 'attr_change';
    return $d37d0d1a866c9132$var$putRecord(tokens, attrs);
};
var $d37d0d1a866c9132$var$_default = module.exports["default"] = {
    emitUserAttrsChange: $d37d0d1a866c9132$var$emitUserAttrsChange
};

});

parcelRegister("9E8aK", function(module, exports) {
"use strict";
function $705e30587228a792$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $705e30587228a792$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $705e30587228a792$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $705e30587228a792$var$MyMenu;

var $705e30587228a792$var$_react = $705e30587228a792$var$_interopRequireDefault((parcelRequire("acw62")));

var $4fGPb = parcelRequire("4fGPb");

var $dwN01 = parcelRequire("dwN01");

var $705e30587228a792$var$styles = $705e30587228a792$var$_interopRequireWildcard((parcelRequire("2Qug8")));

var $g3rxA = parcelRequire("g3rxA");
function $705e30587228a792$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($705e30587228a792$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $705e30587228a792$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $705e30587228a792$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $705e30587228a792$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $705e30587228a792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}

if (null) null.accept("./index.css", function() {
    (parcelRequire("2Qug8"));
});
function $705e30587228a792$var$MyMenu(props) {
    var highlighted = props.highlighted;
    var userData = (0, $dwN01.getAuthenticatedUserData)();
    var handleSignOut = function handleSignOut() {
        (0, $dwN01.signOut)();
    };
    // Signing in again to external host just in case the session has expired over there. The idea
    // is as long as the Cognito token is still valid in the front end app, client should be able to
    // navigate with a valid session to External Host
    var redirectExternalHost = function redirectExternalHost() {
        (0, $g3rxA.signInExternalHost)();
    };
    return /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("div", {
        className: $705e30587228a792$var$styles.menu_container
    }, /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("div", null, /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("div", {
        className: $705e30587228a792$var$styles.menu_item
    }, /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("a", {
        onClick: function onClick() {
            redirectExternalHost();
        }
    }, " Back to app")), /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("div", {
        className: highlighted === 'update_email' ? [
            $705e30587228a792$var$styles.menu_item,
            $705e30587228a792$var$styles.highlighted
        ].join(' ') : $705e30587228a792$var$styles.menu_item
    }, /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement($4fGPb.Link, {
        to: "/update_email"
    }, " Email")), /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("div", {
        className: highlighted === 'change_password' ? [
            $705e30587228a792$var$styles.menu_item,
            $705e30587228a792$var$styles.highlighted
        ].join(' ') : $705e30587228a792$var$styles.menu_item
    }, /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement($4fGPb.Link, {
        to: "/change_password"
    }, " Change Password ")), /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("div", {
        className: highlighted === 'mfa_settings' ? [
            $705e30587228a792$var$styles.menu_item,
            $705e30587228a792$var$styles.highlighted
        ].join(' ') : $705e30587228a792$var$styles.menu_item
    }, /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement($4fGPb.Link, {
        to: "/mfa_settings"
    }, " Mfa Settings")), /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("div", {
        className: [
            $705e30587228a792$var$styles.menu_item,
            $705e30587228a792$var$styles.last_menu_item
        ].join(' ')
    }, /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("a", {
        onClick: function onClick() {
            handleSignOut();
        }
    }, " Sign Out")), /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("div", {
        className: $705e30587228a792$var$styles.account_name
    }, "Editing details for", /*#__PURE__*/ $705e30587228a792$var$_react["default"].createElement("b", null, " ", userData.getAttr('email'), " "))));
}

});
parcelRegister("2Qug8", function(module, exports) {

$parcel$export(module.exports, "menu_container", () => $2127e8f7d65acaa6$export$714e73ad774ccecb, (v) => $2127e8f7d65acaa6$export$714e73ad774ccecb = v);
$parcel$export(module.exports, "menu_item", () => $2127e8f7d65acaa6$export$7cb6bef9a536a50, (v) => $2127e8f7d65acaa6$export$7cb6bef9a536a50 = v);
$parcel$export(module.exports, "last_menu_item", () => $2127e8f7d65acaa6$export$1e94ddfab213906f, (v) => $2127e8f7d65acaa6$export$1e94ddfab213906f = v);
$parcel$export(module.exports, "highlighted", () => $2127e8f7d65acaa6$export$ba6acb6e4dfd83c2, (v) => $2127e8f7d65acaa6$export$ba6acb6e4dfd83c2 = v);
$parcel$export(module.exports, "account_name", () => $2127e8f7d65acaa6$export$94df86395cccd338, (v) => $2127e8f7d65acaa6$export$94df86395cccd338 = v);
var $2127e8f7d65acaa6$export$714e73ad774ccecb;
var $2127e8f7d65acaa6$export$7cb6bef9a536a50;
var $2127e8f7d65acaa6$export$1e94ddfab213906f;
var $2127e8f7d65acaa6$export$ba6acb6e4dfd83c2;
var $2127e8f7d65acaa6$export$94df86395cccd338;
"use strict";
$2127e8f7d65acaa6$export$714e73ad774ccecb = "js-Menu-__index__menu_container__o1XUr";
$2127e8f7d65acaa6$export$7cb6bef9a536a50 = "js-Menu-__index__menu_item__NHdBS";
$2127e8f7d65acaa6$export$1e94ddfab213906f = "js-Menu-__index__last_menu_item__9ULPs";
$2127e8f7d65acaa6$export$ba6acb6e4dfd83c2 = "js-Menu-__index__highlighted__9mDY6";
$2127e8f7d65acaa6$export$94df86395cccd338 = "js-Menu-__index__account_name__fxDOA";

});


parcelRegister("dFuh9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatPhoneNumber = $9f3696ccff6a3115$var$formatPhoneNumber;
function $9f3696ccff6a3115$var$formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.trim();
    if (phoneNumber.length === 0) return phoneNumber;
    else if (phoneNumber.charAt(0) === '+') // return as is if a country code is given
    return phoneNumber;
    else {
        // Assume it is American phone number it no country code is given
        if (phoneNumber.charAt(0) === '1') return "+".concat(phoneNumber);
        else return "+1".concat(phoneNumber);
    }
}

});

parcelRegister("lj4el", function(module, exports) {
"use strict";
function $f82ea75d16ad978f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f82ea75d16ad978f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f82ea75d16ad978f$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
module.exports.trackPendo = $f82ea75d16ad978f$var$trackPendo;

var $dwN01 = parcelRequire("dwN01");
function $f82ea75d16ad978f$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $f82ea75d16ad978f$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $f82ea75d16ad978f$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($f82ea75d16ad978f$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $f82ea75d16ad978f$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $f82ea75d16ad978f$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $f82ea75d16ad978f$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $f82ea75d16ad978f$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

(parcelRequire("8vghX")).config();
var $f82ea75d16ad978f$var$_default = module.exports["default"] = /*#__PURE__*/ $f82ea75d16ad978f$var$_asyncToGenerator(/*#__PURE__*/ $f82ea75d16ad978f$var$_regeneratorRuntime().mark(function _callee() {
    var userData, visitor, account;
    return $f82ea75d16ad978f$var$_regeneratorRuntime().wrap(function _callee$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                userData = (0, $dwN01.getAuthenticatedUserData)(); // Call this whenever information about your visitors becomes available
                // Please use Strings, Numbers, or Bools for value types.
                visitor = {
                    id: "".concat(userData.getAttr('custom:bl_id')),
                    email: "".concat(userData.getAttr('email'))
                };
                account = {
                    id: "".concat(userData.getAttr('custom:firm_id'))
                };
                pendo.initialize({
                    visitor: visitor,
                    account: account
                });
            case 4:
            case "end":
                return _context.stop();
        }
    }, _callee);
}));
function $f82ea75d16ad978f$var$trackPendo(activityName, data) {
    pendo.track(activityName, data);
}

});


parcelRegister("1o4hO", function(module, exports) {
"use strict";
function $102b5b86a6cf8dd2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $102b5b86a6cf8dd2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $102b5b86a6cf8dd2$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $102b5b86a6cf8dd2$var$ChangePassword;

var $102b5b86a6cf8dd2$var$_react = $102b5b86a6cf8dd2$var$_interopRequireWildcard((parcelRequire("acw62")));

var $102b5b86a6cf8dd2$var$alertStyles = $102b5b86a6cf8dd2$var$_interopRequireWildcard((parcelRequire("jbsrN")));

var $102b5b86a6cf8dd2$var$styles = $102b5b86a6cf8dd2$var$_interopRequireWildcard((parcelRequire("kMVI2")));

var $dwN01 = parcelRequire("dwN01");

var $102b5b86a6cf8dd2$var$_Menu = $102b5b86a6cf8dd2$var$_interopRequireDefault((parcelRequire("9E8aK")));

var $102b5b86a6cf8dd2$var$_Logger = $102b5b86a6cf8dd2$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $102b5b86a6cf8dd2$var$_AlertTypes = $102b5b86a6cf8dd2$var$_interopRequireDefault((parcelRequire("5LA7J")));

var $102b5b86a6cf8dd2$var$_Footer = $102b5b86a6cf8dd2$var$_interopRequireDefault((parcelRequire("8ALkM")));

var $102b5b86a6cf8dd2$var$_reactTopLoadingBar = $102b5b86a6cf8dd2$var$_interopRequireDefault((parcelRequire("1KSzM")));

var $lj4el = parcelRequire("lj4el");
function $102b5b86a6cf8dd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $102b5b86a6cf8dd2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($102b5b86a6cf8dd2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $102b5b86a6cf8dd2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $102b5b86a6cf8dd2$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $102b5b86a6cf8dd2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $102b5b86a6cf8dd2$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $102b5b86a6cf8dd2$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $102b5b86a6cf8dd2$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($102b5b86a6cf8dd2$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $102b5b86a6cf8dd2$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $102b5b86a6cf8dd2$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $102b5b86a6cf8dd2$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $102b5b86a6cf8dd2$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $102b5b86a6cf8dd2$var$_slicedToArray(r, e) {
    return $102b5b86a6cf8dd2$var$_arrayWithHoles(r) || $102b5b86a6cf8dd2$var$_iterableToArrayLimit(r, e) || $102b5b86a6cf8dd2$var$_unsupportedIterableToArray(r, e) || $102b5b86a6cf8dd2$var$_nonIterableRest();
}
function $102b5b86a6cf8dd2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $102b5b86a6cf8dd2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $102b5b86a6cf8dd2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $102b5b86a6cf8dd2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $102b5b86a6cf8dd2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $102b5b86a6cf8dd2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $102b5b86a6cf8dd2$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

if (null) null.accept("../SharedCss/alert.css", function() {
    (parcelRequire("jbsrN"));
});

(parcelRequire("8vghX")).config();
function $102b5b86a6cf8dd2$var$ChangePassword() {
    var cognitoUser = (0, $dwN01.getAuthenticatedUser)();
    var userData = (0, $dwN01.getAuthenticatedUserData)();
    var _useState = (0, $102b5b86a6cf8dd2$var$_react.useState)(''), _useState2 = $102b5b86a6cf8dd2$var$_slicedToArray(_useState, 2), alertType = _useState2[0], setAlertType = _useState2[1];
    var _useState3 = (0, $102b5b86a6cf8dd2$var$_react.useState)(''), _useState4 = $102b5b86a6cf8dd2$var$_slicedToArray(_useState3, 2), errorMessage = _useState4[0], setErrorMessage = _useState4[1];
    var _useState5 = (0, $102b5b86a6cf8dd2$var$_react.useState)(''), _useState6 = $102b5b86a6cf8dd2$var$_slicedToArray(_useState5, 2), password = _useState6[0], setPassword = _useState6[1];
    var _useState7 = (0, $102b5b86a6cf8dd2$var$_react.useState)(''), _useState8 = $102b5b86a6cf8dd2$var$_slicedToArray(_useState7, 2), oldPassword = _useState8[0], setOldPassword = _useState8[1];
    var _useState9 = (0, $102b5b86a6cf8dd2$var$_react.useState)(''), _useState10 = $102b5b86a6cf8dd2$var$_slicedToArray(_useState9, 2), confirmation = _useState10[0], setConfirmation = _useState10[1];
    var loadingRef = (0, $102b5b86a6cf8dd2$var$_react.useRef)(null);
    var userId = userData.getAttr('custom:bl_id');
    (0, $lj4el.trackPendo)('Visit Change Password', {
        userId: userId
    });
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = $102b5b86a6cf8dd2$var$_asyncToGenerator(/*#__PURE__*/ $102b5b86a6cf8dd2$var$_regeneratorRuntime().mark(function _callee(e) {
            return $102b5b86a6cf8dd2$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        $102b5b86a6cf8dd2$var$_Logger["default"].start('Update Password');
                        setAlertType('');
                        e.preventDefault();
                        if (!(password !== confirmation)) {
                            _context.next = 7;
                            break;
                        }
                        setAlertType($102b5b86a6cf8dd2$var$_AlertTypes["default"].UPDATE_FAILED);
                        setErrorMessage('Password and confirmation password do not match');
                        return _context.abrupt("return");
                    case 7:
                        loadingRef.current.continuousStart();
                        cognitoUser.changePassword(oldPassword, password, function(err, result) {
                            loadingRef.current.complete();
                            if (err) {
                                $102b5b86a6cf8dd2$var$_Logger["default"].error('Update Password', err);
                                setAlertType($102b5b86a6cf8dd2$var$_AlertTypes["default"].UPDATE_FAILED);
                                setErrorMessage(err.message || JSON.stringify(err));
                                (0, $lj4el.trackPendo)('Failed to change Password', {
                                    userId: userId,
                                    error: err.message
                                });
                            } else {
                                $102b5b86a6cf8dd2$var$_Logger["default"].done('Update Password');
                                setAlertType($102b5b86a6cf8dd2$var$_AlertTypes["default"].UPDATE_SUCCESSFULLY);
                                (0, $lj4el.trackPendo)('Changed password');
                            }
                        });
                    case 9:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderAlert = function renderAlert() {
        if (alertType === $102b5b86a6cf8dd2$var$_AlertTypes["default"].UPDATE_FAILED) return /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
            className: [
                $102b5b86a6cf8dd2$var$alertStyles.error,
                $102b5b86a6cf8dd2$var$alertStyles.render_with_menu,
                $102b5b86a6cf8dd2$var$alertStyles.alert
            ].join(' ')
        }, errorMessage);
        else if (alertType === $102b5b86a6cf8dd2$var$_AlertTypes["default"].UPDATE_SUCCESSFULLY) return /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
            className: [
                $102b5b86a6cf8dd2$var$alertStyles.success,
                $102b5b86a6cf8dd2$var$alertStyles.render_with_menu,
                $102b5b86a6cf8dd2$var$alertStyles.alert
            ].join(' ')
        }, "Change password successfully.");
    };
    return /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
        className: $102b5b86a6cf8dd2$var$styles.container
    }, renderAlert(), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement($102b5b86a6cf8dd2$var$_reactTopLoadingBar["default"], {
        color: "#f11946",
        ref: loadingRef
    }), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement($102b5b86a6cf8dd2$var$_Menu["default"], {
        highlighted: "change_password"
    }), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", null, /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
        className: $102b5b86a6cf8dd2$var$styles.header
    }, /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
        className: $102b5b86a6cf8dd2$var$styles.logo
    }, /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("h1", null, "Blueleaf")), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
        className: $102b5b86a6cf8dd2$var$styles.header_text
    }, /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("h2", null, "Change Your Password"))), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
        className: $102b5b86a6cf8dd2$var$styles.form_container
    }, /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("form", {
        id: "new-password-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
        className: $102b5b86a6cf8dd2$var$styles.fieldset
    }, /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("label", {
        className: $102b5b86a6cf8dd2$var$styles.label
    }, "Old Password"), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("input", {
        className: $102b5b86a6cf8dd2$var$styles.input_field,
        id: "old-password",
        type: "password",
        value: oldPassword,
        onChange: function onChange(e) {
            return setOldPassword(e.target.value);
        }
    })), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
        className: $102b5b86a6cf8dd2$var$styles.fieldset
    }, /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("label", {
        className: $102b5b86a6cf8dd2$var$styles.label
    }, "New Password"), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("input", {
        className: $102b5b86a6cf8dd2$var$styles.input_field,
        id: "password",
        type: "password",
        value: password,
        onChange: function onChange(e) {
            return setPassword(e.target.value);
        }
    })), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("div", {
        className: $102b5b86a6cf8dd2$var$styles.fieldset
    }, /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("label", {
        className: $102b5b86a6cf8dd2$var$styles.label
    }, "Confirm New Password"), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("input", {
        className: $102b5b86a6cf8dd2$var$styles.input_field,
        id: "password-confirmation",
        type: "password",
        value: confirmation,
        onChange: function onChange(e) {
            return setConfirmation(e.target.value);
        }
    })), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement("input", {
        id: "submit-btn",
        className: $102b5b86a6cf8dd2$var$styles.submit_btn,
        type: "submit",
        value: "Save"
    }))), /*#__PURE__*/ $102b5b86a6cf8dd2$var$_react["default"].createElement($102b5b86a6cf8dd2$var$_Footer["default"], null)));
}

});

parcelRegister("efVXx", function(module, exports) {
"use strict";
function $a60f6ce815e2a147$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a60f6ce815e2a147$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a60f6ce815e2a147$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a60f6ce815e2a147$var$UpdateEmail;

var $a60f6ce815e2a147$var$_react = $a60f6ce815e2a147$var$_interopRequireWildcard((parcelRequire("acw62")));

var $a60f6ce815e2a147$var$alertStyles = $a60f6ce815e2a147$var$_interopRequireWildcard((parcelRequire("jbsrN")));

var $a60f6ce815e2a147$var$styles = $a60f6ce815e2a147$var$_interopRequireWildcard((parcelRequire("kMVI2")));

var $dwN01 = parcelRequire("dwN01");

var $a60f6ce815e2a147$var$_MessageBus = $a60f6ce815e2a147$var$_interopRequireDefault((parcelRequire("i9Koa")));

var $a60f6ce815e2a147$var$_Flash = $a60f6ce815e2a147$var$_interopRequireDefault((parcelRequire("2gSw0")));

var $a60f6ce815e2a147$var$_Menu = $a60f6ce815e2a147$var$_interopRequireDefault((parcelRequire("9E8aK")));

var $a60f6ce815e2a147$var$_Logger = $a60f6ce815e2a147$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $a60f6ce815e2a147$var$_AlertTypes = $a60f6ce815e2a147$var$_interopRequireDefault((parcelRequire("5LA7J")));

var $a60f6ce815e2a147$var$_Footer = $a60f6ce815e2a147$var$_interopRequireDefault((parcelRequire("8ALkM")));

var $a60f6ce815e2a147$var$_reactTopLoadingBar = $a60f6ce815e2a147$var$_interopRequireDefault((parcelRequire("1KSzM")));

var $lj4el = parcelRequire("lj4el");
function $a60f6ce815e2a147$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $a60f6ce815e2a147$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a60f6ce815e2a147$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a60f6ce815e2a147$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $a60f6ce815e2a147$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $a60f6ce815e2a147$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a60f6ce815e2a147$var$_slicedToArray(r, e) {
    return $a60f6ce815e2a147$var$_arrayWithHoles(r) || $a60f6ce815e2a147$var$_iterableToArrayLimit(r, e) || $a60f6ce815e2a147$var$_unsupportedIterableToArray(r, e) || $a60f6ce815e2a147$var$_nonIterableRest();
}
function $a60f6ce815e2a147$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a60f6ce815e2a147$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a60f6ce815e2a147$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a60f6ce815e2a147$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a60f6ce815e2a147$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a60f6ce815e2a147$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a60f6ce815e2a147$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

if (null) null.accept("../SharedCss/alert.css", function() {
    (parcelRequire("jbsrN"));
});

(parcelRequire("8vghX")).config();
function $a60f6ce815e2a147$var$UpdateEmail(props) {
    var CognitoIdentityLib = props.CognitoIdentityLib;
    var cognitoUser = (0, $dwN01.getAuthenticatedUser)();
    var userData = (0, $dwN01.getAuthenticatedUserData)();
    var email = userData.getAttr('email');
    var _useState = (0, $a60f6ce815e2a147$var$_react.useState)(''), _useState2 = $a60f6ce815e2a147$var$_slicedToArray(_useState, 2), alertType = _useState2[0], setAlertType = _useState2[1];
    var _useState3 = (0, $a60f6ce815e2a147$var$_react.useState)(''), _useState4 = $a60f6ce815e2a147$var$_slicedToArray(_useState3, 2), errorMessage = _useState4[0], setErrorMessage = _useState4[1];
    var _useState5 = (0, $a60f6ce815e2a147$var$_react.useState)(email), _useState6 = $a60f6ce815e2a147$var$_slicedToArray(_useState5, 2), newEmail = _useState6[0], setNewEmail = _useState6[1];
    var _useState7 = (0, $a60f6ce815e2a147$var$_react.useState)(''), _useState8 = $a60f6ce815e2a147$var$_slicedToArray(_useState7, 2), password = _useState8[0], setPassword = _useState8[1];
    var _useState9 = (0, $a60f6ce815e2a147$var$_react.useState)(''), _useState10 = $a60f6ce815e2a147$var$_slicedToArray(_useState9, 2), confirmation = _useState10[0], setConfirmation = _useState10[1];
    var loadingRef = (0, $a60f6ce815e2a147$var$_react.useRef)(null);
    var userId = userData.getAttr('custom:bl_id');
    var userPool = new CognitoIdentityLib.CognitoUserPool({
        UserPoolId: "us-east-1_dghkmntO0",
        ClientId: "745dij271n5sgodrapt1ofef22"
    });
    (0, $lj4el.trackPendo)('Visit Update Email', {
        userId: userId
    });
    var constructAttrs = function constructAttrs() {
        return [
            new CognitoIdentityLib.CognitoUserAttribute({
                Name: 'nickname',
                Value: userData.getAttr('nickname')
            }),
            new CognitoIdentityLib.CognitoUserAttribute({
                Name: 'phone_number',
                Value: userData.getAttr('phone_number')
            }),
            new CognitoIdentityLib.CognitoUserAttribute({
                Name: 'given_name',
                Value: userData.getAttr('given_name')
            }),
            new CognitoIdentityLib.CognitoUserAttribute({
                Name: 'family_name',
                Value: userData.getAttr('family_name')
            }),
            new CognitoIdentityLib.CognitoUserAttribute({
                Name: 'custom:bl_id',
                Value: userData.getAttr('custom:bl_id')
            }),
            new CognitoIdentityLib.CognitoUserAttribute({
                Name: 'custom:chargebee_id',
                Value: userData.getAttr('custom:chargebee_id')
            })
        ];
    };
    var signUpUserWithNewEmail = function signUpUserWithNewEmail() {
        $a60f6ce815e2a147$var$_Logger["default"].start('Update Email', {
            newEmail: newEmail,
            oldEmail: email
        });
        var blId = userData.getAttr('custom:bl_id');
        $a60f6ce815e2a147$var$_Logger["default"].start('Sign up new user', {
            newEmail: newEmail
        });
        userPool.signUp(newEmail, password, constructAttrs(), null, function(err, user) {
            if (err) {
                setAlertType($a60f6ce815e2a147$var$_AlertTypes["default"].UPDATE_FAILED);
                setErrorMessage(err.message || JSON.stringify(err));
                return;
            }
            $a60f6ce815e2a147$var$_Logger["default"].done('Sign up new user', {
                newEmail: newEmail
            });
            $a60f6ce815e2a147$var$_MessageBus["default"].emitUserAttrsChange({
                username: user.userSub,
                bl_id: blId
            });
            $a60f6ce815e2a147$var$_Logger["default"].start('Delete old user', {
                oldEmail: email
            });
            cognitoUser.deleteUser(function(err) {
                loadingRef.current.complete();
                if (err) {
                    setAlertType($a60f6ce815e2a147$var$_AlertTypes["default"].UPDATE_FAILED);
                    setErrorMessage(err.message || JSON.stringify(err));
                    return;
                }
                $a60f6ce815e2a147$var$_Logger["default"].done('Delete old user', {
                    oldEmail: email
                });
                $a60f6ce815e2a147$var$_Flash["default"].setMessage('Update email successfully, please check your email and click the confirmation link');
                (0, $lj4el.trackPendo)('Updated email', {
                    userId: userId
                });
                (0, $dwN01.signOut)();
            });
        });
    };
    var handleSubmit = function handleSubmit(e) {
        e.preventDefault();
        if (password !== confirmation) {
            setAlertType($a60f6ce815e2a147$var$_AlertTypes["default"].UPDATE_FAILED);
            setErrorMessage('Password and confirmation password do not match');
            return;
        }
        loadingRef.current.continuousStart();
        var authenticationData = {
            Username: email,
            Password: password
        };
        var authenticationDetails = new CognitoIdentityLib.AuthenticationDetails(authenticationData);
        $a60f6ce815e2a147$var$_Logger["default"].start('Authenticate user', {
            email: email
        });
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function onSuccess() {
                $a60f6ce815e2a147$var$_Logger["default"].done('Authenticate user', {
                    email: email
                });
                signUpUserWithNewEmail();
            },
            onFailure: function onFailure(err) {
                loadingRef.current.complete();
                $a60f6ce815e2a147$var$_Logger["default"].error('Authenticate user', err);
                setAlertType($a60f6ce815e2a147$var$_AlertTypes["default"].UPDATE_FAILED);
                setErrorMessage(err.message || JSON.stringify(err));
                (0, $lj4el.trackPendo)('Failed to update email', {
                    userId: userId,
                    error: err.message
                });
            },
            mfaRequired: function mfaRequired() {
                $a60f6ce815e2a147$var$_Logger["default"].done('Authenticate user (MFA, not important)', {
                    email: email
                });
                signUpUserWithNewEmail();
            }
        });
    };
    var renderAlert = function renderAlert() {
        if (alertType === $a60f6ce815e2a147$var$_AlertTypes["default"].UPDATE_FAILED) return /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
            className: [
                $a60f6ce815e2a147$var$alertStyles.error,
                $a60f6ce815e2a147$var$alertStyles.render_with_menu,
                $a60f6ce815e2a147$var$alertStyles.alert
            ].join(' ')
        }, errorMessage);
        else if (alertType === $a60f6ce815e2a147$var$_AlertTypes["default"].UPDATE_SUCCESSFULLY) return /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
            className: [
                $a60f6ce815e2a147$var$alertStyles.success,
                $a60f6ce815e2a147$var$alertStyles.render_with_menu,
                $a60f6ce815e2a147$var$alertStyles.alert
            ].join(' ')
        }, "Update email successfully.");
    };
    return /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
        className: $a60f6ce815e2a147$var$styles.container
    }, renderAlert(), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement($a60f6ce815e2a147$var$_reactTopLoadingBar["default"], {
        color: "#f11946",
        ref: loadingRef
    }), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement($a60f6ce815e2a147$var$_Menu["default"], {
        highlighted: "update_email"
    }), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", null, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
        className: $a60f6ce815e2a147$var$styles.header
    }, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
        className: $a60f6ce815e2a147$var$styles.logo
    }, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("h1", null, "Blueleaf")), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
        className: $a60f6ce815e2a147$var$styles.header_text
    }, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("h2", null, "Email Settings"))), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
        className: $a60f6ce815e2a147$var$styles.form_container
    }, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("form", {
        id: "new-password-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
        className: $a60f6ce815e2a147$var$styles.fieldset
    }, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("label", {
        className: $a60f6ce815e2a147$var$styles.label
    }, "Email"), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("input", {
        className: $a60f6ce815e2a147$var$styles.input_field,
        id: "email",
        type: "email",
        value: newEmail,
        onChange: function onChange(e) {
            return setNewEmail(e.target.value);
        }
    })), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
        className: $a60f6ce815e2a147$var$styles.fieldset
    }, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("h3", null, "Please enter your password to confirm this change")), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
        className: $a60f6ce815e2a147$var$styles.fieldset
    }, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("label", {
        className: $a60f6ce815e2a147$var$styles.label
    }, "Password"), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("input", {
        className: $a60f6ce815e2a147$var$styles.input_field,
        id: "password",
        type: "password",
        value: password,
        onChange: function onChange(e) {
            return setPassword(e.target.value);
        }
    })), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("div", {
        className: $a60f6ce815e2a147$var$styles.fieldset
    }, /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("label", {
        className: $a60f6ce815e2a147$var$styles.label
    }, "Password Confirmation"), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("input", {
        className: $a60f6ce815e2a147$var$styles.input_field,
        id: "password-confirmation",
        type: "password",
        value: confirmation,
        onChange: function onChange(e) {
            return setConfirmation(e.target.value);
        }
    })), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement("input", {
        id: "submit-btn",
        className: $a60f6ce815e2a147$var$styles.submit_btn,
        type: "submit",
        value: "Save"
    }))), /*#__PURE__*/ $a60f6ce815e2a147$var$_react["default"].createElement($a60f6ce815e2a147$var$_Footer["default"], null)));
}

});

parcelRegister("fZeo5", function(module, exports) {
"use strict";
function $ba37b6959be94f8c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ba37b6959be94f8c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ba37b6959be94f8c$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $ba37b6959be94f8c$var$ConfirmSignUp;

var $ba37b6959be94f8c$var$_react = $ba37b6959be94f8c$var$_interopRequireWildcard((parcelRequire("acw62")));



var $kfZjc = parcelRequire("kfZjc");

var $ba37b6959be94f8c$var$_AlertTypes = $ba37b6959be94f8c$var$_interopRequireDefault((parcelRequire("5LA7J")));

var $ba37b6959be94f8c$var$_Flash = $ba37b6959be94f8c$var$_interopRequireDefault((parcelRequire("2gSw0")));
function $ba37b6959be94f8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $ba37b6959be94f8c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ba37b6959be94f8c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ba37b6959be94f8c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $ba37b6959be94f8c$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $ba37b6959be94f8c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ba37b6959be94f8c$var$_slicedToArray(r, e) {
    return $ba37b6959be94f8c$var$_arrayWithHoles(r) || $ba37b6959be94f8c$var$_iterableToArrayLimit(r, e) || $ba37b6959be94f8c$var$_unsupportedIterableToArray(r, e) || $ba37b6959be94f8c$var$_nonIterableRest();
}
function $ba37b6959be94f8c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ba37b6959be94f8c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ba37b6959be94f8c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ba37b6959be94f8c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ba37b6959be94f8c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ba37b6959be94f8c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ba37b6959be94f8c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

if (null) null.accept("../SharedCss/alert.css", function() {
    (parcelRequire("jbsrN"));
});

(parcelRequire("8vghX")).config();
function $ba37b6959be94f8c$var$ConfirmSignUp(props) {
    var CognitoIdentityLib = props.CognitoIdentityLib;
    var _useParams = (0, $kfZjc.useParams)(), confirmationCode = _useParams.confirmationCode, username = _useParams.username;
    var _useState = (0, $ba37b6959be94f8c$var$_react.useState)(''), _useState2 = $ba37b6959be94f8c$var$_slicedToArray(_useState, 2), alertType = _useState2[0], setAlertType = _useState2[1];
    var _useState3 = (0, $ba37b6959be94f8c$var$_react.useState)(''), _useState4 = $ba37b6959be94f8c$var$_slicedToArray(_useState3, 2), errorMessage = _useState4[0], setErrorMessage = _useState4[1];
    var userPool = new CognitoIdentityLib.CognitoUserPool({
        UserPoolId: "us-east-1_dghkmntO0",
        ClientId: "745dij271n5sgodrapt1ofef22"
    });
    var userData = {
        Username: username,
        Pool: userPool
    };
    var cognitoUser = new CognitoIdentityLib.CognitoUser(userData);
    cognitoUser.confirmRegistration(confirmationCode, true, function(err, result) {
        if (err) {
            setAlertType($ba37b6959be94f8c$var$_AlertTypes["default"].UPDATE_FAILED);
            setErrorMessage(err.message || JSON.stringify(err));
        } else {
            $ba37b6959be94f8c$var$_Flash["default"].setMessage('User confirmed, you can sign in now.');
            setAlertType($ba37b6959be94f8c$var$_AlertTypes["default"].UPDATE_SUCCESSFULLY);
        }
    });
    if (alertType === $ba37b6959be94f8c$var$_AlertTypes["default"].UPDATE_SUCCESSFULLY) return /*#__PURE__*/ $ba37b6959be94f8c$var$_react["default"].createElement($kfZjc.Redirect, {
        id: "login-redirect",
        to: "/"
    });
    if (alertType === $ba37b6959be94f8c$var$_AlertTypes["default"].UPDATE_FAILED) return /*#__PURE__*/ $ba37b6959be94f8c$var$_react["default"].createElement("div", {
        className: "js-SharedCss-__alert__alert__2vPPN js-SharedCss-__alert__error__214sD"
    }, errorMessage);
    return /*#__PURE__*/ $ba37b6959be94f8c$var$_react["default"].createElement("div", null, "Confirming user...");
}

});

parcelRegister("59yaR", function(module, exports) {
"use strict";
function $3c084d50b836325f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3c084d50b836325f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3c084d50b836325f$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $3c084d50b836325f$var$ResetPasswordForm;

var $3c084d50b836325f$var$_react = $3c084d50b836325f$var$_interopRequireWildcard((parcelRequire("acw62")));

var $3c084d50b836325f$var$alertStyles = $3c084d50b836325f$var$_interopRequireWildcard((parcelRequire("jbsrN")));

var $3c084d50b836325f$var$styles = $3c084d50b836325f$var$_interopRequireWildcard((parcelRequire("kMVI2")));

var $4fGPb = parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");

var $3c084d50b836325f$var$_Flash = $3c084d50b836325f$var$_interopRequireDefault((parcelRequire("2gSw0")));

var $3c084d50b836325f$var$_Logger = $3c084d50b836325f$var$_interopRequireDefault((parcelRequire("2ChR8")));

var $3c084d50b836325f$var$_AlertTypes = $3c084d50b836325f$var$_interopRequireDefault((parcelRequire("5LA7J")));

var $3c084d50b836325f$var$_Footer = $3c084d50b836325f$var$_interopRequireDefault((parcelRequire("8ALkM")));

var $3c084d50b836325f$var$_reactTopLoadingBar = $3c084d50b836325f$var$_interopRequireDefault((parcelRequire("1KSzM")));
function $3c084d50b836325f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $3c084d50b836325f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3c084d50b836325f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3c084d50b836325f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $3c084d50b836325f$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $3c084d50b836325f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3c084d50b836325f$var$_slicedToArray(r, e) {
    return $3c084d50b836325f$var$_arrayWithHoles(r) || $3c084d50b836325f$var$_iterableToArrayLimit(r, e) || $3c084d50b836325f$var$_unsupportedIterableToArray(r, e) || $3c084d50b836325f$var$_nonIterableRest();
}
function $3c084d50b836325f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3c084d50b836325f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3c084d50b836325f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3c084d50b836325f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3c084d50b836325f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3c084d50b836325f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3c084d50b836325f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

if (null) null.accept("../SharedCss/form.css", function() {
    (parcelRequire("kMVI2"));
});

if (null) null.accept("../SharedCss/alert.css", function() {
    (parcelRequire("jbsrN"));
});

(parcelRequire("8vghX")).config();
function $3c084d50b836325f$var$ResetPasswordForm(props) {
    var _useParams = (0, $kfZjc.useParams)(), code = _useParams.code, username = _useParams.username;
    var CognitoIdentityLib = props.CognitoIdentityLib;
    var _useState = (0, $3c084d50b836325f$var$_react.useState)(''), _useState2 = $3c084d50b836325f$var$_slicedToArray(_useState, 2), password = _useState2[0], setPassword = _useState2[1];
    var _useState3 = (0, $3c084d50b836325f$var$_react.useState)(''), _useState4 = $3c084d50b836325f$var$_slicedToArray(_useState3, 2), confirmation = _useState4[0], setConfirmation = _useState4[1];
    var _useState5 = (0, $3c084d50b836325f$var$_react.useState)(''), _useState6 = $3c084d50b836325f$var$_slicedToArray(_useState5, 2), alertType = _useState6[0], setAlertType = _useState6[1];
    var _useState7 = (0, $3c084d50b836325f$var$_react.useState)(''), _useState8 = $3c084d50b836325f$var$_slicedToArray(_useState7, 2), errorMessage = _useState8[0], setErrorMessage = _useState8[1];
    var _useState9 = (0, $3c084d50b836325f$var$_react.useState)(false), _useState10 = $3c084d50b836325f$var$_slicedToArray(_useState9, 2), redirect = _useState10[0], setRedirect = _useState10[1];
    var loadingRef = (0, $3c084d50b836325f$var$_react.useRef)(null);
    var handleSubmit = function handleSubmit(e) {
        $3c084d50b836325f$var$_Logger["default"].start('Submit Reset Password', {
            code: code,
            username: username
        });
        setAlertType('');
        loadingRef.current.continuousStart();
        e.preventDefault();
        var userPool = new CognitoIdentityLib.CognitoUserPool({
            UserPoolId: "us-east-1_dghkmntO0",
            ClientId: "745dij271n5sgodrapt1ofef22"
        });
        var userData = {
            Username: username,
            Pool: userPool
        };
        var cognitoUser = new CognitoIdentityLib.CognitoUser(userData);
        if (password !== confirmation) {
            setAlertType($3c084d50b836325f$var$_AlertTypes["default"].UPDATE_FAILED);
            setErrorMessage('Password and confirmation password do not match');
            return;
        }
        cognitoUser.confirmPassword(code, password, {
            onSuccess: function onSuccess(result) {
                loadingRef.current.complete();
                $3c084d50b836325f$var$_Logger["default"].done('Submit Reset Password', {
                    code: code,
                    username: username
                });
                $3c084d50b836325f$var$_Flash["default"].setMessage('Your password has been reset, please sign in with the new password');
                setRedirect(true);
            },
            onFailure: function onFailure(err) {
                loadingRef.current.complete();
                $3c084d50b836325f$var$_Logger["default"].error('Submit Reset Password', err);
                setAlertType($3c084d50b836325f$var$_AlertTypes["default"].UPDATE_FAILED);
                setErrorMessage(err.message);
            }
        });
    };
    var renderAlert = function renderAlert() {
        if (alertType === $3c084d50b836325f$var$_AlertTypes["default"].UPDATE_FAILED) return /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("div", {
            className: [
                $3c084d50b836325f$var$alertStyles.alert,
                $3c084d50b836325f$var$alertStyles.error
            ].join(' ')
        }, errorMessage);
    };
    if (redirect) return /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement($kfZjc.Redirect, {
        id: "login-redirect",
        to: "/"
    });
    return /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("div", {
        className: $3c084d50b836325f$var$styles.container
    }, renderAlert(), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement($3c084d50b836325f$var$_reactTopLoadingBar["default"], {
        color: "#f11946",
        ref: loadingRef
    }), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("div", {
        className: $3c084d50b836325f$var$styles.header
    }, /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("div", {
        className: $3c084d50b836325f$var$styles.logo
    }, /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("h1", null, "Blueleaf")), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("div", {
        className: $3c084d50b836325f$var$styles.header_text
    }, /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("h2", null, "Reset your password"))), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("div", {
        className: $3c084d50b836325f$var$styles.form_container
    }, /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("form", {
        id: "reset-password-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("div", {
        className: $3c084d50b836325f$var$styles.fieldset
    }, /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("label", {
        className: $3c084d50b836325f$var$styles.label
    }, "Choose a new password"), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("input", {
        className: $3c084d50b836325f$var$styles.input_field,
        type: "password",
        value: password,
        onChange: function onChange(e) {
            return setPassword(e.target.value);
        }
    })), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("div", {
        className: $3c084d50b836325f$var$styles.fieldset
    }, /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("label", {
        className: $3c084d50b836325f$var$styles.label
    }, "Confirm your new password"), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("input", {
        className: $3c084d50b836325f$var$styles.input_field,
        type: "password",
        value: confirmation,
        onChange: function onChange(e) {
            return setConfirmation(e.target.value);
        }
    })), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement("input", {
        id: "submit-btn",
        className: $3c084d50b836325f$var$styles.submit_btn,
        type: "submit",
        value: "Reset Password"
    }), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement($4fGPb.Link, {
        id: "sign-in-btn",
        className: $3c084d50b836325f$var$styles.link,
        to: "/"
    }, "Back to sign in"))), /*#__PURE__*/ $3c084d50b836325f$var$_react["default"].createElement($3c084d50b836325f$var$_Footer["default"], null));
}

});

parcelRegister("l7ps3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f5fdfe92b8e5cd65$var$PrivateRoute;

var $f5fdfe92b8e5cd65$var$_react = $f5fdfe92b8e5cd65$var$_interopRequireDefault((parcelRequire("acw62")));

var $kfZjc = parcelRequire("kfZjc");

var $dwN01 = parcelRequire("dwN01");
function $f5fdfe92b8e5cd65$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $f5fdfe92b8e5cd65$var$PrivateRoute(props) {
    if ((0, $dwN01.hasTokens)()) return /*#__PURE__*/ $f5fdfe92b8e5cd65$var$_react["default"].createElement($kfZjc.Route, props, props.children);
    else return /*#__PURE__*/ $f5fdfe92b8e5cd65$var$_react["default"].createElement($kfZjc.Redirect, {
        to: "/"
    });
}

});

parcelRegister("cSHHf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $960c6c62b3221bf9$var$PublicRoute;

var $960c6c62b3221bf9$var$_react = $960c6c62b3221bf9$var$_interopRequireDefault((parcelRequire("acw62")));

var $kfZjc = parcelRequire("kfZjc");

var $dwN01 = parcelRequire("dwN01");
function $960c6c62b3221bf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $960c6c62b3221bf9$var$PublicRoute(props) {
    if ((0, $dwN01.hasTokens)()) return /*#__PURE__*/ $960c6c62b3221bf9$var$_react["default"].createElement($kfZjc.Redirect, {
        to: "/mfa_settings"
    });
    else return /*#__PURE__*/ $960c6c62b3221bf9$var$_react["default"].createElement($kfZjc.Route, props, props.children);
}

});

parcelRegister("fsNUu", function(module, exports) {
"use strict";
function $b4202fa862c24867$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b4202fa862c24867$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b4202fa862c24867$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b4202fa862c24867$var$RefreshToken;

var $b4202fa862c24867$var$_react = $b4202fa862c24867$var$_interopRequireWildcard((parcelRequire("acw62")));

var $dwN01 = parcelRequire("dwN01");

var $g3rxA = parcelRequire("g3rxA");

var $b4202fa862c24867$var$_Logger = $b4202fa862c24867$var$_interopRequireDefault((parcelRequire("2ChR8")));
function $b4202fa862c24867$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b4202fa862c24867$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b4202fa862c24867$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $b4202fa862c24867$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $b4202fa862c24867$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $b4202fa862c24867$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}

(parcelRequire("8vghX")).config();
function $b4202fa862c24867$var$RefreshToken(props) {
    var params = new URLSearchParams(window.location.search);
    var returnToUrl = params.get('return_to');
    var cognitoUser = (0, $dwN01.getAuthenticatedUser)();
    (0, $b4202fa862c24867$var$_react.useEffect)(function() {
        cognitoUser.getSession(function(sessionErr, cognitoTokens) {
            if (sessionErr) {
                $b4202fa862c24867$var$_Logger["default"].error('Get session failed', sessionErr);
                (0, $dwN01.signOut)();
            } else {
                var refreshToken = cognitoTokens.getRefreshToken();
                cognitoUser.refreshSession(refreshToken, function(err, newCognitoTokens) {
                    if (err) {
                        $b4202fa862c24867$var$_Logger["default"].error('Refresh session failed', err);
                        (0, $dwN01.signOut)();
                    } else {
                        (0, $dwN01.setTokens)(newCognitoTokens);
                        // We need to inform the backend about the tokens change so it can update the
                        // the cookies with the new tokens. Currently this backend is Mono but later on
                        // we will use a dedicated backend for managing these tokens
                        //
                        // After signin, instead of redirecting to Mono, the app will redirect directly
                        // to the url // specified in "?return_to" parameter. This avoid circulating
                        // redirection // from A -> Mono -> B -> Mono -> back to A
                        (0, $g3rxA.signInExternalHostWithCustomRedirect)(returnToUrl);
                    }
                });
            }
        });
    }, []);
    return /*#__PURE__*/ $b4202fa862c24867$var$_react["default"].createElement("div", null, " ");
}

});

parcelRegister("epDvA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a7e20c0ebf2394ea$var$SignOut;

var $a7e20c0ebf2394ea$var$_react = $a7e20c0ebf2394ea$var$_interopRequireDefault((parcelRequire("acw62")));

var $dwN01 = parcelRequire("dwN01");
function $a7e20c0ebf2394ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $a7e20c0ebf2394ea$var$SignOut() {
    (0, $dwN01.signOut)();
    return /*#__PURE__*/ $a7e20c0ebf2394ea$var$_react["default"].createElement("div", null, "Loading");
}

});

"use strict";
function $e5e6023659c13c1d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e5e6023659c13c1d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e5e6023659c13c1d$var$_typeof(o);
}
var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
                // Note: ["return"] must be used for ES3 parsing compatibility.
                if (delegate.iterator["return"]) {
                    // If the delegate iterator has a return method, give it a
                    // chance to clean up.
                    context.method = "return";
                    context.arg = undefined;
                    maybeInvokeDelegate(delegate, context);
                    if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                }
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}



var $e5e6023659c13c1d$var$_react = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("acw62")));
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));



var $e5e6023659c13c1d$var$_Login = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("f736Y")));

var $e5e6023659c13c1d$var$_ForgotPassword = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("2fnLT")));

var $e5e6023659c13c1d$var$_MfaSettings = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("etINR")));

var $e5e6023659c13c1d$var$_ChangePassword = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("1o4hO")));

var $e5e6023659c13c1d$var$_UpdateEmail = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("efVXx")));

var $e5e6023659c13c1d$var$_ConfirmSignUp = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("fZeo5")));

var $e5e6023659c13c1d$var$_ResetPassword = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("59yaR")));

var $e5e6023659c13c1d$var$_PrivateRoute = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("l7ps3")));

var $e5e6023659c13c1d$var$_PublicRoute = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("cSHHf")));

var $e5e6023659c13c1d$var$_RefreshToken = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("fsNUu")));

var $e5e6023659c13c1d$var$_SignOut = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("epDvA")));

var $4fGPb = parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");

var $e5e6023659c13c1d$var$AmazonCognitoIdentity = $e5e6023659c13c1d$var$_interopRequireWildcard((parcelRequire("Ym30y")));

var $dwN01 = parcelRequire("dwN01");

var $g3rxA = parcelRequire("g3rxA");

var $1XggU = parcelRequire("1XggU");

var $e5e6023659c13c1d$var$_pendo = $e5e6023659c13c1d$var$_interopRequireDefault((parcelRequire("lj4el")));
function $e5e6023659c13c1d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e5e6023659c13c1d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e5e6023659c13c1d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $e5e6023659c13c1d$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $e5e6023659c13c1d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e5e6023659c13c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
(0, $1XggU.setAdvisorCustomLogin)();
(0, $g3rxA.setExternalHost)();
function $e5e6023659c13c1d$var$App() {
    return /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($4fGPb.BrowserRouter, null, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($kfZjc.Switch, null, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_PublicRoute["default"], {
        path: "/forgot_password"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_ForgotPassword["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_PublicRoute["default"], {
        path: "/password_recoveries/new"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_ForgotPassword["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_PrivateRoute["default"], {
        path: "/mfa_settings"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_MfaSettings["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_PrivateRoute["default"], {
        path: "/change_password"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_ChangePassword["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_PrivateRoute["default"], {
        path: "/update_email"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_UpdateEmail["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_PrivateRoute["default"], {
        path: "/refresh_token"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_RefreshToken["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($kfZjc.Route, {
        path: "/confirm_sign_up/:username/:confirmationCode"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_ConfirmSignUp["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($kfZjc.Route, {
        path: "/reset_password/:username/:code"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_ResetPassword["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($kfZjc.Route, {
        path: "/sign_out"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_SignOut["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_PublicRoute["default"], {
        path: "/advisor/:advisorId"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_Login["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    })), /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_PublicRoute["default"], {
        path: "/"
    }, /*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$_Login["default"], {
        CognitoIdentityLib: $e5e6023659c13c1d$var$AmazonCognitoIdentity
    }))));
}
if ((0, $dwN01.hasTokens)()) (0, $dwN01.authenticateCognito)(function() {
    (0, $e5e6023659c13c1d$var$_pendo["default"])();
    (0, $11492dca620dcaa5$exports.render)(/*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$App, null), document.getElementById('main'));
});
else (0, $11492dca620dcaa5$exports.render)(/*#__PURE__*/ $e5e6023659c13c1d$var$_react["default"].createElement($e5e6023659c13c1d$var$App, null), document.getElementById('main'));


//# sourceMappingURL=index.3fe1e667.js.map
